var im = Object.defineProperty;
var sm = (e, t, n) => t in e ? im(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ie = (e, t, n) => sm(e, typeof t != "symbol" ? t + "" : t, n);
import * as d from "react";
import K, { forwardRef as Sn, createElement as Jo, useState as dt, Component as vc, useMemo as ut, useRef as qe, useEffect as hn, useLayoutEffect as hc, useCallback as Ee, useContext as xc, createContext as cm, Fragment as Uo } from "react";
import * as wa from "react-dom";
import lm, { createPortal as um } from "react-dom";
function dm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var zn = { exports: {} }, cn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wi;
function fm() {
  if (Wi) return cn;
  Wi = 1;
  var e = K, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, c, l) {
    var u, f = {}, g = null, b = null;
    l !== void 0 && (g = "" + l), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (b = c.ref);
    for (u in c) o.call(c, u) && !a.hasOwnProperty(u) && (f[u] = c[u]);
    if (s && s.defaultProps) for (u in c = s.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: t, type: s, key: g, ref: b, props: f, _owner: r.current };
  }
  return cn.Fragment = n, cn.jsx = i, cn.jsxs = i, cn;
}
var ln = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xi;
function pm() {
  return Xi || (Xi = 1, process.env.NODE_ENV !== "production" && function() {
    var e = K, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), C = Symbol.iterator, m = "@@iterator";
    function v(A) {
      if (A === null || typeof A != "object")
        return null;
      var P = C && A[C] || A[m];
      return typeof P == "function" ? P : null;
    }
    var h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(A) {
      {
        for (var P = arguments.length, V = new Array(P > 1 ? P - 1 : 0), Y = 1; Y < P; Y++)
          V[Y - 1] = arguments[Y];
        x("error", A, V);
      }
    }
    function x(A, P, V) {
      {
        var Y = h.ReactDebugCurrentFrame, ie = Y.getStackAddendum();
        ie !== "" && (P += "%s", V = V.concat([ie]));
        var le = V.map(function(te) {
          return String(te);
        });
        le.unshift("Warning: " + P), Function.prototype.apply.call(console[A], console, le);
      }
    }
    var y = !1, w = !1, R = !1, E = !1, N = !1, _;
    _ = Symbol.for("react.module.reference");
    function D(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === o || A === a || N || A === r || A === l || A === u || E || A === b || y || w || R || typeof A == "object" && A !== null && (A.$$typeof === g || A.$$typeof === f || A.$$typeof === i || A.$$typeof === s || A.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === _ || A.getModuleId !== void 0));
    }
    function O(A, P, V) {
      var Y = A.displayName;
      if (Y)
        return Y;
      var ie = P.displayName || P.name || "";
      return ie !== "" ? V + "(" + ie + ")" : V;
    }
    function T(A) {
      return A.displayName || "Context";
    }
    function L(A) {
      if (A == null)
        return null;
      if (typeof A.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
        return A.displayName || A.name || null;
      if (typeof A == "string")
        return A;
      switch (A) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case r:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case s:
            var P = A;
            return T(P) + ".Consumer";
          case i:
            var V = A;
            return T(V._context) + ".Provider";
          case c:
            return O(A, A.render, "ForwardRef");
          case f:
            var Y = A.displayName || null;
            return Y !== null ? Y : L(A.type) || "Memo";
          case g: {
            var ie = A, le = ie._payload, te = ie._init;
            try {
              return L(te(le));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, B = 0, k, $, j, F, U, re, J;
    function Q() {
    }
    Q.__reactDisabledLog = !0;
    function ge() {
      {
        if (B === 0) {
          k = console.log, $ = console.info, j = console.warn, F = console.error, U = console.group, re = console.groupCollapsed, J = console.groupEnd;
          var A = {
            configurable: !0,
            enumerable: !0,
            value: Q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: A,
            log: A,
            warn: A,
            error: A,
            group: A,
            groupCollapsed: A,
            groupEnd: A
          });
        }
        B++;
      }
    }
    function Ce() {
      {
        if (B--, B === 0) {
          var A = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, A, {
              value: k
            }),
            info: M({}, A, {
              value: $
            }),
            warn: M({}, A, {
              value: j
            }),
            error: M({}, A, {
              value: F
            }),
            group: M({}, A, {
              value: U
            }),
            groupCollapsed: M({}, A, {
              value: re
            }),
            groupEnd: M({}, A, {
              value: J
            })
          });
        }
        B < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ue = h.ReactCurrentDispatcher, fe;
    function me(A, P, V) {
      {
        if (fe === void 0)
          try {
            throw Error();
          } catch (ie) {
            var Y = ie.stack.trim().match(/\n( *(at )?)/);
            fe = Y && Y[1] || "";
          }
        return `
` + fe + A;
      }
    }
    var pe = !1, _e;
    {
      var ct = typeof WeakMap == "function" ? WeakMap : Map;
      _e = new ct();
    }
    function W(A, P) {
      if (!A || pe)
        return "";
      {
        var V = _e.get(A);
        if (V !== void 0)
          return V;
      }
      var Y;
      pe = !0;
      var ie = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var le;
      le = ue.current, ue.current = null, ge();
      try {
        if (P) {
          var te = function() {
            throw Error();
          };
          if (Object.defineProperty(te.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(te, []);
            } catch (Te) {
              Y = Te;
            }
            Reflect.construct(A, [], te);
          } else {
            try {
              te.call();
            } catch (Te) {
              Y = Te;
            }
            A.call(te.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Te) {
            Y = Te;
          }
          A();
        }
      } catch (Te) {
        if (Te && Y && typeof Te.stack == "string") {
          for (var q = Te.stack.split(`
`), Pe = Y.stack.split(`
`), ve = q.length - 1, he = Pe.length - 1; ve >= 1 && he >= 0 && q[ve] !== Pe[he]; )
            he--;
          for (; ve >= 1 && he >= 0; ve--, he--)
            if (q[ve] !== Pe[he]) {
              if (ve !== 1 || he !== 1)
                do
                  if (ve--, he--, he < 0 || q[ve] !== Pe[he]) {
                    var We = `
` + q[ve].replace(" at new ", " at ");
                    return A.displayName && We.includes("<anonymous>") && (We = We.replace("<anonymous>", A.displayName)), typeof A == "function" && _e.set(A, We), We;
                  }
                while (ve >= 1 && he >= 0);
              break;
            }
        }
      } finally {
        pe = !1, ue.current = le, Ce(), Error.prepareStackTrace = ie;
      }
      var Ft = A ? A.displayName || A.name : "", At = Ft ? me(Ft) : "";
      return typeof A == "function" && _e.set(A, At), At;
    }
    function Ge(A, P, V) {
      return W(A, !1);
    }
    function Le(A) {
      var P = A.prototype;
      return !!(P && P.isReactComponent);
    }
    function He(A, P, V) {
      if (A == null)
        return "";
      if (typeof A == "function")
        return W(A, Le(A));
      if (typeof A == "string")
        return me(A);
      switch (A) {
        case l:
          return me("Suspense");
        case u:
          return me("SuspenseList");
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case c:
            return Ge(A.render);
          case f:
            return He(A.type, P, V);
          case g: {
            var Y = A, ie = Y._payload, le = Y._init;
            try {
              return He(le(ie), P, V);
            } catch {
            }
          }
        }
      return "";
    }
    var wt = Object.prototype.hasOwnProperty, Xn = {}, Hn = h.ReactDebugCurrentFrame;
    function lt(A) {
      if (A) {
        var P = A._owner, V = He(A.type, A._source, P ? P.type : null);
        Hn.setExtraStackFrame(V);
      } else
        Hn.setExtraStackFrame(null);
    }
    function jg(A, P, V, Y, ie) {
      {
        var le = Function.call.bind(wt);
        for (var te in A)
          if (le(A, te)) {
            var q = void 0;
            try {
              if (typeof A[te] != "function") {
                var Pe = Error((Y || "React class") + ": " + V + " type `" + te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[te] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Pe.name = "Invariant Violation", Pe;
              }
              q = A[te](P, te, Y, V, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ve) {
              q = ve;
            }
            q && !(q instanceof Error) && (lt(ie), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", V, te, typeof q), lt(null)), q instanceof Error && !(q.message in Xn) && (Xn[q.message] = !0, lt(ie), I("Failed %s type: %s", V, q.message), lt(null));
          }
      }
    }
    var Vg = Array.isArray;
    function go(A) {
      return Vg(A);
    }
    function Bg(A) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, V = P && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return V;
      }
    }
    function Lg(A) {
      try {
        return _i(A), !1;
      } catch {
        return !0;
      }
    }
    function _i(A) {
      return "" + A;
    }
    function Ti(A) {
      if (Lg(A))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Bg(A)), _i(A);
    }
    var Di = h.ReactCurrentOwner, Wg = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Mi, Fi;
    function Xg(A) {
      if (wt.call(A, "ref")) {
        var P = Object.getOwnPropertyDescriptor(A, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return A.ref !== void 0;
    }
    function Hg(A) {
      if (wt.call(A, "key")) {
        var P = Object.getOwnPropertyDescriptor(A, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return A.key !== void 0;
    }
    function zg(A, P) {
      typeof A.ref == "string" && Di.current;
    }
    function Zg(A, P) {
      {
        var V = function() {
          Mi || (Mi = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        V.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: V,
          configurable: !0
        });
      }
    }
    function $g(A, P) {
      {
        var V = function() {
          Fi || (Fi = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        V.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: V,
          configurable: !0
        });
      }
    }
    var Yg = function(A, P, V, Y, ie, le, te) {
      var q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: A,
        key: P,
        ref: V,
        props: te,
        // Record the component responsible for creating this element.
        _owner: le
      };
      return q._store = {}, Object.defineProperty(q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.defineProperty(q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ie
      }), Object.freeze && (Object.freeze(q.props), Object.freeze(q)), q;
    };
    function Jg(A, P, V, Y, ie) {
      {
        var le, te = {}, q = null, Pe = null;
        V !== void 0 && (Ti(V), q = "" + V), Hg(P) && (Ti(P.key), q = "" + P.key), Xg(P) && (Pe = P.ref, zg(P, ie));
        for (le in P)
          wt.call(P, le) && !Wg.hasOwnProperty(le) && (te[le] = P[le]);
        if (A && A.defaultProps) {
          var ve = A.defaultProps;
          for (le in ve)
            te[le] === void 0 && (te[le] = ve[le]);
        }
        if (q || Pe) {
          var he = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          q && Zg(te, he), Pe && $g(te, he);
        }
        return Yg(A, q, Pe, ie, Y, Di.current, te);
      }
    }
    var mo = h.ReactCurrentOwner, Oi = h.ReactDebugCurrentFrame;
    function Mt(A) {
      if (A) {
        var P = A._owner, V = He(A.type, A._source, P ? P.type : null);
        Oi.setExtraStackFrame(V);
      } else
        Oi.setExtraStackFrame(null);
    }
    var bo;
    bo = !1;
    function vo(A) {
      return typeof A == "object" && A !== null && A.$$typeof === t;
    }
    function Gi() {
      {
        if (mo.current) {
          var A = L(mo.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
    }
    function Ug(A) {
      return "";
    }
    var ki = {};
    function Qg(A) {
      {
        var P = Gi();
        if (!P) {
          var V = typeof A == "string" ? A : A.displayName || A.name;
          V && (P = `

Check the top-level render call using <` + V + ">.");
        }
        return P;
      }
    }
    function ji(A, P) {
      {
        if (!A._store || A._store.validated || A.key != null)
          return;
        A._store.validated = !0;
        var V = Qg(P);
        if (ki[V])
          return;
        ki[V] = !0;
        var Y = "";
        A && A._owner && A._owner !== mo.current && (Y = " It was passed a child from " + L(A._owner.type) + "."), Mt(A), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', V, Y), Mt(null);
      }
    }
    function Vi(A, P) {
      {
        if (typeof A != "object")
          return;
        if (go(A))
          for (var V = 0; V < A.length; V++) {
            var Y = A[V];
            vo(Y) && ji(Y, P);
          }
        else if (vo(A))
          A._store && (A._store.validated = !0);
        else if (A) {
          var ie = v(A);
          if (typeof ie == "function" && ie !== A.entries)
            for (var le = ie.call(A), te; !(te = le.next()).done; )
              vo(te.value) && ji(te.value, P);
        }
      }
    }
    function Kg(A) {
      {
        var P = A.type;
        if (P == null || typeof P == "string")
          return;
        var V;
        if (typeof P == "function")
          V = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === f))
          V = P.propTypes;
        else
          return;
        if (V) {
          var Y = L(P);
          jg(V, A.props, "prop", Y, A);
        } else if (P.PropTypes !== void 0 && !bo) {
          bo = !0;
          var ie = L(P);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ie || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qg(A) {
      {
        for (var P = Object.keys(A.props), V = 0; V < P.length; V++) {
          var Y = P[V];
          if (Y !== "children" && Y !== "key") {
            Mt(A), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), Mt(null);
            break;
          }
        }
        A.ref !== null && (Mt(A), I("Invalid attribute `ref` supplied to `React.Fragment`."), Mt(null));
      }
    }
    var Bi = {};
    function Li(A, P, V, Y, ie, le) {
      {
        var te = D(A);
        if (!te) {
          var q = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Pe = Ug();
          Pe ? q += Pe : q += Gi();
          var ve;
          A === null ? ve = "null" : go(A) ? ve = "array" : A !== void 0 && A.$$typeof === t ? (ve = "<" + (L(A.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : ve = typeof A, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ve, q);
        }
        var he = Jg(A, P, V, ie, le);
        if (he == null)
          return he;
        if (te) {
          var We = P.children;
          if (We !== void 0)
            if (Y)
              if (go(We)) {
                for (var Ft = 0; Ft < We.length; Ft++)
                  Vi(We[Ft], A);
                Object.freeze && Object.freeze(We);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Vi(We, A);
        }
        if (wt.call(P, "key")) {
          var At = L(A), Te = Object.keys(P).filter(function(am) {
            return am !== "key";
          }), ho = Te.length > 0 ? "{key: someKey, " + Te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Bi[At + ho]) {
            var om = Te.length > 0 ? "{" + Te.join(": ..., ") + ": ...}" : "{}";
            I(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ho, At, om, At), Bi[At + ho] = !0;
          }
        }
        return A === o ? qg(he) : Kg(he), he;
      }
    }
    function em(A, P, V) {
      return Li(A, P, V, !0);
    }
    function tm(A, P, V) {
      return Li(A, P, V, !1);
    }
    var nm = tm, rm = em;
    ln.Fragment = o, ln.jsx = nm, ln.jsxs = rm;
  }()), ln;
}
var Hi;
function gm() {
  return Hi || (Hi = 1, process.env.NODE_ENV === "production" ? zn.exports = fm() : zn.exports = pm()), zn.exports;
}
var p = gm();
function mm(e, t) {
  const n = d.createContext(t), o = (a) => {
    const { children: i, ...s } = a, c = d.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ p.jsx(n.Provider, { value: c, children: i });
  };
  o.displayName = e + "Provider";
  function r(a) {
    const i = d.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function ye(e, t = []) {
  let n = [];
  function o(a, i) {
    const s = d.createContext(i), c = n.length;
    n = [...n, i];
    const l = (f) => {
      var h;
      const { scope: g, children: b, ...C } = f, m = ((h = g == null ? void 0 : g[e]) == null ? void 0 : h[c]) || s, v = d.useMemo(() => C, Object.values(C));
      return /* @__PURE__ */ p.jsx(m.Provider, { value: v, children: b });
    };
    l.displayName = a + "Provider";
    function u(f, g) {
      var m;
      const b = ((m = g == null ? void 0 : g[e]) == null ? void 0 : m[c]) || s, C = d.useContext(b);
      if (C) return C;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [l, u];
  }
  const r = () => {
    const a = n.map((i) => d.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return r.scopeName = e, [o, bm(r, ...t)];
}
function bm(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function zi(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Fr(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const a = zi(r, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const a = o[r];
          typeof a == "function" ? a() : zi(e[r], null);
        }
      };
  };
}
function ne(...e) {
  return d.useCallback(Fr(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Rt(e) {
  const t = /* @__PURE__ */ hm(e), n = d.forwardRef((o, r) => {
    const { children: a, ...i } = o, s = d.Children.toArray(a), c = s.find(xm);
    if (c) {
      const l = c.props.children, u = s.map((f) => f === c ? d.Children.count(l) > 1 ? d.Children.only(null) : d.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p.jsx(t, { ...i, ref: r, children: d.isValidElement(l) ? d.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ p.jsx(t, { ...i, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var vm = /* @__PURE__ */ Rt("Slot");
// @__NO_SIDE_EFFECTS__
function hm(e) {
  const t = d.forwardRef((n, o) => {
    const { children: r, ...a } = n;
    if (d.isValidElement(r)) {
      const i = Cm(r), s = ym(a, r.props);
      return r.type !== d.Fragment && (s.ref = o ? Fr(o, i) : i), d.cloneElement(r, s);
    }
    return d.Children.count(r) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var yc = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Cc(e) {
  const t = ({ children: n }) => /* @__PURE__ */ p.jsx(p.Fragment, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = yc, t;
}
function xm(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === yc;
}
function ym(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...s) => {
      const c = a(...s);
      return r(...s), c;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Cm(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Or(e) {
  const t = e + "CollectionProvider", [n, o] = ye(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: v, children: h } = m, I = K.useRef(null), x = K.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p.jsx(r, { scope: v, itemMap: x, collectionRef: I, children: h });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", c = /* @__PURE__ */ Rt(s), l = K.forwardRef(
    (m, v) => {
      const { scope: h, children: I } = m, x = a(s, h), y = ne(v, x.collectionRef);
      return /* @__PURE__ */ p.jsx(c, { ref: y, children: I });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", f = "data-radix-collection-item", g = /* @__PURE__ */ Rt(u), b = K.forwardRef(
    (m, v) => {
      const { scope: h, children: I, ...x } = m, y = K.useRef(null), w = ne(v, y), R = a(u, h);
      return K.useEffect(() => (R.itemMap.set(y, { ref: y, ...x }), () => void R.itemMap.delete(y))), /* @__PURE__ */ p.jsx(g, { [f]: "", ref: w, children: I });
    }
  );
  b.displayName = u;
  function C(m) {
    const v = a(e + "CollectionConsumer", m);
    return K.useCallback(() => {
      const I = v.collectionRef.current;
      if (!I) return [];
      const x = Array.from(I.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (R, E) => x.indexOf(R.ref.current) - x.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: b },
    C,
    o
  ];
}
function G(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
var rt = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, Im = d[" useInsertionEffect ".trim().toString()] || rt;
function Oe({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, a, i] = wm({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, c = s ? e : r;
  {
    const u = d.useRef(e !== void 0);
    d.useEffect(() => {
      const f = u.current;
      f !== s && console.warn(
        `${o} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const l = d.useCallback(
    (u) => {
      var f;
      if (s) {
        const g = Am(u) ? u(e) : u;
        g !== e && ((f = i.current) == null || f.call(i, g));
      } else
        a(u);
    },
    [s, e, a, i]
  );
  return [c, l];
}
function wm({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = d.useState(e), r = d.useRef(n), a = d.useRef(t);
  return Im(() => {
    a.current = t;
  }, [t]), d.useEffect(() => {
    var i;
    r.current !== n && ((i = a.current) == null || i.call(a, n), r.current = n);
  }, [n, r]), [n, o, a];
}
function Am(e) {
  return typeof e == "function";
}
var Em = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], z = Em.reduce((e, t) => {
  const n = /* @__PURE__ */ Rt(`Primitive.${t}`), o = d.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, c = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p.jsx(c, { ...s, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Aa(e, t) {
  e && wa.flushSync(() => e.dispatchEvent(t));
}
function Rm(e, t) {
  return d.useReducer((n, o) => t[n][o] ?? n, e);
}
var Se = (e) => {
  const { present: t, children: n } = e, o = Sm(t), r = typeof n == "function" ? n({ present: o.isPresent }) : d.Children.only(n), a = ne(o.ref, Nm(r));
  return typeof n == "function" || o.isPresent ? d.cloneElement(r, { ref: a }) : null;
};
Se.displayName = "Presence";
function Sm(e) {
  const [t, n] = d.useState(), o = d.useRef(null), r = d.useRef(e), a = d.useRef("none"), i = e ? "mounted" : "unmounted", [s, c] = Rm(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const l = Zn(o.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), rt(() => {
    const l = o.current, u = r.current;
    if (u !== e) {
      const g = a.current, b = Zn(l);
      e ? c("MOUNT") : b === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && g !== b ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, c]), rt(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, f = (b) => {
        const m = Zn(o.current).includes(b.animationName);
        if (b.target === t && m && (c("ANIMATION_END"), !r.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, g = (b) => {
        b.target === t && (a.current = Zn(o.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: d.useCallback((l) => {
      o.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function Zn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Nm(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Pm = d[" useId ".trim().toString()] || (() => {
}), _m = 0;
function je(e) {
  const [t, n] = d.useState(Pm());
  return rt(() => {
    n((o) => o ?? String(_m++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var Gr = "Collapsible", [Tm, Ic] = ye(Gr), [Dm, Ea] = Tm(Gr), wc = d.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: o,
      defaultOpen: r,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [c, l] = Oe({
      prop: o,
      defaultProp: r ?? !1,
      onChange: i,
      caller: Gr
    });
    return /* @__PURE__ */ p.jsx(
      Dm,
      {
        scope: n,
        disabled: a,
        contentId: je(),
        open: c,
        onOpenToggle: d.useCallback(() => l((u) => !u), [l]),
        children: /* @__PURE__ */ p.jsx(
          z.div,
          {
            "data-state": Sa(c),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
wc.displayName = Gr;
var Ac = "CollapsibleTrigger", Ec = d.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...o } = e, r = Ea(Ac, n);
    return /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": Sa(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...o,
        ref: t,
        onClick: G(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Ec.displayName = Ac;
var Ra = "CollapsibleContent", Rc = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Ea(Ra, e.__scopeCollapsible);
    return /* @__PURE__ */ p.jsx(Se, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ p.jsx(Mm, { ...o, ref: t, present: a }) });
  }
);
Rc.displayName = Ra;
var Mm = d.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...a } = e, i = Ea(Ra, n), [s, c] = d.useState(o), l = d.useRef(null), u = ne(t, l), f = d.useRef(0), g = f.current, b = d.useRef(0), C = b.current, m = i.open || s, v = d.useRef(m), h = d.useRef(void 0);
  return d.useEffect(() => {
    const I = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(I);
  }, []), rt(() => {
    const I = l.current;
    if (I) {
      h.current = h.current || {
        transitionDuration: I.style.transitionDuration,
        animationName: I.style.animationName
      }, I.style.transitionDuration = "0s", I.style.animationName = "none";
      const x = I.getBoundingClientRect();
      f.current = x.height, b.current = x.width, v.current || (I.style.transitionDuration = h.current.transitionDuration, I.style.animationName = h.current.animationName), c(o);
    }
  }, [i.open, o]), /* @__PURE__ */ p.jsx(
    z.div,
    {
      "data-state": Sa(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !m,
      ...a,
      ref: u,
      style: {
        "--radix-collapsible-content-height": g ? `${g}px` : void 0,
        "--radix-collapsible-content-width": C ? `${C}px` : void 0,
        ...e.style
      },
      children: m && r
    }
  );
});
function Sa(e) {
  return e ? "open" : "closed";
}
var Fm = wc, Om = Ec, Gm = Rc, km = d.createContext(void 0);
function Nn(e) {
  const t = d.useContext(km);
  return e || t || "ltr";
}
var Ye = "Accordion", jm = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Na, Vm, Bm] = Or(Ye), [kr, CE] = ye(Ye, [
  Bm,
  Ic
]), Pa = Ic(), Sc = K.forwardRef(
  (e, t) => {
    const { type: n, ...o } = e, r = o, a = o;
    return /* @__PURE__ */ p.jsx(Na.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ p.jsx(Hm, { ...a, ref: t }) : /* @__PURE__ */ p.jsx(Xm, { ...r, ref: t }) });
  }
);
Sc.displayName = Ye;
var [Nc, Lm] = kr(Ye), [Pc, Wm] = kr(
  Ye,
  { collapsible: !1 }
), Xm = K.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: o,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, c] = Oe({
      prop: n,
      defaultProp: o ?? "",
      onChange: r,
      caller: Ye
    });
    return /* @__PURE__ */ p.jsx(
      Nc,
      {
        scope: e.__scopeAccordion,
        value: K.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: c,
        onItemClose: K.useCallback(() => a && c(""), [a, c]),
        children: /* @__PURE__ */ p.jsx(Pc, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ p.jsx(_c, { ...i, ref: t }) })
      }
    );
  }
), Hm = K.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = Oe({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: Ye
  }), c = K.useCallback(
    (u) => s((f = []) => [...f, u]),
    [s]
  ), l = K.useCallback(
    (u) => s((f = []) => f.filter((g) => g !== u)),
    [s]
  );
  return /* @__PURE__ */ p.jsx(
    Nc,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: c,
      onItemClose: l,
      children: /* @__PURE__ */ p.jsx(Pc, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ p.jsx(_c, { ...a, ref: t }) })
    }
  );
}), [zm, jr] = kr(Ye), _c = K.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: o, dir: r, orientation: a = "vertical", ...i } = e, s = K.useRef(null), c = ne(s, t), l = Vm(n), f = Nn(r) === "ltr", g = G(e.onKeyDown, (b) => {
      var N;
      if (!jm.includes(b.key)) return;
      const C = b.target, m = l().filter((_) => {
        var D;
        return !((D = _.ref.current) != null && D.disabled);
      }), v = m.findIndex((_) => _.ref.current === C), h = m.length;
      if (v === -1) return;
      b.preventDefault();
      let I = v;
      const x = 0, y = h - 1, w = () => {
        I = v + 1, I > y && (I = x);
      }, R = () => {
        I = v - 1, I < x && (I = y);
      };
      switch (b.key) {
        case "Home":
          I = x;
          break;
        case "End":
          I = y;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? w() : R());
          break;
        case "ArrowDown":
          a === "vertical" && w();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? R() : w());
          break;
        case "ArrowUp":
          a === "vertical" && R();
          break;
      }
      const E = I % h;
      (N = m[E].ref.current) == null || N.focus();
    });
    return /* @__PURE__ */ p.jsx(
      zm,
      {
        scope: n,
        disabled: o,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ p.jsx(Na.Slot, { scope: n, children: /* @__PURE__ */ p.jsx(
          z.div,
          {
            ...i,
            "data-orientation": a,
            ref: c,
            onKeyDown: o ? void 0 : g
          }
        ) })
      }
    );
  }
), xr = "AccordionItem", [Zm, _a] = kr(xr), Tc = K.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: o, ...r } = e, a = jr(xr, n), i = Lm(xr, n), s = Pa(n), c = je(), l = o && i.value.includes(o) || !1, u = a.disabled || e.disabled;
    return /* @__PURE__ */ p.jsx(
      Zm,
      {
        scope: n,
        open: l,
        disabled: u,
        triggerId: c,
        children: /* @__PURE__ */ p.jsx(
          Fm,
          {
            "data-orientation": a.orientation,
            "data-state": kc(l),
            ...s,
            ...r,
            ref: t,
            disabled: u,
            open: l,
            onOpenChange: (f) => {
              f ? i.onItemOpen(o) : i.onItemClose(o);
            }
          }
        )
      }
    );
  }
);
Tc.displayName = xr;
var Dc = "AccordionHeader", Mc = K.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = jr(Ye, n), a = _a(Dc, n);
    return /* @__PURE__ */ p.jsx(
      z.h3,
      {
        "data-orientation": r.orientation,
        "data-state": kc(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Mc.displayName = Dc;
var Qo = "AccordionTrigger", Fc = K.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = jr(Ye, n), a = _a(Qo, n), i = Wm(Qo, n), s = Pa(n);
    return /* @__PURE__ */ p.jsx(Na.ItemSlot, { scope: n, children: /* @__PURE__ */ p.jsx(
      Om,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...s,
        ...o,
        ref: t
      }
    ) });
  }
);
Fc.displayName = Qo;
var Oc = "AccordionContent", Gc = K.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = jr(Ye, n), a = _a(Oc, n), i = Pa(n);
    return /* @__PURE__ */ p.jsx(
      Gm,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...o,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Gc.displayName = Oc;
function kc(e) {
  return e ? "open" : "closed";
}
var $m = Sc, Ym = Tc, Jm = Mc, jc = Fc, Vc = Gc;
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Um = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Bc = (...e) => e.filter((t, n, o) => !!t && o.indexOf(t) === n).join(" ");
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Qm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Km = Sn(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: o,
    className: r = "",
    children: a,
    iconNode: i,
    ...s
  }, c) => Jo(
    "svg",
    {
      ref: c,
      ...Qm,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: o ? Number(n) * 24 / Number(t) : n,
      className: Bc("lucide", r),
      ...s
    },
    [
      ...i.map(([l, u]) => Jo(l, u)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const at = (e, t) => {
  const n = Sn(
    ({ className: o, ...r }, a) => Jo(Km, {
      ref: a,
      iconNode: t,
      className: Bc(`lucide-${Um(e)}`, o),
      ...r
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qm = at("BadgeAlert", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lc = at("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eb = at("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tb = at("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nb = at("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rb = at("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wc = at("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ob = at("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ab = at("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.394.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vr = at("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
function Xc(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Xc(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function Hc() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Xc(e)) && (o && (o += " "), o += t);
  return o;
}
function ib() {
  for (var e = 0, t, n, o = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = zc(t)) && (o && (o += " "), o += n);
  return o;
}
function zc(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", o = 0; o < e.length; o++)
    e[o] && (t = zc(e[o])) && (n && (n += " "), n += t);
  return n;
}
var Ta = "-";
function sb(e) {
  var t = lb(e), n = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, r = o === void 0 ? {} : o;
  function a(s) {
    var c = s.split(Ta);
    return c[0] === "" && c.length !== 1 && c.shift(), Zc(c, t) || cb(s);
  }
  function i(s, c) {
    var l = n[s] || [];
    return c && r[s] ? [].concat(l, r[s]) : l;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: i
  };
}
function Zc(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], o = t.nextPart.get(n), r = o ? Zc(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length !== 0) {
    var a = e.join(Ta);
    return (i = t.validators.find(function(s) {
      var c = s.validator;
      return c(a);
    })) == null ? void 0 : i.classGroupId;
  }
}
var Zi = /^\[(.+)\]$/;
function cb(e) {
  if (Zi.test(e)) {
    var t = Zi.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function lb(e) {
  var t = e.theme, n = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, r = db(Object.entries(e.classGroups), n);
  return r.forEach(function(a) {
    var i = a[0], s = a[1];
    Ko(s, o, i, t);
  }), o;
}
function Ko(e, t, n, o) {
  e.forEach(function(r) {
    if (typeof r == "string") {
      var a = r === "" ? t : $i(t, r);
      a.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (ub(r)) {
        Ko(r(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(function(i) {
      var s = i[0], c = i[1];
      Ko(c, $i(t, s), n, o);
    });
  });
}
function $i(e, t) {
  var n = e;
  return t.split(Ta).forEach(function(o) {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}
function ub(e) {
  return e.isThemeGetter;
}
function db(e, t) {
  return t ? e.map(function(n) {
    var o = n[0], r = n[1], a = r.map(function(i) {
      return typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(s) {
        var c = s[0], l = s[1];
        return [t + c, l];
      })) : i;
    });
    return [o, a];
  }) : e;
}
function fb(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function r(a, i) {
    n.set(a, i), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = o.get(i)) !== void 0)
        return r(i, s), s;
    },
    set: function(i, s) {
      n.has(i) ? n.set(i, s) : r(i, s);
    }
  };
}
var $c = "!";
function pb(e) {
  var t = e.separator || ":", n = t.length === 1, o = t[0], r = t.length;
  return function(i) {
    for (var s = [], c = 0, l = 0, u, f = 0; f < i.length; f++) {
      var g = i[f];
      if (c === 0) {
        if (g === o && (n || i.slice(f, f + r) === t)) {
          s.push(i.slice(l, f)), l = f + r;
          continue;
        }
        if (g === "/") {
          u = f;
          continue;
        }
      }
      g === "[" ? c++ : g === "]" && c--;
    }
    var b = s.length === 0 ? i : i.substring(l), C = b.startsWith($c), m = C ? b.substring(1) : b, v = u && u > l ? u - l : void 0;
    return {
      modifiers: s,
      hasImportantModifier: C,
      baseClassName: m,
      maybePostfixModifierPosition: v
    };
  };
}
function gb(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(o) {
    var r = o[0] === "[";
    r ? (t.push.apply(t, n.sort().concat([o])), n = []) : n.push(o);
  }), t.push.apply(t, n.sort()), t;
}
function mb(e) {
  return {
    cache: fb(e.cacheSize),
    splitModifiers: pb(e),
    ...sb(e)
  };
}
var bb = /\s+/;
function vb(e, t) {
  var n = t.splitModifiers, o = t.getClassGroupId, r = t.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return e.trim().split(bb).map(function(i) {
    var s = n(i), c = s.modifiers, l = s.hasImportantModifier, u = s.baseClassName, f = s.maybePostfixModifierPosition, g = o(f ? u.substring(0, f) : u), b = !!f;
    if (!g) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (g = o(u), !g)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      b = !1;
    }
    var C = gb(c).join(":"), m = l ? C + $c : C;
    return {
      isTailwindClass: !0,
      modifierId: m,
      classGroupId: g,
      originalClassName: i,
      hasPostfixModifier: b
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var s = i.modifierId, c = i.classGroupId, l = i.hasPostfixModifier, u = s + c;
    return a.has(u) ? !1 : (a.add(u), r(c, l).forEach(function(f) {
      return a.add(s + f);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function hb() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var o, r, a, i = s;
  function s(l) {
    var u = t[0], f = t.slice(1), g = f.reduce(function(b, C) {
      return C(b);
    }, u());
    return o = mb(g), r = o.cache.get, a = o.cache.set, i = c, c(l);
  }
  function c(l) {
    var u = r(l);
    if (u)
      return u;
    var f = vb(l, o);
    return a(l, f), f;
  }
  return function() {
    return i(ib.apply(null, arguments));
  };
}
function de(e) {
  var t = function(o) {
    return o[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Yc = /^\[(?:([a-z-]+):)?(.+)\]$/i, xb = /^\d+\/\d+$/, yb = /* @__PURE__ */ new Set(["px", "full", "screen"]), Cb = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ib = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, wb = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function ze(e) {
  return Et(e) || yb.has(e) || xb.test(e) || qo(e);
}
function qo(e) {
  return _t(e, "length", Pb);
}
function Ab(e) {
  return _t(e, "size", Jc);
}
function Eb(e) {
  return _t(e, "position", Jc);
}
function Rb(e) {
  return _t(e, "url", _b);
}
function $n(e) {
  return _t(e, "number", Et);
}
function Et(e) {
  return !Number.isNaN(Number(e));
}
function Sb(e) {
  return e.endsWith("%") && Et(e.slice(0, -1));
}
function un(e) {
  return Yi(e) || _t(e, "number", Yi);
}
function ee(e) {
  return Yc.test(e);
}
function dn() {
  return !0;
}
function bt(e) {
  return Cb.test(e);
}
function Nb(e) {
  return _t(e, "", Tb);
}
function _t(e, t, n) {
  var o = Yc.exec(e);
  return o ? o[1] ? o[1] === t : n(o[2]) : !1;
}
function Pb(e) {
  return Ib.test(e);
}
function Jc() {
  return !1;
}
function _b(e) {
  return e.startsWith("url(");
}
function Yi(e) {
  return Number.isInteger(Number(e));
}
function Tb(e) {
  return wb.test(e);
}
function Db() {
  var e = de("colors"), t = de("spacing"), n = de("blur"), o = de("brightness"), r = de("borderColor"), a = de("borderRadius"), i = de("borderSpacing"), s = de("borderWidth"), c = de("contrast"), l = de("grayscale"), u = de("hueRotate"), f = de("invert"), g = de("gap"), b = de("gradientColorStops"), C = de("gradientColorStopPositions"), m = de("inset"), v = de("margin"), h = de("opacity"), I = de("padding"), x = de("saturate"), y = de("scale"), w = de("sepia"), R = de("skew"), E = de("space"), N = de("translate"), _ = function() {
    return ["auto", "contain", "none"];
  }, D = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, O = function() {
    return ["auto", ee, t];
  }, T = function() {
    return [ee, t];
  }, L = function() {
    return ["", ze];
  }, M = function() {
    return ["auto", Et, ee];
  }, B = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, k = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, $ = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, j = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, F = function() {
    return ["", "0", ee];
  }, U = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, re = function() {
    return [Et, $n];
  }, J = function() {
    return [Et, ee];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [dn],
      spacing: [ze],
      blur: ["none", "", bt, ee],
      brightness: re(),
      borderColor: [e],
      borderRadius: ["none", "", "full", bt, ee],
      borderSpacing: T(),
      borderWidth: L(),
      contrast: re(),
      grayscale: F(),
      hueRotate: J(),
      invert: F(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Sb, qo],
      inset: O(),
      margin: O(),
      opacity: re(),
      padding: T(),
      saturate: re(),
      scale: re(),
      sepia: F(),
      skew: J(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ee]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [bt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": U()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": U()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(B(), [ee])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", un]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: O()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ee]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: F()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: F()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", un]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [dn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", un]
        }, ee]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": M()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": M()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [dn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [un]
        }, ee]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": M()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": M()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ee]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ee]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [g]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [g]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [g]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(j())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(j(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(j(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [I]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [I]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [I]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [I]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [I]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [I]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [I]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [I]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [I]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", ee, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", ee, ze]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [bt]
        }, bt, ee]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ee, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", ee, ze]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ee, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", bt, qo]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", $n]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [dn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ee]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Et, $n]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ee, ze]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ee]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ee]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [h]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [h]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(k(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ze]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ee, ze]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ee]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ee]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [h]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(B(), [Eb])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Ab]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Rb]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [C]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [C]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [C]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [b]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [h]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(k(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [h]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: k()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(k())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ee, ze]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ze]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: L()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [h]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ze]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", bt, Nb]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [dn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [h]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": $()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", bt, ee]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [w]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [h]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [w]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ee]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: J()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ee]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: J()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ee]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [y]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [y]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [y]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [un, ee]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [N]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [N]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ee]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ee]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ee]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ze, $n]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Mb = /* @__PURE__ */ hb(Db);
function S(...e) {
  return Mb(Hc(e));
}
const Fb = $m, Uc = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Ym, { ref: n, className: S("border-b", e), ...t }));
Uc.displayName = "AccordionItem";
const Qc = d.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ p.jsx(Jm, { className: "flex", children: /* @__PURE__ */ p.jsxs(
  jc,
  {
    ref: o,
    className: S(
      "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ p.jsx(eb, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
    ]
  }
) }));
Qc.displayName = jc.displayName;
const Kc = d.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ p.jsx(
  Vc,
  {
    ref: o,
    className: S(
      "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      e
    ),
    ...n,
    children: /* @__PURE__ */ p.jsx("div", { className: "pb-4 pt-0", children: t })
  }
));
Kc.displayName = Vc.displayName;
var qc = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(qc || {}), Vt = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(Vt || {}), Bt = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(Bt || {}), Lt = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(Lt || {}), Wt = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(Wt || {}), Xt = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(Xt || {}), Ht = /* @__PURE__ */ ((e) => (e.XS = "XS", e.SM = "SM", e.MD = "MD", e.LG = "LG", e))(Ht || {}), Re = /* @__PURE__ */ ((e) => (e.DEFAULT = "DEFAULT", e.INFO = "INFO", e.SUCCESS = "SUCCESS", e.WARNING = "WARNING", e.ERROR = "ERROR", e))(Re || {}), ea = /* @__PURE__ */ ((e) => (e.LIGHT = "light", e.DARK = "dark", e))(ea || {}), el = /* @__PURE__ */ ((e) => (e.SINGLE = "single", e.MULTIPLE = "multiple", e))(el || {});
const IE = (e) => {
  const { type: t = el.SINGLE, items: n, className: o = "", itemClassName: r = "", triggerClassName: a = "", contentClassName: i = "" } = e;
  return /* @__PURE__ */ p.jsx(Fb, { type: t, className: S(`w-full ${o}`), children: n.map((s, c) => /* @__PURE__ */ p.jsxs(
    Uc,
    {
      value: `item-${c}`,
      className: S(`nyn-accordion border border-border px-3 bg-card rounded mb-2.5 ${r}`),
      children: [
        /* @__PURE__ */ p.jsx(Qc, { className: S(`nyn-accordion-title text-text hover:no-underline ${a}`), children: s.title }),
        /* @__PURE__ */ p.jsx(Kc, { className: S(`nyn-accordion-message text-text ${i}`), children: s.message })
      ]
    },
    c
  )) });
}, Ji = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ui = Hc, en = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null) return Ui(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: a } = t, i = Object.keys(r).map((l) => {
    const u = n == null ? void 0 : n[l], f = a == null ? void 0 : a[l];
    if (u === null) return null;
    const g = Ji(u) || Ji(f);
    return r[l][g];
  }), s = n && Object.entries(n).reduce((l, u) => {
    let [f, g] = u;
    return g === void 0 || (l[f] = g), l;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((l, u) => {
    let { class: f, className: g, ...b } = u;
    return Object.entries(b).every((C) => {
      let [m, v] = C;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...s
      }[m]) : {
        ...a,
        ...s
      }[m] === v;
    }) ? [
      ...l,
      f,
      g
    ] : l;
  }, []);
  return Ui(e, i, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Ob = en(
  "relative w-full rounded-lg border p-4 [&:has(svg)]:pl-11 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), tl = d.forwardRef(
  ({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ p.jsx("div", { ref: o, role: "alert", className: S(Ob({ variant: t }), e), ...n })
);
tl.displayName = "Alert";
const nl = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("h5", { ref: n, className: S("mb-1 font-medium leading-none tracking-tight", e), ...t }));
nl.displayName = "AlertTitle";
const rl = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("div", { ref: n, className: S("text-sm [&_p]:leading-relaxed", e), ...t }));
rl.displayName = "AlertDescription";
const Gb = {
  [Re.DEFAULT]: /* @__PURE__ */ p.jsx(qm, { className: "h-4 w-4" }),
  [Re.INFO]: /* @__PURE__ */ p.jsx(ob, { className: "h-4 w-4" }),
  [Re.SUCCESS]: /* @__PURE__ */ p.jsx(nb, { className: "h-4 w-4" }),
  [Re.WARNING]: /* @__PURE__ */ p.jsx(ab, { className: "h-4 w-4" }),
  [Re.ERROR]: /* @__PURE__ */ p.jsx(rb, { className: "h-4 w-4" })
}, kb = {
  [Re.DEFAULT]: "bg-card text-text border-border",
  [Re.INFO]: "bg-blue-300 text-blue-700 border border-blue-400",
  [Re.SUCCESS]: "bg-green-300 text-green-700 border border-green-400",
  [Re.WARNING]: "bg-yellow-300 text-yellow-700 border border-yellow-400",
  [Re.ERROR]: "bg-red-300 text-red-700 border border-red-400"
}, jb = {
  [Re.DEFAULT]: "Alert!",
  [Re.INFO]: "Information!",
  [Re.SUCCESS]: "Success!",
  [Re.WARNING]: "Warning!",
  [Re.ERROR]: "Error!"
}, wE = (e) => {
  const {
    className: t = "",
    titleClassName: n = "",
    messageClassName: o = "",
    closeClassName: r = "",
    type: a,
    title: i = jb[a],
    message: s,
    onClose: c
  } = e;
  return /* @__PURE__ */ p.jsxs(
    tl,
    {
      className: S(
        `nyn-alert ${a.toLowerCase()} [&:has(svg)]:pl-10 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-3 [&>svg]:top-3 [&>svg]:nyn-text rounded p-3 ${kb[a]} ${t}`
      ),
      children: [
        Gb[a],
        i && /* @__PURE__ */ p.jsxs(nl, { className: S(`nyn-alert-title mb-1.5 font-semibold flex flex-row justify-between items-center ${n}`), children: [
          i,
          c && /* @__PURE__ */ p.jsx("span", { className: S(`nyn-alert-close${r}`), tabIndex: 1, role: "button", onClick: c, onKeyDown: c, children: /* @__PURE__ */ p.jsx(Vr, { className: "w-4 h-4" }) })
        ] }),
        /* @__PURE__ */ p.jsx(rl, { className: S(`nyn-alert-message ${o}`), children: s })
      ]
    }
  );
}, Vb = en(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Bb({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ p.jsx("div", { className: S(Vb({ variant: t }), e), ...n });
}
const Lb = {
  [Vt.XS]: "px-2 py-0.5 text-xs",
  [Vt.SM]: "px-2 py-0 text-sm",
  [Vt.MD]: "px-3 py-0 text-base",
  [Vt.LG]: "px-3 py-0 text-lg"
}, AE = (e) => {
  const { className: t = "", size: n = Vt.SM, children: o } = e;
  return /* @__PURE__ */ p.jsx(Bb, { className: S(`nyn-badge ${n.toLowerCase()} rounded-full font-normal ${Lb[n]} ${t}`), children: o });
}, Da = en(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ma = d.forwardRef(({ className: e, variant: t, size: n, asChild: o = !1, ...r }, a) => {
  const i = o ? vm : "button";
  return /* @__PURE__ */ p.jsx(i, { className: S(Da({ variant: t, size: n, className: e })), ref: a, ...r });
});
Ma.displayName = "Button";
const Wb = {
  [Bt.XS]: "px-2 py-0.5 text-xs",
  [Bt.SM]: "px-2 py-1 text-sm",
  [Bt.MD]: "px-3 py-2 text-sm",
  [Bt.LG]: "px-3 py-2 text-base"
}, EE = (e) => {
  const {
    children: t,
    size: n = Bt.MD,
    className: o = "",
    isOutline: r = !1,
    isLoading: a = !1,
    loadingText: i = "Loading...",
    onClick: s = () => {
    },
    ...c
  } = e;
  return /* @__PURE__ */ p.jsx(
    Ma,
    {
      className: S(
        `nyn-button ${n.toLowerCase()} ${r ? "text-primary hover:text-white bg-transparent hover:bg-primary-dark border border-primary" : "text-white bg-primary border border-primary hover:bg-primary-dark"} rounded h-auto transition duration-150 ease-in-out h-auto ${Wb[n]} ${o}`
      ),
      onClick: s,
      ...c,
      children: a ? i : t
    }
  );
}, RE = (e) => {
  const { className: t = "", buttonClassName: n = "", items: o, selected: r, disabled: a = !1, onChange: i } = e;
  return /* @__PURE__ */ p.jsx("div", { className: S(`nyn-button-group rounded ${t}`), role: "group", children: o.map((s) => /* @__PURE__ */ p.jsx(
    Ma,
    {
      type: "button",
      disabled: a,
      onClick: () => i(s),
      className: S(
        `nyn-button-group-item ${s === r ? "bg-primary text-white" : "bg-card text-text"} hover:bg-primary hover:text-white border border-border first:border-r-0 last:border-l-0 first:rounded-l-lg rounded-none last:rounded-r-lg px-3 py-2 h-auto mx-0 outline-none focus:shadow-outline ${n}`
      ),
      children: s
    },
    s
  )) });
}, SE = (e) => {
  const { className: t = "", children: n, onClick: o, ...r } = e;
  return /* @__PURE__ */ p.jsx("div", { className: S(`nyn-card border border-border bg-card rounded ${t}`), onClick: o, onKeyDown: o, ...r, children: n });
};
function Fa(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Br(e) {
  const [t, n] = d.useState(void 0);
  return rt(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Lr = "Checkbox", [Xb, NE] = ye(Lr), [Hb, Oa] = Xb(Lr);
function zb(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: o,
    defaultChecked: r,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: c,
    required: l,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [g, b] = Oe({
    prop: n,
    defaultProp: r ?? !1,
    onChange: c,
    caller: Lr
  }), [C, m] = d.useState(null), [v, h] = d.useState(null), I = d.useRef(!1), x = C ? !!i || !!C.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), y = {
    checked: g,
    disabled: a,
    setChecked: b,
    control: C,
    setControl: m,
    name: s,
    form: i,
    value: u,
    hasConsumerStoppedPropagationRef: I,
    required: l,
    defaultChecked: ht(r) ? !1 : r,
    isFormControl: x,
    bubbleInput: v,
    setBubbleInput: h
  };
  return /* @__PURE__ */ p.jsx(
    Hb,
    {
      scope: t,
      ...y,
      children: Zb(f) ? f(y) : o
    }
  );
}
var ol = "CheckboxTrigger", al = d.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...o }, r) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: c,
      required: l,
      setControl: u,
      setChecked: f,
      hasConsumerStoppedPropagationRef: g,
      isFormControl: b,
      bubbleInput: C
    } = Oa(ol, e), m = ne(r, u), v = d.useRef(c);
    return d.useEffect(() => {
      const h = a == null ? void 0 : a.form;
      if (h) {
        const I = () => f(v.current);
        return h.addEventListener("reset", I), () => h.removeEventListener("reset", I);
      }
    }, [a, f]), /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": ht(c) ? "mixed" : c,
        "aria-required": l,
        "data-state": ul(c),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...o,
        ref: m,
        onKeyDown: G(t, (h) => {
          h.key === "Enter" && h.preventDefault();
        }),
        onClick: G(n, (h) => {
          f((I) => ht(I) ? !0 : !I), C && b && (g.current = h.isPropagationStopped(), g.current || h.stopPropagation());
        })
      }
    );
  }
);
al.displayName = ol;
var Ga = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: c,
      onCheckedChange: l,
      form: u,
      ...f
    } = e;
    return /* @__PURE__ */ p.jsx(
      zb,
      {
        __scopeCheckbox: n,
        checked: r,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: l,
        name: o,
        form: u,
        value: c,
        internal_do_not_use_render: ({ isFormControl: g }) => /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          /* @__PURE__ */ p.jsx(
            al,
            {
              ...f,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          g && /* @__PURE__ */ p.jsx(
            ll,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
Ga.displayName = Lr;
var il = "CheckboxIndicator", sl = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: o, ...r } = e, a = Oa(il, n);
    return /* @__PURE__ */ p.jsx(
      Se,
      {
        present: o || ht(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ p.jsx(
          z.span,
          {
            "data-state": ul(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...r,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
sl.displayName = il;
var cl = "CheckboxBubbleInput", ll = d.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: o,
      hasConsumerStoppedPropagationRef: r,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: c,
      name: l,
      value: u,
      form: f,
      bubbleInput: g,
      setBubbleInput: b
    } = Oa(cl, e), C = ne(n, b), m = Fa(a), v = Br(o);
    d.useEffect(() => {
      const I = g;
      if (!I) return;
      const x = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, R = !r.current;
      if (m !== a && w) {
        const E = new Event("click", { bubbles: R });
        I.indeterminate = ht(a), w.call(I, ht(a) ? !1 : a), I.dispatchEvent(E);
      }
    }, [g, m, a, r]);
    const h = d.useRef(ht(a) ? !1 : a);
    return /* @__PURE__ */ p.jsx(
      z.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? h.current,
        required: s,
        disabled: c,
        name: l,
        value: u,
        form: f,
        ...t,
        tabIndex: -1,
        ref: C,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
ll.displayName = cl;
function Zb(e) {
  return typeof e == "function";
}
function ht(e) {
  return e === "indeterminate";
}
function ul(e) {
  return ht(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const dl = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    Ga,
    {
      ref: n,
      className: S(
        "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        e
      ),
      ...t,
      children: /* @__PURE__ */ p.jsx(sl, { className: S("flex items-center justify-center text-current"), children: /* @__PURE__ */ p.jsx(Lc, { className: "h-4 w-4" }) })
    }
  )
);
dl.displayName = Ga.displayName;
const PE = (e) => {
  const { className: t = "", checkClassName: n = "", labelClassName: o = "", id: r = "check", children: a, checked: i, disabled: s = !1, onChange: c } = e;
  return /* @__PURE__ */ p.jsxs("div", { className: S(`flex space-x-2 mb-3 ${t}`), children: [
    /* @__PURE__ */ p.jsx(
      dl,
      {
        id: r,
        disabled: s,
        checked: i,
        onCheckedChange: c,
        className: S(
          `nyn-check data-[state=checked]:bg-primary data-[state=checked]:text-white data-[state=unchecked]:border-muted data-[state=checked]:border-primary ${n}`
        )
      }
    ),
    /* @__PURE__ */ p.jsx("label", { htmlFor: r, className: S(`-mt-1 peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${o}`), children: a })
  ] });
};
function Me(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function $b(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Me(e);
  d.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var Yb = "DismissableLayer", ta = "dismissableLayer.update", Jb = "dismissableLayer.pointerDownOutside", Ub = "dismissableLayer.focusOutside", Qi, fl = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), tn = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...c
    } = e, l = d.useContext(fl), [u, f] = d.useState(null), g = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, b] = d.useState({}), C = ne(t, (E) => f(E)), m = Array.from(l.layers), [v] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), h = m.indexOf(v), I = u ? m.indexOf(u) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, y = I >= h, w = Kb((E) => {
      const N = E.target, _ = [...l.branches].some((D) => D.contains(N));
      !y || _ || (r == null || r(E), i == null || i(E), E.defaultPrevented || s == null || s());
    }, g), R = qb((E) => {
      const N = E.target;
      [...l.branches].some((D) => D.contains(N)) || (a == null || a(E), i == null || i(E), E.defaultPrevented || s == null || s());
    }, g);
    return $b((E) => {
      I === l.layers.size - 1 && (o == null || o(E), !E.defaultPrevented && s && (E.preventDefault(), s()));
    }, g), d.useEffect(() => {
      if (u)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Qi = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), Ki(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = Qi);
        };
    }, [u, g, n, l]), d.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), Ki());
    }, [u, l]), d.useEffect(() => {
      const E = () => b({});
      return document.addEventListener(ta, E), () => document.removeEventListener(ta, E);
    }, []), /* @__PURE__ */ p.jsx(
      z.div,
      {
        ...c,
        ref: C,
        style: {
          pointerEvents: x ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: G(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: G(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: G(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
tn.displayName = Yb;
var Qb = "DismissableLayerBranch", pl = d.forwardRef((e, t) => {
  const n = d.useContext(fl), o = d.useRef(null), r = ne(t, o);
  return d.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ p.jsx(z.div, { ...e, ref: r });
});
pl.displayName = Qb;
function Kb(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Me(e), o = d.useRef(!1), r = d.useRef(() => {
  });
  return d.useEffect(() => {
    const a = (s) => {
      if (s.target && !o.current) {
        let c = function() {
          gl(
            Jb,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = c, t.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function qb(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Me(e), o = d.useRef(!1);
  return d.useEffect(() => {
    const r = (a) => {
      a.target && !o.current && gl(Ub, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Ki() {
  const e = new CustomEvent(ta);
  document.dispatchEvent(e);
}
function gl(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? Aa(r, a) : r.dispatchEvent(a);
}
var ev = tn, tv = pl, xo = "focusScope.autoFocusOnMount", yo = "focusScope.autoFocusOnUnmount", qi = { bubbles: !1, cancelable: !0 }, nv = "FocusScope", Wr = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, c] = d.useState(null), l = Me(r), u = Me(a), f = d.useRef(null), g = ne(t, (m) => c(m)), b = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (o) {
      let m = function(x) {
        if (b.paused || !s) return;
        const y = x.target;
        s.contains(y) ? f.current = y : vt(f.current, { select: !0 });
      }, v = function(x) {
        if (b.paused || !s) return;
        const y = x.relatedTarget;
        y !== null && (s.contains(y) || vt(f.current, { select: !0 }));
      }, h = function(x) {
        if (document.activeElement === document.body)
          for (const w of x)
            w.removedNodes.length > 0 && vt(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", v);
      const I = new MutationObserver(h);
      return s && I.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", v), I.disconnect();
      };
    }
  }, [o, s, b.paused]), d.useEffect(() => {
    if (s) {
      ts.add(b);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const h = new CustomEvent(xo, qi);
        s.addEventListener(xo, l), s.dispatchEvent(h), h.defaultPrevented || (rv(cv(ml(s)), { select: !0 }), document.activeElement === m && vt(s));
      }
      return () => {
        s.removeEventListener(xo, l), setTimeout(() => {
          const h = new CustomEvent(yo, qi);
          s.addEventListener(yo, u), s.dispatchEvent(h), h.defaultPrevented || vt(m ?? document.body, { select: !0 }), s.removeEventListener(yo, u), ts.remove(b);
        }, 0);
      };
    }
  }, [s, l, u, b]);
  const C = d.useCallback(
    (m) => {
      if (!n && !o || b.paused) return;
      const v = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, h = document.activeElement;
      if (v && h) {
        const I = m.currentTarget, [x, y] = ov(I);
        x && y ? !m.shiftKey && h === y ? (m.preventDefault(), n && vt(x, { select: !0 })) : m.shiftKey && h === x && (m.preventDefault(), n && vt(y, { select: !0 })) : h === I && m.preventDefault();
      }
    },
    [n, o, b.paused]
  );
  return /* @__PURE__ */ p.jsx(z.div, { tabIndex: -1, ...i, ref: g, onKeyDown: C });
});
Wr.displayName = nv;
function rv(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (vt(o, { select: t }), document.activeElement !== n) return;
}
function ov(e) {
  const t = ml(e), n = es(t, e), o = es(t.reverse(), e);
  return [n, o];
}
function ml(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function es(e, t) {
  for (const n of e)
    if (!av(n, { upTo: t })) return n;
}
function av(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function iv(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function vt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && iv(e) && t && e.select();
  }
}
var ts = sv();
function sv() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ns(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ns(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function ns(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function cv(e) {
  return e.filter((t) => t.tagName !== "A");
}
var lv = "Portal", Pn = d.forwardRef((e, t) => {
  var s;
  const { container: n, ...o } = e, [r, a] = d.useState(!1);
  rt(() => a(!0), []);
  const i = n || r && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? lm.createPortal(/* @__PURE__ */ p.jsx(z.div, { ...o, ref: t }), i) : null;
});
Pn.displayName = lv;
var Co = 0;
function ka() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? rs()), document.body.insertAdjacentElement("beforeend", e[1] ?? rs()), Co++, () => {
      Co === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Co--;
    };
  }, []);
}
function rs() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ke = function() {
  return Ke = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Ke.apply(this, arguments);
};
function bl(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function uv(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, a; o < r; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var ur = "right-scroll-bar-position", dr = "width-before-scroll-bar", dv = "with-scroll-bars-hidden", fv = "--removed-body-scroll-bar-size";
function Io(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function pv(e, t) {
  var n = dt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var gv = typeof window < "u" ? d.useLayoutEffect : d.useEffect, os = /* @__PURE__ */ new WeakMap();
function mv(e, t) {
  var n = pv(null, function(o) {
    return e.forEach(function(r) {
      return Io(r, o);
    });
  });
  return gv(function() {
    var o = os.get(n);
    if (o) {
      var r = new Set(o), a = new Set(e), i = n.current;
      r.forEach(function(s) {
        a.has(s) || Io(s, null);
      }), a.forEach(function(s) {
        r.has(s) || Io(s, i);
      });
    }
    os.set(n, e);
  }, [e]), n;
}
function bv(e) {
  return e;
}
function vv(e, t) {
  t === void 0 && (t = bv);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, o);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      o = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var c = function() {
        var u = i;
        i = [], u.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          i.push(u), l();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return r;
}
function hv(e) {
  e === void 0 && (e = {});
  var t = vv(null);
  return t.options = Ke({ async: !0, ssr: !1 }, e), t;
}
var vl = function(e) {
  var t = e.sideCar, n = bl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return d.createElement(o, Ke({}, n));
};
vl.isSideCarExport = !0;
function xv(e, t) {
  return e.useMedium(t), vl;
}
var hl = hv(), wo = function() {
}, Xr = d.forwardRef(function(e, t) {
  var n = d.useRef(null), o = d.useState({
    onScrollCapture: wo,
    onWheelCapture: wo,
    onTouchMoveCapture: wo
  }), r = o[0], a = o[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, f = e.shards, g = e.sideCar, b = e.noRelative, C = e.noIsolation, m = e.inert, v = e.allowPinchZoom, h = e.as, I = h === void 0 ? "div" : h, x = e.gapMode, y = bl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = g, R = mv([n, t]), E = Ke(Ke({}, y), r);
  return d.createElement(
    d.Fragment,
    null,
    u && d.createElement(w, { sideCar: hl, removeScrollBar: l, shards: f, noRelative: b, noIsolation: C, inert: m, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: x }),
    i ? d.cloneElement(d.Children.only(s), Ke(Ke({}, E), { ref: R })) : d.createElement(I, Ke({}, E, { className: c, ref: R }), s)
  );
});
Xr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Xr.classNames = {
  fullWidth: dr,
  zeroRight: ur
};
var yv = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Cv() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = yv();
  return t && e.setAttribute("nonce", t), e;
}
function Iv(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function wv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Av = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Cv()) && (Iv(t, n), wv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Ev = function() {
  var e = Av();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, xl = function() {
  var e = Ev(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, Rv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ao = function(e) {
  return parseInt(e || "", 10) || 0;
}, Sv = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ao(n), Ao(o), Ao(r)];
}, Nv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Rv;
  var t = Sv(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, Pv = xl(), zt = "data-scroll-locked", _v = function(e, t, n, o) {
  var r = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(dv, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(zt, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ur, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(dr, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ur, " .").concat(ur, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(dr, " .").concat(dr, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(zt, `] {
    `).concat(fv, ": ").concat(s, `px;
  }
`);
}, as = function() {
  var e = parseInt(document.body.getAttribute(zt) || "0", 10);
  return isFinite(e) ? e : 0;
}, Tv = function() {
  d.useEffect(function() {
    return document.body.setAttribute(zt, (as() + 1).toString()), function() {
      var e = as() - 1;
      e <= 0 ? document.body.removeAttribute(zt) : document.body.setAttribute(zt, e.toString());
    };
  }, []);
}, Dv = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  Tv();
  var a = d.useMemo(function() {
    return Nv(r);
  }, [r]);
  return d.createElement(Pv, { styles: _v(a, !t, r, n ? "" : "!important") });
}, na = !1;
if (typeof window < "u")
  try {
    var Yn = Object.defineProperty({}, "passive", {
      get: function() {
        return na = !0, !0;
      }
    });
    window.addEventListener("test", Yn, Yn), window.removeEventListener("test", Yn, Yn);
  } catch {
    na = !1;
  }
var Ot = na ? { passive: !1 } : !1, Mv = function(e) {
  return e.tagName === "TEXTAREA";
}, yl = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Mv(e) && n[t] === "visible")
  );
}, Fv = function(e) {
  return yl(e, "overflowY");
}, Ov = function(e) {
  return yl(e, "overflowX");
}, is = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = Cl(e, o);
    if (r) {
      var a = Il(e, o), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, Gv = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, kv = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, Cl = function(e, t) {
  return e === "v" ? Fv(t) : Ov(t);
}, Il = function(e, t) {
  return e === "v" ? Gv(t) : kv(t);
}, jv = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Vv = function(e, t, n, o, r) {
  var a = jv(e, window.getComputedStyle(t).direction), i = a * o, s = n.target, c = t.contains(s), l = !1, u = i > 0, f = 0, g = 0;
  do {
    if (!s)
      break;
    var b = Il(e, s), C = b[0], m = b[1], v = b[2], h = m - v - a * C;
    (C || h) && Cl(e, s) && (f += h, g += C);
    var I = s.parentNode;
    s = I && I.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? I.host : I;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(g) < 1) && (l = !0), l;
}, Jn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ss = function(e) {
  return [e.deltaX, e.deltaY];
}, cs = function(e) {
  return e && "current" in e ? e.current : e;
}, Bv = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Lv = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Wv = 0, Gt = [];
function Xv(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), o = d.useRef(), r = d.useState(Wv++)[0], a = d.useState(xl)[0], i = d.useRef(e);
  d.useEffect(function() {
    i.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var m = uv([e.lockRef.current], (e.shards || []).map(cs), !0).filter(Boolean);
      return m.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), m.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = d.useCallback(function(m, v) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var h = Jn(m), I = n.current, x = "deltaX" in m ? m.deltaX : I[0] - h[0], y = "deltaY" in m ? m.deltaY : I[1] - h[1], w, R = m.target, E = Math.abs(x) > Math.abs(y) ? "h" : "v";
    if ("touches" in m && E === "h" && R.type === "range")
      return !1;
    var N = is(E, R);
    if (!N)
      return !0;
    if (N ? w = E : (w = E === "v" ? "h" : "v", N = is(E, R)), !N)
      return !1;
    if (!o.current && "changedTouches" in m && (x || y) && (o.current = w), !w)
      return !0;
    var _ = o.current || w;
    return Vv(_, v, m, _ === "h" ? x : y);
  }, []), c = d.useCallback(function(m) {
    var v = m;
    if (!(!Gt.length || Gt[Gt.length - 1] !== a)) {
      var h = "deltaY" in v ? ss(v) : Jn(v), I = t.current.filter(function(w) {
        return w.name === v.type && (w.target === v.target || v.target === w.shadowParent) && Bv(w.delta, h);
      })[0];
      if (I && I.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!I) {
        var x = (i.current.shards || []).map(cs).filter(Boolean).filter(function(w) {
          return w.contains(v.target);
        }), y = x.length > 0 ? s(v, x[0]) : !i.current.noIsolation;
        y && v.cancelable && v.preventDefault();
      }
    }
  }, []), l = d.useCallback(function(m, v, h, I) {
    var x = { name: m, delta: v, target: h, should: I, shadowParent: Hv(h) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(y) {
        return y !== x;
      });
    }, 1);
  }, []), u = d.useCallback(function(m) {
    n.current = Jn(m), o.current = void 0;
  }, []), f = d.useCallback(function(m) {
    l(m.type, ss(m), m.target, s(m, e.lockRef.current));
  }, []), g = d.useCallback(function(m) {
    l(m.type, Jn(m), m.target, s(m, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Gt.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, Ot), document.addEventListener("touchmove", c, Ot), document.addEventListener("touchstart", u, Ot), function() {
      Gt = Gt.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", c, Ot), document.removeEventListener("touchmove", c, Ot), document.removeEventListener("touchstart", u, Ot);
    };
  }, []);
  var b = e.removeScrollBar, C = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    C ? d.createElement(a, { styles: Lv(r) }) : null,
    b ? d.createElement(Dv, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Hv(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const zv = xv(hl, Xv);
var Hr = d.forwardRef(function(e, t) {
  return d.createElement(Xr, Ke({}, e, { ref: t, sideCar: zv }));
});
Hr.classNames = Xr.classNames;
var Zv = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, kt = /* @__PURE__ */ new WeakMap(), Un = /* @__PURE__ */ new WeakMap(), Qn = {}, Eo = 0, wl = function(e) {
  return e && (e.host || wl(e.parentNode));
}, $v = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = wl(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Yv = function(e, t, n, o) {
  var r = $v(t, Array.isArray(e) ? e : [e]);
  Qn[n] || (Qn[n] = /* @__PURE__ */ new WeakMap());
  var a = Qn[n], i = [], s = /* @__PURE__ */ new Set(), c = new Set(r), l = function(f) {
    !f || s.has(f) || (s.add(f), l(f.parentNode));
  };
  r.forEach(l);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(g) {
      if (s.has(g))
        u(g);
      else
        try {
          var b = g.getAttribute(o), C = b !== null && b !== "false", m = (kt.get(g) || 0) + 1, v = (a.get(g) || 0) + 1;
          kt.set(g, m), a.set(g, v), i.push(g), m === 1 && C && Un.set(g, !0), v === 1 && g.setAttribute(n, "true"), C || g.setAttribute(o, "true");
        } catch (h) {
          console.error("aria-hidden: cannot operate on ", g, h);
        }
    });
  };
  return u(t), s.clear(), Eo++, function() {
    i.forEach(function(f) {
      var g = kt.get(f) - 1, b = a.get(f) - 1;
      kt.set(f, g), a.set(f, b), g || (Un.has(f) || f.removeAttribute(o), Un.delete(f)), b || f.removeAttribute(n);
    }), Eo--, Eo || (kt = /* @__PURE__ */ new WeakMap(), kt = /* @__PURE__ */ new WeakMap(), Un = /* @__PURE__ */ new WeakMap(), Qn = {});
  };
}, ja = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = Zv(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), Yv(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, zr = "Dialog", [Al, El] = ye(zr), [Jv, Je] = Al(zr), Rl = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !0
  } = e, s = d.useRef(null), c = d.useRef(null), [l, u] = Oe({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: zr
  });
  return /* @__PURE__ */ p.jsx(
    Jv,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: je(),
      titleId: je(),
      descriptionId: je(),
      open: l,
      onOpenChange: u,
      onOpenToggle: d.useCallback(() => u((f) => !f), [u]),
      modal: i,
      children: n
    }
  );
};
Rl.displayName = zr;
var Sl = "DialogTrigger", Nl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Je(Sl, n), a = ne(t, r.triggerRef);
    return /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": La(r.open),
        ...o,
        ref: a,
        onClick: G(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Nl.displayName = Sl;
var Va = "DialogPortal", [Uv, Pl] = Al(Va, {
  forceMount: void 0
}), _l = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, a = Je(Va, t);
  return /* @__PURE__ */ p.jsx(Uv, { scope: t, forceMount: n, children: d.Children.map(o, (i) => /* @__PURE__ */ p.jsx(Se, { present: n || a.open, children: /* @__PURE__ */ p.jsx(Pn, { asChild: !0, container: r, children: i }) })) });
};
_l.displayName = Va;
var yr = "DialogOverlay", Tl = d.forwardRef(
  (e, t) => {
    const n = Pl(yr, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Je(yr, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ p.jsx(Se, { present: o || a.open, children: /* @__PURE__ */ p.jsx(Kv, { ...r, ref: t }) }) : null;
  }
);
Tl.displayName = yr;
var Qv = /* @__PURE__ */ Rt("DialogOverlay.RemoveScroll"), Kv = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Je(yr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p.jsx(Hr, { as: Qv, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ p.jsx(
        z.div,
        {
          "data-state": La(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), St = "DialogContent", Dl = d.forwardRef(
  (e, t) => {
    const n = Pl(St, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Je(St, e.__scopeDialog);
    return /* @__PURE__ */ p.jsx(Se, { present: o || a.open, children: a.modal ? /* @__PURE__ */ p.jsx(qv, { ...r, ref: t }) : /* @__PURE__ */ p.jsx(eh, { ...r, ref: t }) });
  }
);
Dl.displayName = St;
var qv = d.forwardRef(
  (e, t) => {
    const n = Je(St, e.__scopeDialog), o = d.useRef(null), r = ne(t, n.contentRef, o);
    return d.useEffect(() => {
      const a = o.current;
      if (a) return ja(a);
    }, []), /* @__PURE__ */ p.jsx(
      Ml,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: G(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: G(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: G(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), eh = d.forwardRef(
  (e, t) => {
    const n = Je(St, e.__scopeDialog), o = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ p.jsx(
      Ml,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), Ml = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: a, ...i } = e, s = Je(St, n), c = d.useRef(null), l = ne(t, c);
    return ka(), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        Wr,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ p.jsx(
            tn,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": La(s.open),
              ...i,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        /* @__PURE__ */ p.jsx(nh, { titleId: s.titleId }),
        /* @__PURE__ */ p.jsx(oh, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ba = "DialogTitle", Fl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Je(Ba, n);
    return /* @__PURE__ */ p.jsx(z.h2, { id: r.titleId, ...o, ref: t });
  }
);
Fl.displayName = Ba;
var Ol = "DialogDescription", Gl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Je(Ol, n);
    return /* @__PURE__ */ p.jsx(z.p, { id: r.descriptionId, ...o, ref: t });
  }
);
Gl.displayName = Ol;
var kl = "DialogClose", jl = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Je(kl, n);
    return /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: G(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
jl.displayName = kl;
function La(e) {
  return e ? "open" : "closed";
}
var Vl = "DialogTitleWarning", [th, Bl] = mm(Vl, {
  contentName: St,
  titleName: Ba,
  docsSlug: "dialog"
}), nh = ({ titleId: e }) => {
  const t = Bl(Vl), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, rh = "DialogDescriptionWarning", oh = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Bl(rh).contentName}}.`;
  return d.useEffect(() => {
    var a;
    const r = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, Wa = Rl, ah = Nl, Xa = _l, _n = Tl, Tn = Dl, Dn = Fl, Mn = Gl, Zr = jl, Ll = "AlertDialog", [ih, _E] = ye(Ll, [
  El
]), mt = El(), Wl = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, o = mt(t);
  return /* @__PURE__ */ p.jsx(Wa, { ...o, ...n, modal: !0 });
};
Wl.displayName = Ll;
var sh = "AlertDialogTrigger", ch = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = mt(n);
    return /* @__PURE__ */ p.jsx(ah, { ...r, ...o, ref: t });
  }
);
ch.displayName = sh;
var lh = "AlertDialogPortal", Xl = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, o = mt(t);
  return /* @__PURE__ */ p.jsx(Xa, { ...o, ...n });
};
Xl.displayName = lh;
var uh = "AlertDialogOverlay", Hl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = mt(n);
    return /* @__PURE__ */ p.jsx(_n, { ...r, ...o, ref: t });
  }
);
Hl.displayName = uh;
var Zt = "AlertDialogContent", [dh, fh] = ih(Zt), ph = /* @__PURE__ */ Cc("AlertDialogContent"), zl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: o, ...r } = e, a = mt(n), i = d.useRef(null), s = ne(t, i), c = d.useRef(null);
    return /* @__PURE__ */ p.jsx(
      th,
      {
        contentName: Zt,
        titleName: Zl,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ p.jsx(dh, { scope: n, cancelRef: c, children: /* @__PURE__ */ p.jsxs(
          Tn,
          {
            role: "alertdialog",
            ...a,
            ...r,
            ref: s,
            onOpenAutoFocus: G(r.onOpenAutoFocus, (l) => {
              var u;
              l.preventDefault(), (u = c.current) == null || u.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (l) => l.preventDefault(),
            onInteractOutside: (l) => l.preventDefault(),
            children: [
              /* @__PURE__ */ p.jsx(ph, { children: o }),
              /* @__PURE__ */ p.jsx(mh, { contentRef: i })
            ]
          }
        ) })
      }
    );
  }
);
zl.displayName = Zt;
var Zl = "AlertDialogTitle", $l = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = mt(n);
    return /* @__PURE__ */ p.jsx(Dn, { ...r, ...o, ref: t });
  }
);
$l.displayName = Zl;
var Yl = "AlertDialogDescription", Jl = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...o } = e, r = mt(n);
  return /* @__PURE__ */ p.jsx(Mn, { ...r, ...o, ref: t });
});
Jl.displayName = Yl;
var gh = "AlertDialogAction", Ul = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, r = mt(n);
    return /* @__PURE__ */ p.jsx(Zr, { ...r, ...o, ref: t });
  }
);
Ul.displayName = gh;
var Ql = "AlertDialogCancel", Kl = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...o } = e, { cancelRef: r } = fh(Ql, n), a = mt(n), i = ne(t, r);
    return /* @__PURE__ */ p.jsx(Zr, { ...a, ...o, ref: i });
  }
);
Kl.displayName = Ql;
var mh = ({ contentRef: e }) => {
  const t = `\`${Zt}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${Zt}\` by passing a \`${Yl}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${Zt}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    var o;
    document.getElementById(
      (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, bh = Wl, vh = Xl, ql = Hl, eu = zl, tu = Ul, nu = Kl, ru = $l, ou = Jl;
const hh = bh, xh = vh, au = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  ql,
  {
    className: S(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
au.displayName = ql.displayName;
const iu = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsxs(xh, { children: [
  /* @__PURE__ */ p.jsx(au, {}),
  /* @__PURE__ */ p.jsx(
    eu,
    {
      ref: n,
      className: S(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
iu.displayName = eu.displayName;
const su = ({ className: e, ...t }) => /* @__PURE__ */ p.jsx("div", { className: S("flex flex-col space-y-2 text-center sm:text-left", e), ...t });
su.displayName = "AlertDialogHeader";
const cu = ({ className: e, ...t }) => /* @__PURE__ */ p.jsx("div", { className: S("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e), ...t });
cu.displayName = "AlertDialogFooter";
const lu = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(ru, { ref: n, className: S("text-lg font-semibold", e), ...t }));
lu.displayName = ru.displayName;
const uu = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(ou, { ref: n, className: S("text-sm text-muted-foreground", e), ...t }));
uu.displayName = ou.displayName;
const du = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(tu, { ref: n, className: S(Da(), e), ...t }));
du.displayName = tu.displayName;
const fu = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(nu, { ref: n, className: S(Da({ variant: "outline" }), "mt-2 sm:mt-0", e), ...t }));
fu.displayName = nu.displayName;
const TE = (e) => {
  const {
    isOpen: t,
    title: n = "Are you absolutely sure?",
    message: o,
    className: r = "",
    titleClassName: a = "",
    messageClassName: i = "",
    confirmClassName: s = "",
    cancelClassName: c = "",
    confirmText: l = "Confirm",
    cancelText: u = "Cancel"
  } = e;
  return /* @__PURE__ */ p.jsx(hh, { open: t, onOpenChange: e.onClose, children: /* @__PURE__ */ p.jsxs(iu, { className: S(`nyn-confirm-alert border border-border bg-card p-3 ${r}`), children: [
    /* @__PURE__ */ p.jsxs(su, { children: [
      /* @__PURE__ */ p.jsx(lu, { className: S(`nyn-confirm-alert-title text-text ${a}`), children: n }),
      /* @__PURE__ */ p.jsx(uu, { className: S(`nyn-confirm-alert-message text-text ${i}`), children: o })
    ] }),
    /* @__PURE__ */ p.jsxs(cu, { children: [
      /* @__PURE__ */ p.jsx(fu, { className: S(`text-text bg-card border border-border ${c}`), onClick: () => e.onResult(!1), children: u }),
      /* @__PURE__ */ p.jsx(du, { className: S(`text-white bg-primary border border-primary ${s}`), onClick: () => e.onResult(!0), children: l })
    ] })
  ] }) });
}, yh = Wa, Ch = Xa, pu = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  _n,
  {
    ref: n,
    className: S(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
pu.displayName = _n.displayName;
const gu = d.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ p.jsxs(Ch, { children: [
  /* @__PURE__ */ p.jsx(pu, {}),
  /* @__PURE__ */ p.jsxs(
    Tn,
    {
      ref: o,
      className: S(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ p.jsxs(Zr, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ p.jsx(Vr, { className: "h-4 w-4" }),
          /* @__PURE__ */ p.jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
gu.displayName = Tn.displayName;
const mu = ({ className: e, ...t }) => /* @__PURE__ */ p.jsx("div", { className: S("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
mu.displayName = "DialogHeader";
const bu = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Dn, { ref: n, className: S("text-lg font-semibold leading-none tracking-tight", e), ...t })
);
bu.displayName = Dn.displayName;
const Ih = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Mn, { ref: n, className: S("text-sm text-muted-foreground", e), ...t }));
Ih.displayName = Mn.displayName;
const wh = {
  [Lt.XS]: "max-w-sm",
  [Lt.SM]: "max-w-lg",
  [Lt.MD]: "max-w-2xl",
  [Lt.LG]: "max-w-4xl"
}, DE = (e) => {
  const { isOpen: t, title: n, children: o, size: r = Lt.SM, className: a = "", headerClassName: i = "", titleClassName: s = "", contentClassName: c = "" } = e;
  return /* @__PURE__ */ p.jsx(yh, { open: t, onOpenChange: e.onClose, children: /* @__PURE__ */ p.jsxs(
    gu,
    {
      className: S(`nyn-dialog p-0 gap-0 border border-border bg-card text-white rounded overflow-hidden ${wh[r]} ${a}`),
      children: [
        /* @__PURE__ */ p.jsx(mu, { className: S(`nyn-dialog-header px-3 py-2.5 bg-primary text-white ${i}`), children: /* @__PURE__ */ p.jsx(bu, { className: S(`nyn-dialog-title text-base font-normal ${s}`), children: n }) }),
        /* @__PURE__ */ p.jsx(
          "div",
          {
            className: S(
              `nyn-dialog-content text-text h-[calc(100vh_-_140px)] sm:h-auto sm:min-h-[350px] sm:max-h-[calc(100vh_-_75px)] overflow-y-auto ${c}`
            ),
            children: o
          }
        )
      ]
    }
  ) });
};
var Ah = "Separator", ls = "horizontal", Eh = ["horizontal", "vertical"], vu = d.forwardRef((e, t) => {
  const { decorative: n, orientation: o = ls, ...r } = e, a = Rh(o) ? o : ls, s = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ p.jsx(
    z.div,
    {
      "data-orientation": a,
      ...s,
      ...r,
      ref: t
    }
  );
});
vu.displayName = Ah;
function Rh(e) {
  return Eh.includes(e);
}
var hu = vu;
const xu = d.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...o }, r) => /* @__PURE__ */ p.jsx(
    hu,
    {
      ref: r,
      decorative: n,
      orientation: t,
      className: S("shrink-0 bg-border", t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", e),
      ...o
    }
  )
);
xu.displayName = hu.displayName;
const yu = (e) => {
  const { className: t = "", orientation: n = "horizontal" } = e;
  return /* @__PURE__ */ p.jsx(xu, { orientation: n, className: S(`bg-border ${t}`) });
};
var ra = /* @__PURE__ */ ((e) => (e.Pixel = "Pixel", e.Percent = "Percent", e))(ra || {});
const us = {
  unit: "Percent",
  value: 0.8
};
function ds(e) {
  return typeof e == "number" ? {
    unit: "Percent",
    value: e * 100
  } : typeof e == "string" ? e.match(/^(\d*(\.\d+)?)px$/) ? {
    unit: "Pixel",
    value: parseFloat(e)
  } : e.match(/^(\d*(\.\d+)?)%$/) ? {
    unit: "Percent",
    value: parseFloat(e)
  } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), us) : (console.warn("scrollThreshold should be string or number"), us);
}
const Sh = (e, t, n = {}) => {
  const { noTrailing: o = !1, noLeading: r = !1, debounceMode: a = void 0 } = n || {};
  let i, s = !1, c = 0;
  function l() {
    i && clearTimeout(i);
  }
  function u(g) {
    const { upcomingOnly: b = !1 } = g || {};
    l(), s = !b;
  }
  function f(...g) {
    let b = this, C = Date.now() - c;
    if (s)
      return;
    function m() {
      c = Date.now(), t.apply(b, g);
    }
    function v() {
      i = void 0;
    }
    !r && a && !i && m(), l(), a === void 0 && C > e ? r ? (c = Date.now(), o || (i = setTimeout(a ? v : m, e))) : m() : o !== !0 && (i = setTimeout(a ? v : m, a === void 0 ? e - C : e));
  }
  return f.cancel = u, f;
}, fs = (e) => ({
  ...e,
  borderRadius: 4,
  colors: {
    ...e.colors,
    neutral0: "var(--COLOR_BACKGROUND)",
    neutral10: "var(--COLOR_BORDER)",
    neutral5: "var(--COLOR_BACKGROUND)",
    neutral20: "var(--COLOR_BORDER)",
    neutral80: "var(--COLOR_TEXT)",
    primary25: "gray",
    primary: "var(--COLOR_PRIMARY)"
  }
}), ps = {
  control: (e) => "flex h-10 w-full rounded bg-card border border-border focus:border-border text-text",
  menu: (e) => "w-full rounded bg-card border border-border focus:border-border"
};
class ME extends vc {
  constructor(n) {
    super(n);
    Ie(this, "throttledOnScrollListener");
    Ie(this, "_scrollableNode");
    Ie(this, "el");
    Ie(this, "_infScroll");
    Ie(this, "lastScrollTop", 0);
    Ie(this, "actionTriggered", !1);
    Ie(this, "_pullDown");
    // variables to keep track of pull down behaviour
    Ie(this, "startY", 0);
    Ie(this, "currentY", 0);
    Ie(this, "dragging", !1);
    // will be populated in componentDidMount
    // based on the height of the pull down element
    Ie(this, "maxPullDownDistance", 0);
    Ie(this, "getScrollableTarget", () => this.props.scrollableTarget instanceof HTMLElement ? this.props.scrollableTarget : typeof this.props.scrollableTarget == "string" ? document.getElementById(this.props.scrollableTarget) : (this.props.scrollableTarget === null && console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `), null));
    Ie(this, "onStart", (n) => {
      this.lastScrollTop || (this.dragging = !0, n instanceof MouseEvent ? this.startY = n.pageY : n instanceof TouchEvent && (this.startY = n.touches[0].pageY), this.currentY = this.startY, this._infScroll && (this._infScroll.style.willChange = "transform", this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
    });
    Ie(this, "onMove", (n) => {
      this.dragging && (n instanceof MouseEvent ? this.currentY = n.pageY : n instanceof TouchEvent && (this.currentY = n.touches[0].pageY), !(this.currentY < this.startY) && (this.currentY - this.startY >= Number(this.props.pullDownToRefreshThreshold) && this.setState({
        pullToRefreshThresholdBreached: !0
      }), !(this.currentY - this.startY > this.maxPullDownDistance * 1.5) && this._infScroll && (this._infScroll.style.overflow = "visible", this._infScroll.style.transform = `translate3d(0px, ${this.currentY - this.startY}px, 0px)`)));
    });
    Ie(this, "onEnd", () => {
      this.startY = 0, this.currentY = 0, this.dragging = !1, this.state.pullToRefreshThresholdBreached && (this.props.refreshFunction && this.props.refreshFunction(), this.setState({
        pullToRefreshThresholdBreached: !1
      })), requestAnimationFrame(() => {
        this._infScroll && (this._infScroll.style.overflow = "auto", this._infScroll.style.transform = "none", this._infScroll.style.willChange = "unset");
      });
    });
    Ie(this, "onScrollListener", (n) => {
      typeof this.props.onScroll == "function" && setTimeout(() => this.props.onScroll && this.props.onScroll(n), 0);
      const o = this.props.height || this._scrollableNode ? n.target : document.documentElement.scrollTop ? document.documentElement : document.body;
      if (this.actionTriggered) return;
      (this.props.inverse ? this.isElementAtTop(o, this.props.scrollThreshold) : this.isElementAtBottom(o, this.props.scrollThreshold)) && this.props.hasMore && (this.actionTriggered = !0, this.setState({ showLoader: !0 }), this.props.next && this.props.next()), this.lastScrollTop = o.scrollTop;
    });
    this.state = {
      showLoader: !1,
      pullToRefreshThresholdBreached: !1,
      prevDataLength: n.dataLength
    }, this.throttledOnScrollListener = Sh(150, this.onScrollListener).bind(this), this.onStart = this.onStart.bind(this), this.onMove = this.onMove.bind(this), this.onEnd = this.onEnd.bind(this);
  }
  componentDidMount() {
    if (typeof this.props.dataLength > "u")
      throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
    if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function"))
      throw new Error(
        `Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`
      );
  }
  componentWillUnmount() {
    this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
  }
  componentDidUpdate(n) {
    this.props.dataLength !== n.dataLength && (this.actionTriggered = !1, this.setState({
      showLoader: !1
    }));
  }
  static getDerivedStateFromProps(n, o) {
    return n.dataLength !== o.prevDataLength ? {
      ...o,
      prevDataLength: n.dataLength
    } : null;
  }
  isElementAtTop(n, o = 0.8) {
    const r = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, a = ds(o);
    return a.unit === ra.Pixel ? n.scrollTop <= a.value + r - n.scrollHeight + 1 : n.scrollTop <= a.value / 100 + r - n.scrollHeight + 1;
  }
  isElementAtBottom(n, o = 0.8) {
    const r = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, a = ds(o);
    return a.unit === ra.Pixel ? n.scrollTop + r >= n.scrollHeight - a.value : n.scrollTop + r >= a.value / 100 * n.scrollHeight;
  }
  render() {
    const n = {
      height: this.props.height || "auto",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
      ...this.props.style
    }, o = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), r = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
    return /* @__PURE__ */ p.jsx("div", { style: r, className: "infinite-scroll-component__outerdiv", children: /* @__PURE__ */ p.jsxs(
      "div",
      {
        className: S(`infinite-scroll-component ${this.props.className || ""}`),
        ref: (a) => this._infScroll = a,
        style: n,
        children: [
          this.props.pullDownToRefresh && /* @__PURE__ */ p.jsx("div", { style: { position: "relative" }, ref: (a) => this._pullDown = a, children: /* @__PURE__ */ p.jsx(
            "div",
            {
              style: {
                position: "absolute",
                left: 0,
                right: 0,
                top: -1 * this.maxPullDownDistance
              },
              children: this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent
            }
          ) }),
          this.props.children,
          !this.state.showLoader && !o && this.props.hasMore && this.props.loader,
          this.state.showLoader && this.props.hasMore && this.props.loader,
          !this.props.hasMore && this.props.endMessage
        ]
      }
    ) });
  }
}
const Ha = d.forwardRef(({ className: e, type: t, ...n }, o) => /* @__PURE__ */ p.jsx(
  "input",
  {
    type: t,
    className: S(
      "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ref: o,
    ...n
  }
));
Ha.displayName = "Input";
var Nh = "Label", Cu = d.forwardRef((e, t) => /* @__PURE__ */ p.jsx(
  z.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var r;
      n.target.closest("button, input, select, textarea") || ((r = e.onMouseDown) == null || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Cu.displayName = Nh;
var Iu = Cu;
const Ph = en("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), Tt = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Iu, { ref: n, className: S(Ph(), e), ...t }));
Tt.displayName = Iu.displayName;
const FE = (e) => {
  const {
    type: t = "text",
    id: n = "input",
    label: o = "",
    placeholder: r = "",
    className: a = "",
    labelClassName: i = "",
    inputClassName: s = "",
    value: c = "",
    onChange: l,
    ...u
  } = e;
  return /* @__PURE__ */ p.jsxs("div", { className: S(`nyn-input-block mb-3 ${a}`), children: [
    o && /* @__PURE__ */ p.jsx(Tt, { htmlFor: n, className: S(`nyn-input-label block pb-2 text-text ${i}`), children: o }),
    /* @__PURE__ */ p.jsx(
      Ha,
      {
        type: t,
        ...c && { value: c },
        ...r && { placeholder: r },
        ...l && { onChange: l },
        ...u,
        className: S(`nyn-input w-full rounded bg-card border border-border text-text px-3 py-2 ${s}`)
      }
    )
  ] });
};
var _h = (e) => e.type === "checkbox", Th = (e) => e instanceof Date, wu = (e) => e == null;
const Dh = (e) => typeof e == "object";
var Fn = (e) => !wu(e) && !Array.isArray(e) && Dh(e) && !Th(e), Mh = (e) => Fn(e) && e.target ? _h(e.target) ? e.target.checked : e.target.value : e, Fh = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Oh = (e, t) => e.has(Fh(t)), Gh = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Fn(t) && t.hasOwnProperty("isPrototypeOf");
}, kh = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Au(e) {
  let t;
  const n = Array.isArray(e), o = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(kh && (e instanceof Blob || o)) && (n || Fn(e)))
    if (t = n ? [] : {}, !n && !Gh(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = Au(e[r]));
  else
    return e;
  return t;
}
var Eu = (e) => /^\w*$/.test(e), oa = (e) => e === void 0, jh = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Ru = (e) => jh(e.replace(/["|']|\]/g, "").split(/\.|\[/)), De = (e, t, n) => {
  if (!t || !Fn(e))
    return n;
  const o = (Eu(t) ? [t] : Ru(t)).reduce((r, a) => wu(r) ? r : r[a], e);
  return oa(o) || o === e ? oa(e[t]) ? n : e[t] : o;
}, Ro = (e) => typeof e == "boolean", gs = (e, t, n) => {
  let o = -1;
  const r = Eu(t) ? [t] : Ru(t), a = r.length, i = a - 1;
  for (; ++o < a; ) {
    const s = r[o];
    let c = n;
    if (o !== i) {
      const l = e[s];
      c = Fn(l) || Array.isArray(l) ? l : isNaN(+r[o + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = c, e = e[s];
  }
};
const ms = {
  BLUR: "blur",
  CHANGE: "change"
}, bs = {
  all: "all"
}, Su = K.createContext(null);
Su.displayName = "HookFormContext";
const za = () => K.useContext(Su);
var Vh = (e, t, n, o = !0) => {
  const r = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(r, a, {
      get: () => {
        const i = a;
        return t._proxyFormState[i] !== bs.all && (t._proxyFormState[i] = !o || bs.all), n && (n[i] = !0), e[i];
      }
    });
  return r;
};
const Nu = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function Bh(e) {
  const t = za(), { control: n = t.control, disabled: o, name: r, exact: a } = e || {}, [i, s] = K.useState(n._formState), c = K.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return Nu(() => n._subscribe({
    name: r,
    formState: c.current,
    exact: a,
    callback: (l) => {
      !o && s({
        ...n._formState,
        ...l
      });
    }
  }), [r, o, a]), K.useEffect(() => {
    c.current.isValid && n._setValid(!0);
  }, [n]), K.useMemo(() => Vh(i, n, c.current, !1), [i, n]);
}
var Lh = (e) => typeof e == "string", Wh = (e, t, n, o, r) => Lh(e) ? De(n, e, r) : Array.isArray(e) ? e.map((a) => De(n, a)) : n;
function Xh(e) {
  const t = za(), { control: n = t.control, name: o, defaultValue: r, disabled: a, exact: i } = e || {}, s = K.useRef(r), [c, l] = K.useState(n._getWatch(o, s.current));
  return Nu(() => n._subscribe({
    name: o,
    formState: {
      values: !0
    },
    exact: i,
    callback: (u) => !a && l(Wh(o, n._names, u.values || n._formValues, !1, s.current))
  }), [o, n, a, i]), K.useEffect(() => n._removeUnmounted()), c;
}
function Hh(e) {
  const t = za(), { name: n, disabled: o, control: r = t.control, shouldUnregister: a } = e, i = Oh(r._names.array, n), s = Xh({
    control: r,
    name: n,
    defaultValue: De(r._formValues, n, De(r._defaultValues, n, e.defaultValue)),
    exact: !0
  }), c = Bh({
    control: r,
    name: n,
    exact: !0
  }), l = K.useRef(e), u = K.useRef(r.register(n, {
    ...e.rules,
    value: s,
    ...Ro(e.disabled) ? { disabled: e.disabled } : {}
  })), f = K.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!De(c.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!De(c.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!De(c.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!De(c.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => De(c.errors, n)
    }
  }), [c, n]), g = K.useCallback((v) => u.current.onChange({
    target: {
      value: Mh(v),
      name: n
    },
    type: ms.CHANGE
  }), [n]), b = K.useCallback(() => u.current.onBlur({
    target: {
      value: De(r._formValues, n),
      name: n
    },
    type: ms.BLUR
  }), [n, r._formValues]), C = K.useCallback((v) => {
    const h = De(r._fields, n);
    h && v && (h._f.ref = {
      focus: () => v.focus && v.focus(),
      select: () => v.select && v.select(),
      setCustomValidity: (I) => v.setCustomValidity(I),
      reportValidity: () => v.reportValidity()
    });
  }, [r._fields, n]), m = K.useMemo(() => ({
    name: n,
    value: s,
    ...Ro(o) || c.disabled ? { disabled: c.disabled || o } : {},
    onChange: g,
    onBlur: b,
    ref: C
  }), [n, o, c.disabled, g, b, C, s]);
  return K.useEffect(() => {
    const v = r._options.shouldUnregister || a;
    r.register(n, {
      ...l.current.rules,
      ...Ro(l.current.disabled) ? { disabled: l.current.disabled } : {}
    });
    const h = (I, x) => {
      const y = De(r._fields, I);
      y && y._f && (y._f.mount = x);
    };
    if (h(n, !0), v) {
      const I = Au(De(r._options.defaultValues, n));
      gs(r._defaultValues, n, I), oa(De(r._formValues, n)) && gs(r._formValues, n, I);
    }
    return !i && r.register(n), () => {
      (i ? v && !r._state.action : v) ? r.unregister(n) : h(n, !1);
    };
  }, [n, r, i, a]), K.useEffect(() => {
    r._setDisabledField({
      disabled: o,
      name: n
    });
  }, [o, n, r]), K.useMemo(() => ({
    field: m,
    formState: c,
    fieldState: f
  }), [m, c, f]);
}
const zh = (e) => e.render(Hh(e)), OE = (e) => {
  const {
    control: t,
    rules: n,
    errors: o = {},
    name: r,
    type: a = "text",
    id: i = "form-input",
    label: s = "",
    placeholder: c = "",
    className: l = "",
    labelClassName: u = "",
    inputClassName: f = "",
    ...g
  } = e;
  return /* @__PURE__ */ p.jsx(
    zh,
    {
      control: t,
      name: r,
      render: ({ field: { onChange: b, value: C, onBlur: m } }) => /* @__PURE__ */ p.jsxs("div", { className: S(`nyn-form-input-block ${l}`), children: [
        s && /* @__PURE__ */ p.jsx(Tt, { htmlFor: i, className: S(`nyn-form-input-label block pb-2 text-text ${u}`), children: s }),
        /* @__PURE__ */ p.jsx(
          Ha,
          {
            type: a,
            onChange: b,
            onBlur: m,
            ...C && { value: C },
            ...c && { placeholder: c },
            ...g,
            className: S(`nyn-form-input w-full rounded bg-card border border-border text-text px-3 py-2 ${f}`)
          }
        )
      ] })
    }
  );
}, GE = (e) => {
  const { className: t = "", children: n, href: o = "" } = e;
  return o ? /* @__PURE__ */ p.jsx("a", { role: "link", className: S(`nyn-link text-primary cursor-pointer ${t}`), href: o, target: "_blank", children: n }) : /* @__PURE__ */ p.jsx("span", { role: "link", className: S(`nyn-link text-primary cursor-pointer ${t}`), onClick: e.onClick, children: n });
};
var Kn = {}, qn = {}, er = {}, vs;
function Zh() {
  if (vs) return er;
  vs = 1, Object.defineProperty(er, "__esModule", {
    value: !0
  });
  var e = K, t = n(e);
  function n(o) {
    if (o && o.__esModule)
      return o;
    var r = {};
    if (o != null)
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
    return r.default = o, r;
  }
  return er.default = function(o, r, a) {
    return t.createElement(
      "a",
      { href: o, key: a },
      r
    );
  }, er;
}
var tr = {}, hs;
function $h() {
  return hs || (hs = 1, Object.defineProperty(tr, "__esModule", {
    value: !0
  }), tr.default = function(e) {
    return e;
  }), tr;
}
var nr = {}, So, xs;
function Yh() {
  return xs || (xs = 1, So = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), So;
}
var No, ys;
function Jh() {
  return ys || (ys = 1, No = /[\0-\x1F\x7F-\x9F]/), No;
}
var Po, Cs;
function Uh() {
  return Cs || (Cs = 1, Po = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), Po;
}
var _o, Is;
function Qh() {
  return Is || (Is = 1, _o = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/), _o;
}
var To, ws;
function Kh() {
  return ws || (ws = 1, To = function(e) {
    var t = {};
    t.src_Any = Yh().source, t.src_Cc = Jh().source, t.src_Z = Uh().source, t.src_P = Qh().source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
    var n = "[><｜]";
    return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!" + t.src_ZCc + "|[.]).|" + (e && e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + "\\,(?!" + t.src_ZCc + ").|\\!(?!" + t.src_ZCc + "|[!]).|\\?(?!" + t.src_ZCc + "|[?]).)+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
  }), To;
}
var Do, As;
function qh() {
  if (As) return Do;
  As = 1;
  function e(x) {
    var y = Array.prototype.slice.call(arguments, 1);
    return y.forEach(function(w) {
      w && Object.keys(w).forEach(function(R) {
        x[R] = w[R];
      });
    }), x;
  }
  function t(x) {
    return Object.prototype.toString.call(x);
  }
  function n(x) {
    return t(x) === "[object String]";
  }
  function o(x) {
    return t(x) === "[object Object]";
  }
  function r(x) {
    return t(x) === "[object RegExp]";
  }
  function a(x) {
    return t(x) === "[object Function]";
  }
  function i(x) {
    return x.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }
  var s = {
    fuzzyLink: !0,
    fuzzyEmail: !0,
    fuzzyIP: !1
  };
  function c(x) {
    return Object.keys(x || {}).reduce(function(y, w) {
      return y || s.hasOwnProperty(w);
    }, !1);
  }
  var l = {
    "http:": {
      validate: function(x, y, w) {
        var R = x.slice(y);
        return w.re.http || (w.re.http = new RegExp(
          "^\\/\\/" + w.re.src_auth + w.re.src_host_port_strict + w.re.src_path,
          "i"
        )), w.re.http.test(R) ? R.match(w.re.http)[0].length : 0;
      }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
      validate: function(x, y, w) {
        var R = x.slice(y);
        return w.re.no_http || (w.re.no_http = new RegExp(
          "^" + w.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          "(?:localhost|(?:(?:" + w.re.src_domain + ")\\.)+" + w.re.src_domain_root + ")" + w.re.src_port + w.re.src_host_terminator + w.re.src_path,
          "i"
        )), w.re.no_http.test(R) ? y >= 3 && x[y - 3] === ":" || y >= 3 && x[y - 3] === "/" ? 0 : R.match(w.re.no_http)[0].length : 0;
      }
    },
    "mailto:": {
      validate: function(x, y, w) {
        var R = x.slice(y);
        return w.re.mailto || (w.re.mailto = new RegExp(
          "^" + w.re.src_email_name + "@" + w.re.src_host_strict,
          "i"
        )), w.re.mailto.test(R) ? R.match(w.re.mailto)[0].length : 0;
      }
    }
  }, u = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", f = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
  function g(x) {
    x.__index__ = -1, x.__text_cache__ = "";
  }
  function b(x) {
    return function(y, w) {
      var R = y.slice(w);
      return x.test(R) ? R.match(x)[0].length : 0;
    };
  }
  function C() {
    return function(x, y) {
      y.normalize(x);
    };
  }
  function m(x) {
    var y = x.re = Kh()(x.__opts__), w = x.__tlds__.slice();
    x.onCompile(), x.__tlds_replaced__ || w.push(u), w.push(y.src_xn), y.src_tlds = w.join("|");
    function R(D) {
      return D.replace("%TLDS%", y.src_tlds);
    }
    y.email_fuzzy = RegExp(R(y.tpl_email_fuzzy), "i"), y.link_fuzzy = RegExp(R(y.tpl_link_fuzzy), "i"), y.link_no_ip_fuzzy = RegExp(R(y.tpl_link_no_ip_fuzzy), "i"), y.host_fuzzy_test = RegExp(R(y.tpl_host_fuzzy_test), "i");
    var E = [];
    x.__compiled__ = {};
    function N(D, O) {
      throw new Error('(LinkifyIt) Invalid schema "' + D + '": ' + O);
    }
    Object.keys(x.__schemas__).forEach(function(D) {
      var O = x.__schemas__[D];
      if (O !== null) {
        var T = { validate: null, link: null };
        if (x.__compiled__[D] = T, o(O)) {
          r(O.validate) ? T.validate = b(O.validate) : a(O.validate) ? T.validate = O.validate : N(D, O), a(O.normalize) ? T.normalize = O.normalize : O.normalize ? N(D, O) : T.normalize = C();
          return;
        }
        if (n(O)) {
          E.push(D);
          return;
        }
        N(D, O);
      }
    }), E.forEach(function(D) {
      x.__compiled__[x.__schemas__[D]] && (x.__compiled__[D].validate = x.__compiled__[x.__schemas__[D]].validate, x.__compiled__[D].normalize = x.__compiled__[x.__schemas__[D]].normalize);
    }), x.__compiled__[""] = { validate: null, normalize: C() };
    var _ = Object.keys(x.__compiled__).filter(function(D) {
      return D.length > 0 && x.__compiled__[D];
    }).map(i).join("|");
    x.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + y.src_ZPCc + "))(" + _ + ")", "i"), x.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + y.src_ZPCc + "))(" + _ + ")", "ig"), x.re.pretest = RegExp(
      "(" + x.re.schema_test.source + ")|(" + x.re.host_fuzzy_test.source + ")|@",
      "i"
    ), g(x);
  }
  function v(x, y) {
    var w = x.__index__, R = x.__last_index__, E = x.__text_cache__.slice(w, R);
    this.schema = x.__schema__.toLowerCase(), this.index = w + y, this.lastIndex = R + y, this.raw = E, this.text = E, this.url = E;
  }
  function h(x, y) {
    var w = new v(x, y);
    return x.__compiled__[w.schema].normalize(w, x), w;
  }
  function I(x, y) {
    if (!(this instanceof I))
      return new I(x, y);
    y || c(x) && (y = x, x = {}), this.__opts__ = e({}, s, y), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = e({}, l, x), this.__compiled__ = {}, this.__tlds__ = f, this.__tlds_replaced__ = !1, this.re = {}, m(this);
  }
  return I.prototype.add = function(y, w) {
    return this.__schemas__[y] = w, m(this), this;
  }, I.prototype.set = function(y) {
    return this.__opts__ = e(this.__opts__, y), this;
  }, I.prototype.test = function(y) {
    if (this.__text_cache__ = y, this.__index__ = -1, !y.length)
      return !1;
    var w, R, E, N, _, D, O, T, L;
    if (this.re.schema_test.test(y)) {
      for (O = this.re.schema_search, O.lastIndex = 0; (w = O.exec(y)) !== null; )
        if (N = this.testSchemaAt(y, w[2], O.lastIndex), N) {
          this.__schema__ = w[2], this.__index__ = w.index + w[1].length, this.__last_index__ = w.index + w[0].length + N;
          break;
        }
    }
    return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (T = y.search(this.re.host_fuzzy_test), T >= 0 && (this.__index__ < 0 || T < this.__index__) && (R = y.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (_ = R.index + R[1].length, (this.__index__ < 0 || _ < this.__index__) && (this.__schema__ = "", this.__index__ = _, this.__last_index__ = R.index + R[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (L = y.indexOf("@"), L >= 0 && (E = y.match(this.re.email_fuzzy)) !== null && (_ = E.index + E[1].length, D = E.index + E[0].length, (this.__index__ < 0 || _ < this.__index__ || _ === this.__index__ && D > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = _, this.__last_index__ = D))), this.__index__ >= 0;
  }, I.prototype.pretest = function(y) {
    return this.re.pretest.test(y);
  }, I.prototype.testSchemaAt = function(y, w, R) {
    return this.__compiled__[w.toLowerCase()] ? this.__compiled__[w.toLowerCase()].validate(y, R, this) : 0;
  }, I.prototype.match = function(y) {
    var w = 0, R = [];
    this.__index__ >= 0 && this.__text_cache__ === y && (R.push(h(this, w)), w = this.__last_index__);
    for (var E = w ? y.slice(w) : y; this.test(E); )
      R.push(h(this, w)), E = E.slice(this.__last_index__), w += this.__last_index__;
    return R.length ? R : null;
  }, I.prototype.tlds = function(y, w) {
    return y = Array.isArray(y) ? y : [y], w ? (this.__tlds__ = this.__tlds__.concat(y).sort().filter(function(R, E, N) {
      return R !== N[E - 1];
    }).reverse(), m(this), this) : (this.__tlds__ = y.slice(), this.__tlds_replaced__ = !0, m(this), this);
  }, I.prototype.normalize = function(y) {
    y.schema || (y.url = "http://" + y.url), y.schema === "mailto:" && !/^mailto:/i.test(y.url) && (y.url = "mailto:" + y.url);
  }, I.prototype.onCompile = function() {
  }, Do = I, Do;
}
const ex = /* @__PURE__ */ JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","vermögensberater","vermögensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","ελ","ευ","бг","бел","дети","ею","католик","ком","мкд","мон","москва","онлайн","орг","рус","рф","сайт","срб","укр","қаз","հայ","ישראל","קום","ابوظبي","ارامكو","الاردن","البحرين","الجزائر","السعودية","العليان","المغرب","امارات","ایران","بارت","بازار","بيتك","بھارت","تونس","سودان","سورية","شبكة","عراق","عرب","عمان","فلسطين","قطر","كاثوليك","كوم","مصر","مليسيا","موريتانيا","موقع","همراه","پاکستان","ڀارت","कॉम","नेट","भारत","भारतम्","भारोत","संगठन","বাংলা","ভারত","ভাৰত","ਭਾਰਤ","ભારત","ଭାରତ","இந்தியா","இலங்கை","சிங்கப்பூர்","భారత్","ಭಾರತ","ഭാരതം","ලංකා","คอม","ไทย","ລາວ","გე","みんな","アマゾン","クラウド","グーグル","コム","ストア","セール","ファッション","ポイント","世界","中信","中国","中國","中文网","亚马逊","企业","佛山","信息","健康","八卦","公司","公益","台湾","台灣","商城","商店","商标","嘉里","嘉里大酒店","在线","大拿","天主教","娱乐","家電","广东","微博","慈善","我爱你","手机","招聘","政务","政府","新加坡","新闻","时尚","書籍","机构","淡马锡","游戏","澳門","点看","移动","组织机构","网址","网店","网站","网络","联通","谷歌","购物","通販","集团","電訊盈科","飞利浦","食品","餐厅","香格里拉","香港","닷넷","닷컴","삼성","한국"]');
var Es;
function tx() {
  if (Es) return nr;
  Es = 1, Object.defineProperty(nr, "__esModule", {
    value: !0
  });
  var e = qh(), t = r(e), n = ex, o = r(n);
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = new t.default();
  return a.tlds(o.default), nr.default = function(i) {
    return a.match(i);
  }, nr;
}
var rr = {}, Rs;
function nx() {
  return Rs || (Rs = 1, Object.defineProperty(rr, "__esModule", {
    value: !0
  }), rr.default = function(e) {
    return e;
  }), rr;
}
var Ss;
function rx() {
  if (Ss) return qn;
  Ss = 1, Object.defineProperty(qn, "__esModule", {
    value: !0
  });
  var e = /* @__PURE__ */ function() {
    function h(I, x) {
      for (var y = 0; y < x.length; y++) {
        var w = x[y];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(I, w.key, w);
      }
    }
    return function(I, x, y) {
      return x && h(I.prototype, x), y && h(I, y), I;
    };
  }(), t = K, n = g(t), o = Zh(), r = f(o), a = $h(), i = f(a), s = tx(), c = f(s), l = nx(), u = f(l);
  function f(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function g(h) {
    if (h && h.__esModule)
      return h;
    var I = {};
    if (h != null)
      for (var x in h)
        Object.prototype.hasOwnProperty.call(h, x) && (I[x] = h[x]);
    return I.default = h, I;
  }
  function b(h, I) {
    if (!(h instanceof I))
      throw new TypeError("Cannot call a class as a function");
  }
  function C(h, I) {
    if (!h)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return I && (typeof I == "object" || typeof I == "function") ? I : h;
  }
  function m(h, I) {
    if (typeof I != "function" && I !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof I);
    h.prototype = Object.create(I && I.prototype, { constructor: { value: h, enumerable: !1, writable: !0, configurable: !0 } }), I && (Object.setPrototypeOf ? Object.setPrototypeOf(h, I) : h.__proto__ = I);
  }
  var v = function(h) {
    m(I, h);
    function I() {
      return b(this, I), C(this, (I.__proto__ || Object.getPrototypeOf(I)).apply(this, arguments));
    }
    return e(I, [{
      key: "parseString",
      value: function(y) {
        var w = this;
        if (y === "")
          return y;
        var R = this.props.matchDecorator(y);
        if (!R)
          return y;
        var E = [], N = 0;
        return R.forEach(function(_, D) {
          _.index > N && E.push(y.substring(N, _.index));
          var O = w.props.hrefDecorator(_.url), T = w.props.textDecorator(_.text), L = w.props.componentDecorator(O, T, D);
          E.push(L), N = _.lastIndex;
        }), y.length > N && E.push(y.substring(N)), E.length === 1 ? E[0] : E;
      }
    }, {
      key: "parse",
      value: function(y) {
        var w = this, R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return typeof y == "string" ? this.parseString(y) : n.isValidElement(y) && y.type !== "a" && y.type !== "button" ? n.cloneElement(y, { key: R }, this.parse(y.props.children)) : Array.isArray(y) ? y.map(function(E, N) {
          return w.parse(E, N);
        }) : y;
      }
    }, {
      key: "render",
      value: function() {
        return n.createElement(
          n.Fragment,
          null,
          this.parse(this.props.children)
        );
      }
    }]), I;
  }(n.Component);
  return v.defaultProps = {
    componentDecorator: r.default,
    hrefDecorator: i.default,
    matchDecorator: c.default,
    textDecorator: u.default
  }, qn.default = v, qn;
}
var Ns;
function ox() {
  if (Ns) return Kn;
  Ns = 1, Object.defineProperty(Kn, "__esModule", {
    value: !0
  });
  var e = rx(), t = n(e);
  function n(o) {
    return o && o.__esModule ? o : { default: o };
  }
  return Kn.default = t.default, Kn;
}
var ax = ox();
const ix = /* @__PURE__ */ dm(ax), kE = (e) => /* @__PURE__ */ p.jsx(
  ix,
  {
    componentDecorator: (t, n, o) => /* @__PURE__ */ p.jsx("a", { className: S(`text-primary ${e.className}`), target: "_blank", href: t, children: n }, o),
    children: e.children
  }
), jE = (e) => /* @__PURE__ */ p.jsx("div", { className: "p-3", children: /* @__PURE__ */ p.jsx(
  "div",
  {
    className: S(
      `animation-loader relative text-slate-400 text-[5px] h-[1em] w-[1em] my-[20px] mx-auto -indent-[999em] rounded-full ${e.className}`
    ),
    children: "Loading..."
  }
) }), Mo = () => typeof window < "u";
function sx(e, t, n) {
  const o = ut(() => ({
    serializer: JSON.stringify,
    parser: JSON.parse,
    logger: console.log,
    syncData: !0,
    ...n
  }), [n]), { serializer: r, parser: a, logger: i, syncData: s } = o, c = qe(null), [l, u] = dt(() => {
    if (!Mo()) return t;
    try {
      return c.current = window.localStorage.getItem(e), c.current ? a(c.current) : t;
    } catch (f) {
      return i(f), t;
    }
  });
  return hn(() => {
    if (!Mo()) return;
    const f = () => {
      if (l !== void 0) {
        const g = r(l), b = c.current;
        c.current = g, window.localStorage.setItem(e, g), window.dispatchEvent(
          new StorageEvent("storage", {
            storageArea: window.localStorage,
            url: window.location.href,
            key: e,
            newValue: g,
            oldValue: b
          })
        );
      } else
        window.localStorage.removeItem(e), window.dispatchEvent(
          new StorageEvent("storage", {
            storageArea: window.localStorage,
            url: window.location.href,
            key: e
          })
        );
    };
    try {
      f();
    } catch (g) {
      i(g);
    }
  }, [l]), hn(() => {
    if (!s) return;
    const f = (g) => {
      if (!(g.key !== e || g.storageArea !== window.localStorage))
        try {
          g.newValue !== c.current && (c.current = g.newValue, u(g.newValue ? a(g.newValue) : void 0));
        } catch (b) {
          i(b);
        }
    };
    if (Mo())
      return window.addEventListener("storage", f), () => window.removeEventListener("storage", f);
  }, [e, s]), [l, u];
}
const cx = ["top", "right", "bottom", "left"], xt = Math.min, ke = Math.max, Cr = Math.round, or = Math.floor, tt = (e) => ({
  x: e,
  y: e
}), lx = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ux = {
  start: "end",
  end: "start"
};
function aa(e, t, n) {
  return ke(e, xt(t, n));
}
function pt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function gt(e) {
  return e.split("-")[0];
}
function nn(e) {
  return e.split("-")[1];
}
function Za(e) {
  return e === "x" ? "y" : "x";
}
function $a(e) {
  return e === "y" ? "height" : "width";
}
function et(e) {
  return ["top", "bottom"].includes(gt(e)) ? "y" : "x";
}
function Ya(e) {
  return Za(et(e));
}
function dx(e, t, n) {
  n === void 0 && (n = !1);
  const o = nn(e), r = Ya(e), a = $a(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Ir(i)), [i, Ir(i)];
}
function fx(e) {
  const t = Ir(e);
  return [ia(e), t, ia(t)];
}
function ia(e) {
  return e.replace(/start|end/g, (t) => ux[t]);
}
function px(e, t, n) {
  const o = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function gx(e, t, n, o) {
  const r = nn(e);
  let a = px(gt(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(ia)))), a;
}
function Ir(e) {
  return e.replace(/left|right|bottom|top/g, (t) => lx[t]);
}
function mx(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Pu(e) {
  return typeof e != "number" ? mx(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function wr(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function Ps(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = et(t), i = Ya(t), s = $a(i), c = gt(t), l = a === "y", u = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, g = o[s] / 2 - r[s] / 2;
  let b;
  switch (c) {
    case "top":
      b = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      b = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      b = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      b = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      b = {
        x: o.x,
        y: o.y
      };
  }
  switch (nn(t)) {
    case "start":
      b[i] -= g * (n && l ? -1 : 1);
      break;
    case "end":
      b[i] += g * (n && l ? -1 : 1);
      break;
  }
  return b;
}
const bx = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: u,
    y: f
  } = Ps(l, o, c), g = o, b = {}, C = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: v,
      fn: h
    } = s[m], {
      x: I,
      y: x,
      data: y,
      reset: w
    } = await h({
      x: u,
      y: f,
      initialPlacement: o,
      placement: g,
      strategy: r,
      middlewareData: b,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = I ?? u, f = x ?? f, b = {
      ...b,
      [v]: {
        ...b[v],
        ...y
      }
    }, w && C <= 50 && (C++, typeof w == "object" && (w.placement && (g = w.placement), w.rects && (l = w.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : w.rects), {
      x: u,
      y: f
    } = Ps(l, g, c)), m = -1);
  }
  return {
    x: u,
    y: f,
    placement: g,
    strategy: r,
    middlewareData: b
  };
};
async function xn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: g = !1,
    padding: b = 0
  } = pt(t, e), C = Pu(b), v = s[g ? f === "floating" ? "reference" : "floating" : f], h = wr(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), I = f === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), y = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = wr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: I,
    offsetParent: x,
    strategy: c
  }) : I);
  return {
    top: (h.top - w.top + C.top) / y.y,
    bottom: (w.bottom - h.bottom + C.bottom) / y.y,
    left: (h.left - w.left + C.left) / y.x,
    right: (w.right - h.right + C.right) / y.x
  };
}
const vx = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = pt(e, t) || {};
    if (l == null)
      return {};
    const f = Pu(u), g = {
      x: n,
      y: o
    }, b = Ya(r), C = $a(b), m = await i.getDimensions(l), v = b === "y", h = v ? "top" : "left", I = v ? "bottom" : "right", x = v ? "clientHeight" : "clientWidth", y = a.reference[C] + a.reference[b] - g[b] - a.floating[C], w = g[b] - a.reference[b], R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let E = R ? R[x] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(R))) && (E = s.floating[x] || a.floating[C]);
    const N = y / 2 - w / 2, _ = E / 2 - m[C] / 2 - 1, D = xt(f[h], _), O = xt(f[I], _), T = D, L = E - m[C] - O, M = E / 2 - m[C] / 2 + N, B = aa(T, M, L), k = !c.arrow && nn(r) != null && M !== B && a.reference[C] / 2 - (M < T ? D : O) - m[C] / 2 < 0, $ = k ? M < T ? M - T : M - L : 0;
    return {
      [b]: g[b] + $,
      data: {
        [b]: B,
        centerOffset: M - B - $,
        ...k && {
          alignmentOffset: $
        }
      },
      reset: k
    };
  }
}), hx = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: g,
        fallbackStrategy: b = "bestFit",
        fallbackAxisSideDirection: C = "none",
        flipAlignment: m = !0,
        ...v
      } = pt(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const h = gt(r), I = et(s), x = gt(s) === s, y = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), w = g || (x || !m ? [Ir(s)] : fx(s)), R = C !== "none";
      !g && R && w.push(...gx(s, m, C, y));
      const E = [s, ...w], N = await xn(t, v), _ = [];
      let D = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (u && _.push(N[h]), f) {
        const M = dx(r, i, y);
        _.push(N[M[0]], N[M[1]]);
      }
      if (D = [...D, {
        placement: r,
        overflows: _
      }], !_.every((M) => M <= 0)) {
        var O, T;
        const M = (((O = a.flip) == null ? void 0 : O.index) || 0) + 1, B = E[M];
        if (B && (!(f === "alignment" ? I !== et(B) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((j) => j.overflows[0] > 0 && et(j.placement) === I)))
          return {
            data: {
              index: M,
              overflows: D
            },
            reset: {
              placement: B
            }
          };
        let k = (T = D.filter(($) => $.overflows[0] <= 0).sort(($, j) => $.overflows[1] - j.overflows[1])[0]) == null ? void 0 : T.placement;
        if (!k)
          switch (b) {
            case "bestFit": {
              var L;
              const $ = (L = D.filter((j) => {
                if (R) {
                  const F = et(j.placement);
                  return F === I || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((j) => [j.placement, j.overflows.filter((F) => F > 0).reduce((F, U) => F + U, 0)]).sort((j, F) => j[1] - F[1])[0]) == null ? void 0 : L[0];
              $ && (k = $);
              break;
            }
            case "initialPlacement":
              k = s;
              break;
          }
        if (r !== k)
          return {
            reset: {
              placement: k
            }
          };
      }
      return {};
    }
  };
};
function _s(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ts(e) {
  return cx.some((t) => e[t] >= 0);
}
const xx = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = pt(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await xn(t, {
            ...r,
            elementContext: "reference"
          }), i = _s(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Ts(i)
            }
          };
        }
        case "escaped": {
          const a = await xn(t, {
            ...r,
            altBoundary: !0
          }), i = _s(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Ts(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function yx(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = gt(n), s = nn(n), c = et(n) === "y", l = ["left", "top"].includes(i) ? -1 : 1, u = a && c ? -1 : 1, f = pt(t, e);
  let {
    mainAxis: g,
    crossAxis: b,
    alignmentAxis: C
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof C == "number" && (b = s === "end" ? C * -1 : C), c ? {
    x: b * u,
    y: g * l
  } : {
    x: g * l,
    y: b * u
  };
}
const Cx = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: s
      } = t, c = await yx(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: r + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Ix = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: h,
              y: I
            } = v;
            return {
              x: h,
              y: I
            };
          }
        },
        ...c
      } = pt(e, t), l = {
        x: n,
        y: o
      }, u = await xn(t, c), f = et(gt(r)), g = Za(f);
      let b = l[g], C = l[f];
      if (a) {
        const v = g === "y" ? "top" : "left", h = g === "y" ? "bottom" : "right", I = b + u[v], x = b - u[h];
        b = aa(I, b, x);
      }
      if (i) {
        const v = f === "y" ? "top" : "left", h = f === "y" ? "bottom" : "right", I = C + u[v], x = C - u[h];
        C = aa(I, C, x);
      }
      const m = s.fn({
        ...t,
        [g]: b,
        [f]: C
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - o,
          enabled: {
            [g]: a,
            [f]: i
          }
        }
      };
    }
  };
}, wx = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = pt(e, t), u = {
        x: n,
        y: o
      }, f = et(r), g = Za(f);
      let b = u[g], C = u[f];
      const m = pt(s, t), v = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (c) {
        const x = g === "y" ? "height" : "width", y = a.reference[g] - a.floating[x] + v.mainAxis, w = a.reference[g] + a.reference[x] - v.mainAxis;
        b < y ? b = y : b > w && (b = w);
      }
      if (l) {
        var h, I;
        const x = g === "y" ? "width" : "height", y = ["top", "left"].includes(gt(r)), w = a.reference[f] - a.floating[x] + (y && ((h = i.offset) == null ? void 0 : h[f]) || 0) + (y ? 0 : v.crossAxis), R = a.reference[f] + a.reference[x] + (y ? 0 : ((I = i.offset) == null ? void 0 : I[f]) || 0) - (y ? v.crossAxis : 0);
        C < w ? C = w : C > R && (C = R);
      }
      return {
        [g]: b,
        [f]: C
      };
    }
  };
}, Ax = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = pt(e, t), u = await xn(t, l), f = gt(r), g = nn(r), b = et(r) === "y", {
        width: C,
        height: m
      } = a.floating;
      let v, h;
      f === "top" || f === "bottom" ? (v = f, h = g === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (h = f, v = g === "end" ? "top" : "bottom");
      const I = m - u.top - u.bottom, x = C - u.left - u.right, y = xt(m - u[v], I), w = xt(C - u[h], x), R = !t.middlewareData.shift;
      let E = y, N = w;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (N = x), (o = t.middlewareData.shift) != null && o.enabled.y && (E = I), R && !g) {
        const D = ke(u.left, 0), O = ke(u.right, 0), T = ke(u.top, 0), L = ke(u.bottom, 0);
        b ? N = C - 2 * (D !== 0 || O !== 0 ? D + O : ke(u.left, u.right)) : E = m - 2 * (T !== 0 || L !== 0 ? T + L : ke(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: N,
        availableHeight: E
      });
      const _ = await i.getDimensions(s.floating);
      return C !== _.width || m !== _.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function $r() {
  return typeof window < "u";
}
function rn(e) {
  return _u(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ve(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function it(e) {
  var t;
  return (t = (_u(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _u(e) {
  return $r() ? e instanceof Node || e instanceof Ve(e).Node : !1;
}
function Ze(e) {
  return $r() ? e instanceof Element || e instanceof Ve(e).Element : !1;
}
function ot(e) {
  return $r() ? e instanceof HTMLElement || e instanceof Ve(e).HTMLElement : !1;
}
function Ds(e) {
  return !$r() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ve(e).ShadowRoot;
}
function On(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = $e(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function Ex(e) {
  return ["table", "td", "th"].includes(rn(e));
}
function Yr(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ja(e) {
  const t = Ua(), n = Ze(e) ? $e(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Rx(e) {
  let t = yt(e);
  for (; ot(t) && !Ut(t); ) {
    if (Ja(t))
      return t;
    if (Yr(t))
      return null;
    t = yt(t);
  }
  return null;
}
function Ua() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ut(e) {
  return ["html", "body", "#document"].includes(rn(e));
}
function $e(e) {
  return Ve(e).getComputedStyle(e);
}
function Jr(e) {
  return Ze(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function yt(e) {
  if (rn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ds(e) && e.host || // Fallback.
    it(e)
  );
  return Ds(t) ? t.host : t;
}
function Tu(e) {
  const t = yt(e);
  return Ut(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ot(t) && On(t) ? t : Tu(t);
}
function yn(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Tu(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = Ve(r);
  if (a) {
    const s = sa(i);
    return t.concat(i, i.visualViewport || [], On(r) ? r : [], s && n ? yn(s) : []);
  }
  return t.concat(r, yn(r, [], n));
}
function sa(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Du(e) {
  const t = $e(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = ot(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, s = Cr(n) !== a || Cr(o) !== i;
  return s && (n = a, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function Qa(e) {
  return Ze(e) ? e : e.contextElement;
}
function $t(e) {
  const t = Qa(e);
  if (!ot(t))
    return tt(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = Du(t);
  let i = (a ? Cr(n.width) : n.width) / o, s = (a ? Cr(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Sx = /* @__PURE__ */ tt(0);
function Mu(e) {
  const t = Ve(e);
  return !Ua() || !t.visualViewport ? Sx : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Nx(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ve(e) ? !1 : t;
}
function Nt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = Qa(e);
  let i = tt(1);
  t && (o ? Ze(o) && (i = $t(o)) : i = $t(e));
  const s = Nx(a, n, o) ? Mu(a) : tt(0);
  let c = (r.left + s.x) / i.x, l = (r.top + s.y) / i.y, u = r.width / i.x, f = r.height / i.y;
  if (a) {
    const g = Ve(a), b = o && Ze(o) ? Ve(o) : o;
    let C = g, m = sa(C);
    for (; m && o && b !== C; ) {
      const v = $t(m), h = m.getBoundingClientRect(), I = $e(m), x = h.left + (m.clientLeft + parseFloat(I.paddingLeft)) * v.x, y = h.top + (m.clientTop + parseFloat(I.paddingTop)) * v.y;
      c *= v.x, l *= v.y, u *= v.x, f *= v.y, c += x, l += y, C = Ve(m), m = sa(C);
    }
  }
  return wr({
    width: u,
    height: f,
    x: c,
    y: l
  });
}
function Ka(e, t) {
  const n = Jr(e).scrollLeft;
  return t ? t.left + n : Nt(it(e)).left + n;
}
function Fu(e, t, n) {
  n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), r = o.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Ka(e, o)
  )), a = o.top + t.scrollTop;
  return {
    x: r,
    y: a
  };
}
function Px(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = it(o), s = t ? Yr(t.floating) : !1;
  if (o === i || s && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = tt(1);
  const u = tt(0), f = ot(o);
  if ((f || !f && !a) && ((rn(o) !== "body" || On(i)) && (c = Jr(o)), ot(o))) {
    const b = Nt(o);
    l = $t(o), u.x = b.x + o.clientLeft, u.y = b.y + o.clientTop;
  }
  const g = i && !f && !a ? Fu(i, c, !0) : tt(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + u.x + g.x,
    y: n.y * l.y - c.scrollTop * l.y + u.y + g.y
  };
}
function _x(e) {
  return Array.from(e.getClientRects());
}
function Tx(e) {
  const t = it(e), n = Jr(e), o = e.ownerDocument.body, r = ke(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = ke(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + Ka(e);
  const s = -n.scrollTop;
  return $e(o).direction === "rtl" && (i += ke(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: s
  };
}
function Dx(e, t) {
  const n = Ve(e), o = it(e), r = n.visualViewport;
  let a = o.clientWidth, i = o.clientHeight, s = 0, c = 0;
  if (r) {
    a = r.width, i = r.height;
    const l = Ua();
    (!l || l && t === "fixed") && (s = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: c
  };
}
function Mx(e, t) {
  const n = Nt(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = ot(e) ? $t(e) : tt(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, c = r * a.x, l = o * a.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function Ms(e, t, n) {
  let o;
  if (t === "viewport")
    o = Dx(e, n);
  else if (t === "document")
    o = Tx(it(e));
  else if (Ze(t))
    o = Mx(t, n);
  else {
    const r = Mu(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return wr(o);
}
function Ou(e, t) {
  const n = yt(e);
  return n === t || !Ze(n) || Ut(n) ? !1 : $e(n).position === "fixed" || Ou(n, t);
}
function Fx(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = yn(e, [], !1).filter((s) => Ze(s) && rn(s) !== "body"), r = null;
  const a = $e(e).position === "fixed";
  let i = a ? yt(e) : e;
  for (; Ze(i) && !Ut(i); ) {
    const s = $e(i), c = Ja(i);
    !c && s.position === "fixed" && (r = null), (a ? !c && !r : !c && s.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || On(i) && !c && Ou(e, i)) ? o = o.filter((u) => u !== i) : r = s, i = yt(i);
  }
  return t.set(e, o), o;
}
function Ox(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? Yr(t) ? [] : Fx(t, this._c) : [].concat(n), o], s = i[0], c = i.reduce((l, u) => {
    const f = Ms(t, u, r);
    return l.top = ke(f.top, l.top), l.right = xt(f.right, l.right), l.bottom = xt(f.bottom, l.bottom), l.left = ke(f.left, l.left), l;
  }, Ms(t, s, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Gx(e) {
  const {
    width: t,
    height: n
  } = Du(e);
  return {
    width: t,
    height: n
  };
}
function kx(e, t, n) {
  const o = ot(t), r = it(t), a = n === "fixed", i = Nt(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = tt(0);
  function l() {
    c.x = Ka(r);
  }
  if (o || !o && !a)
    if ((rn(t) !== "body" || On(r)) && (s = Jr(t)), o) {
      const b = Nt(t, !0, a, t);
      c.x = b.x + t.clientLeft, c.y = b.y + t.clientTop;
    } else r && l();
  a && !o && r && l();
  const u = r && !o && !a ? Fu(r, s) : tt(0), f = i.left + s.scrollLeft - c.x - u.x, g = i.top + s.scrollTop - c.y - u.y;
  return {
    x: f,
    y: g,
    width: i.width,
    height: i.height
  };
}
function Fo(e) {
  return $e(e).position === "static";
}
function Fs(e, t) {
  if (!ot(e) || $e(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return it(e) === n && (n = n.ownerDocument.body), n;
}
function Gu(e, t) {
  const n = Ve(e);
  if (Yr(e))
    return n;
  if (!ot(e)) {
    let r = yt(e);
    for (; r && !Ut(r); ) {
      if (Ze(r) && !Fo(r))
        return r;
      r = yt(r);
    }
    return n;
  }
  let o = Fs(e, t);
  for (; o && Ex(o) && Fo(o); )
    o = Fs(o, t);
  return o && Ut(o) && Fo(o) && !Ja(o) ? n : o || Rx(e) || n;
}
const jx = async function(e) {
  const t = this.getOffsetParent || Gu, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: kx(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Vx(e) {
  return $e(e).direction === "rtl";
}
const Bx = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Px,
  getDocumentElement: it,
  getClippingRect: Ox,
  getOffsetParent: Gu,
  getElementRects: jx,
  getClientRects: _x,
  getDimensions: Gx,
  getScale: $t,
  isElement: Ze,
  isRTL: Vx
};
function ku(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Lx(e, t) {
  let n = null, o;
  const r = it(e);
  function a() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const l = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: g,
      height: b
    } = l;
    if (s || t(), !g || !b)
      return;
    const C = or(f), m = or(r.clientWidth - (u + g)), v = or(r.clientHeight - (f + b)), h = or(u), x = {
      rootMargin: -C + "px " + -m + "px " + -v + "px " + -h + "px",
      threshold: ke(0, xt(1, c)) || 1
    };
    let y = !0;
    function w(R) {
      const E = R[0].intersectionRatio;
      if (E !== c) {
        if (!y)
          return i();
        E ? i(!1, E) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !ku(l, e.getBoundingClientRect()) && i(), y = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...x,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, x);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function ju(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, l = Qa(e), u = r || a ? [...l ? yn(l) : [], ...yn(t)] : [];
  u.forEach((h) => {
    r && h.addEventListener("scroll", n, {
      passive: !0
    }), a && h.addEventListener("resize", n);
  });
  const f = l && s ? Lx(l, n) : null;
  let g = -1, b = null;
  i && (b = new ResizeObserver((h) => {
    let [I] = h;
    I && I.target === l && b && (b.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var x;
      (x = b) == null || x.observe(t);
    })), n();
  }), l && !c && b.observe(l), b.observe(t));
  let C, m = c ? Nt(e) : null;
  c && v();
  function v() {
    const h = Nt(e);
    m && !ku(m, h) && n(), m = h, C = requestAnimationFrame(v);
  }
  return n(), () => {
    var h;
    u.forEach((I) => {
      r && I.removeEventListener("scroll", n), a && I.removeEventListener("resize", n);
    }), f == null || f(), (h = b) == null || h.disconnect(), b = null, c && cancelAnimationFrame(C);
  };
}
const Wx = Cx, Xx = Ix, Hx = hx, zx = Ax, Zx = xx, Os = vx, $x = wx, Yx = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Bx,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return bx(e, t, {
    ...r,
    platform: a
  });
};
var Jx = typeof document < "u", Ux = function() {
}, fr = Jx ? hc : Ux;
function Ar(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Ar(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && e.$$typeof) && !Ar(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Vu(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Gs(e, t) {
  const n = Vu(e);
  return Math.round(t * n) / n;
}
function Oo(e) {
  const t = d.useRef(e);
  return fr(() => {
    t.current = e;
  }), t;
}
function Qx(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, f] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, b] = d.useState(o);
  Ar(g, o) || b(o);
  const [C, m] = d.useState(null), [v, h] = d.useState(null), I = d.useCallback((j) => {
    j !== R.current && (R.current = j, m(j));
  }, []), x = d.useCallback((j) => {
    j !== E.current && (E.current = j, h(j));
  }, []), y = a || C, w = i || v, R = d.useRef(null), E = d.useRef(null), N = d.useRef(u), _ = c != null, D = Oo(c), O = Oo(r), T = Oo(l), L = d.useCallback(() => {
    if (!R.current || !E.current)
      return;
    const j = {
      placement: t,
      strategy: n,
      middleware: g
    };
    O.current && (j.platform = O.current), Yx(R.current, E.current, j).then((F) => {
      const U = {
        ...F,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: T.current !== !1
      };
      M.current && !Ar(N.current, U) && (N.current = U, wa.flushSync(() => {
        f(U);
      }));
    });
  }, [g, t, n, O, T]);
  fr(() => {
    l === !1 && N.current.isPositioned && (N.current.isPositioned = !1, f((j) => ({
      ...j,
      isPositioned: !1
    })));
  }, [l]);
  const M = d.useRef(!1);
  fr(() => (M.current = !0, () => {
    M.current = !1;
  }), []), fr(() => {
    if (y && (R.current = y), w && (E.current = w), y && w) {
      if (D.current)
        return D.current(y, w, L);
      L();
    }
  }, [y, w, L, D, _]);
  const B = d.useMemo(() => ({
    reference: R,
    floating: E,
    setReference: I,
    setFloating: x
  }), [I, x]), k = d.useMemo(() => ({
    reference: y,
    floating: w
  }), [y, w]), $ = d.useMemo(() => {
    const j = {
      position: n,
      left: 0,
      top: 0
    };
    if (!k.floating)
      return j;
    const F = Gs(k.floating, u.x), U = Gs(k.floating, u.y);
    return s ? {
      ...j,
      transform: "translate(" + F + "px, " + U + "px)",
      ...Vu(k.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: F,
      top: U
    };
  }, [n, s, k.floating, u.x, u.y]);
  return d.useMemo(() => ({
    ...u,
    update: L,
    refs: B,
    elements: k,
    floatingStyles: $
  }), [u, L, B, k, $]);
}
const Kx = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Os({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Os({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, qx = (e, t) => ({
  ...Wx(e),
  options: [e, t]
}), ey = (e, t) => ({
  ...Xx(e),
  options: [e, t]
}), ty = (e, t) => ({
  ...$x(e),
  options: [e, t]
}), ny = (e, t) => ({
  ...Hx(e),
  options: [e, t]
}), ry = (e, t) => ({
  ...zx(e),
  options: [e, t]
}), oy = (e, t) => ({
  ...Zx(e),
  options: [e, t]
}), ay = (e, t) => ({
  ...Kx(e),
  options: [e, t]
});
var iy = "Arrow", Bu = d.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ p.jsx(
    z.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ p.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Bu.displayName = iy;
var sy = Bu, qa = "Popper", [Lu, on] = ye(qa), [cy, Wu] = Lu(qa), Xu = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = d.useState(null);
  return /* @__PURE__ */ p.jsx(cy, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Xu.displayName = qa;
var Hu = "PopperAnchor", zu = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = Wu(Hu, n), i = d.useRef(null), s = ne(t, i);
    return d.useEffect(() => {
      a.onAnchorChange((o == null ? void 0 : o.current) || i.current);
    }), o ? null : /* @__PURE__ */ p.jsx(z.div, { ...r, ref: s });
  }
);
zu.displayName = Hu;
var ei = "PopperContent", [ly, uy] = Lu(ei), Zu = d.forwardRef(
  (e, t) => {
    var fe, me, pe, _e, ct, W;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: b = "optimized",
      onPlaced: C,
      ...m
    } = e, v = Wu(ei, n), [h, I] = d.useState(null), x = ne(t, (Ge) => I(Ge)), [y, w] = d.useState(null), R = Br(y), E = (R == null ? void 0 : R.width) ?? 0, N = (R == null ? void 0 : R.height) ?? 0, _ = o + (a !== "center" ? "-" + a : ""), D = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, O = Array.isArray(l) ? l : [l], T = O.length > 0, L = {
      padding: D,
      boundary: O.filter(fy),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: T
    }, { refs: M, floatingStyles: B, placement: k, isPositioned: $, middlewareData: j } = Qx({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...Ge) => ju(...Ge, {
        animationFrame: b === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        qx({ mainAxis: r + N, alignmentAxis: i }),
        c && ey({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? ty() : void 0,
          ...L
        }),
        c && ny({ ...L }),
        ry({
          ...L,
          apply: ({ elements: Ge, rects: Le, availableWidth: He, availableHeight: wt }) => {
            const { width: Xn, height: Hn } = Le.reference, lt = Ge.floating.style;
            lt.setProperty("--radix-popper-available-width", `${He}px`), lt.setProperty("--radix-popper-available-height", `${wt}px`), lt.setProperty("--radix-popper-anchor-width", `${Xn}px`), lt.setProperty("--radix-popper-anchor-height", `${Hn}px`);
          }
        }),
        y && ay({ element: y, padding: s }),
        py({ arrowWidth: E, arrowHeight: N }),
        g && oy({ strategy: "referenceHidden", ...L })
      ]
    }), [F, U] = Ju(k), re = Me(C);
    rt(() => {
      $ && (re == null || re());
    }, [$, re]);
    const J = (fe = j.arrow) == null ? void 0 : fe.x, Q = (me = j.arrow) == null ? void 0 : me.y, ge = ((pe = j.arrow) == null ? void 0 : pe.centerOffset) !== 0, [Ce, ue] = d.useState();
    return rt(() => {
      h && ue(window.getComputedStyle(h).zIndex);
    }, [h]), /* @__PURE__ */ p.jsx(
      "div",
      {
        ref: M.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...B,
          transform: $ ? B.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Ce,
          "--radix-popper-transform-origin": [
            (_e = j.transformOrigin) == null ? void 0 : _e.x,
            (ct = j.transformOrigin) == null ? void 0 : ct.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((W = j.hide) == null ? void 0 : W.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p.jsx(
          ly,
          {
            scope: n,
            placedSide: F,
            onArrowChange: w,
            arrowX: J,
            arrowY: Q,
            shouldHideArrow: ge,
            children: /* @__PURE__ */ p.jsx(
              z.div,
              {
                "data-side": F,
                "data-align": U,
                ...m,
                ref: x,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: $ ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Zu.displayName = ei;
var $u = "PopperArrow", dy = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Yu = d.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = uy($u, o), i = dy[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p.jsx(
          sy,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Yu.displayName = $u;
function fy(e) {
  return e !== null;
}
var py = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, h, I;
    const { placement: n, rects: o, middlewareData: r } = t, i = ((v = r.arrow) == null ? void 0 : v.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [l, u] = Ju(n), f = { start: "0%", center: "50%", end: "100%" }[u], g = (((h = r.arrow) == null ? void 0 : h.x) ?? 0) + s / 2, b = (((I = r.arrow) == null ? void 0 : I.y) ?? 0) + c / 2;
    let C = "", m = "";
    return l === "bottom" ? (C = i ? f : `${g}px`, m = `${-c}px`) : l === "top" ? (C = i ? f : `${g}px`, m = `${o.floating.height + c}px`) : l === "right" ? (C = `${-c}px`, m = i ? f : `${b}px`) : l === "left" && (C = `${o.floating.width + c}px`, m = i ? f : `${b}px`), { data: { x: C, y: m } };
  }
});
function Ju(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Ur = Xu, Qr = zu, ti = Zu, ni = Yu, Go = "rovingFocusGroup.onEntryFocus", gy = { bubbles: !1, cancelable: !0 }, Gn = "RovingFocusGroup", [ca, Uu, my] = Or(Gn), [by, an] = ye(
  Gn,
  [my]
), [vy, hy] = by(Gn), Qu = d.forwardRef(
  (e, t) => /* @__PURE__ */ p.jsx(ca.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p.jsx(ca.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p.jsx(xy, { ...e, ref: t }) }) })
);
Qu.displayName = Gn;
var xy = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = e, g = d.useRef(null), b = ne(t, g), C = Nn(a), [m, v] = Oe({
    prop: i,
    defaultProp: s ?? null,
    onChange: c,
    caller: Gn
  }), [h, I] = d.useState(!1), x = Me(l), y = Uu(n), w = d.useRef(!1), [R, E] = d.useState(0);
  return d.useEffect(() => {
    const N = g.current;
    if (N)
      return N.addEventListener(Go, x), () => N.removeEventListener(Go, x);
  }, [x]), /* @__PURE__ */ p.jsx(
    vy,
    {
      scope: n,
      orientation: o,
      dir: C,
      loop: r,
      currentTabStopId: m,
      onItemFocus: d.useCallback(
        (N) => v(N),
        [v]
      ),
      onItemShiftTab: d.useCallback(() => I(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => E((N) => N + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => E((N) => N - 1),
        []
      ),
      children: /* @__PURE__ */ p.jsx(
        z.div,
        {
          tabIndex: h || R === 0 ? -1 : 0,
          "data-orientation": o,
          ...f,
          ref: b,
          style: { outline: "none", ...e.style },
          onMouseDown: G(e.onMouseDown, () => {
            w.current = !0;
          }),
          onFocus: G(e.onFocus, (N) => {
            const _ = !w.current;
            if (N.target === N.currentTarget && _ && !h) {
              const D = new CustomEvent(Go, gy);
              if (N.currentTarget.dispatchEvent(D), !D.defaultPrevented) {
                const O = y().filter((k) => k.focusable), T = O.find((k) => k.active), L = O.find((k) => k.id === m), B = [T, L, ...O].filter(
                  Boolean
                ).map((k) => k.ref.current);
                ed(B, u);
              }
            }
            w.current = !1;
          }),
          onBlur: G(e.onBlur, () => I(!1))
        }
      )
    }
  );
}), Ku = "RovingFocusGroupItem", qu = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, c = je(), l = a || c, u = hy(Ku, n), f = u.currentTabStopId === l, g = Uu(n), { onFocusableItemAdd: b, onFocusableItemRemove: C, currentTabStopId: m } = u;
    return d.useEffect(() => {
      if (o)
        return b(), () => C();
    }, [o, b, C]), /* @__PURE__ */ p.jsx(
      ca.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ p.jsx(
          z.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: G(e.onMouseDown, (v) => {
              o ? u.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: G(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: G(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const h = Iy(v, u.orientation, u.dir);
              if (h !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let x = g().filter((y) => y.focusable).map((y) => y.ref.current);
                if (h === "last") x.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && x.reverse();
                  const y = x.indexOf(v.currentTarget);
                  x = u.loop ? wy(x, y + 1) : x.slice(y + 1);
                }
                setTimeout(() => ed(x));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: f, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
qu.displayName = Ku;
var yy = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Cy(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Iy(e, t, n) {
  const o = Cy(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return yy[o];
}
function ed(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function wy(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var ri = Qu, oi = qu, la = ["Enter", " "], Ay = ["ArrowDown", "PageUp", "Home"], td = ["ArrowUp", "PageDown", "End"], Ey = [...Ay, ...td], Ry = {
  ltr: [...la, "ArrowRight"],
  rtl: [...la, "ArrowLeft"]
}, Sy = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, kn = "Menu", [Cn, Ny, Py] = Or(kn), [Dt, nd] = ye(kn, [
  Py,
  on,
  an
]), jn = on(), rd = an(), [od, Ct] = Dt(kn), [_y, Vn] = Dt(kn), ad = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: a, modal: i = !0 } = e, s = jn(t), [c, l] = d.useState(null), u = d.useRef(!1), f = Me(a), g = Nn(r);
  return d.useEffect(() => {
    const b = () => {
      u.current = !0, document.addEventListener("pointerdown", C, { capture: !0, once: !0 }), document.addEventListener("pointermove", C, { capture: !0, once: !0 });
    }, C = () => u.current = !1;
    return document.addEventListener("keydown", b, { capture: !0 }), () => {
      document.removeEventListener("keydown", b, { capture: !0 }), document.removeEventListener("pointerdown", C, { capture: !0 }), document.removeEventListener("pointermove", C, { capture: !0 });
    };
  }, []), /* @__PURE__ */ p.jsx(Ur, { ...s, children: /* @__PURE__ */ p.jsx(
    od,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: c,
      onContentChange: l,
      children: /* @__PURE__ */ p.jsx(
        _y,
        {
          scope: t,
          onClose: d.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: g,
          modal: i,
          children: o
        }
      )
    }
  ) });
};
ad.displayName = kn;
var Ty = "MenuAnchor", ai = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = jn(n);
    return /* @__PURE__ */ p.jsx(Qr, { ...r, ...o, ref: t });
  }
);
ai.displayName = Ty;
var ii = "MenuPortal", [Dy, id] = Dt(ii, {
  forceMount: void 0
}), sd = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, a = Ct(ii, t);
  return /* @__PURE__ */ p.jsx(Dy, { scope: t, forceMount: n, children: /* @__PURE__ */ p.jsx(Se, { present: n || a.open, children: /* @__PURE__ */ p.jsx(Pn, { asChild: !0, container: r, children: o }) }) });
};
sd.displayName = ii;
var Xe = "MenuContent", [My, si] = Dt(Xe), cd = d.forwardRef(
  (e, t) => {
    const n = id(Xe, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = Ct(Xe, e.__scopeMenu), i = Vn(Xe, e.__scopeMenu);
    return /* @__PURE__ */ p.jsx(Cn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p.jsx(Se, { present: o || a.open, children: /* @__PURE__ */ p.jsx(Cn.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ p.jsx(Fy, { ...r, ref: t }) : /* @__PURE__ */ p.jsx(Oy, { ...r, ref: t }) }) }) });
  }
), Fy = d.forwardRef(
  (e, t) => {
    const n = Ct(Xe, e.__scopeMenu), o = d.useRef(null), r = ne(t, o);
    return d.useEffect(() => {
      const a = o.current;
      if (a) return ja(a);
    }, []), /* @__PURE__ */ p.jsx(
      ci,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: G(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Oy = d.forwardRef((e, t) => {
  const n = Ct(Xe, e.__scopeMenu);
  return /* @__PURE__ */ p.jsx(
    ci,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Gy = /* @__PURE__ */ Rt("MenuContent.ScrollLock"), ci = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: o = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: l,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: g,
      onDismiss: b,
      disableOutsideScroll: C,
      ...m
    } = e, v = Ct(Xe, n), h = Vn(Xe, n), I = jn(n), x = rd(n), y = Ny(n), [w, R] = d.useState(null), E = d.useRef(null), N = ne(t, E, v.onContentChange), _ = d.useRef(0), D = d.useRef(""), O = d.useRef(0), T = d.useRef(null), L = d.useRef("right"), M = d.useRef(0), B = C ? Hr : d.Fragment, k = C ? { as: Gy, allowPinchZoom: !0 } : void 0, $ = (F) => {
      var fe, me;
      const U = D.current + F, re = y().filter((pe) => !pe.disabled), J = document.activeElement, Q = (fe = re.find((pe) => pe.ref.current === J)) == null ? void 0 : fe.textValue, ge = re.map((pe) => pe.textValue), Ce = Yy(ge, U, Q), ue = (me = re.find((pe) => pe.textValue === Ce)) == null ? void 0 : me.ref.current;
      (function pe(_e) {
        D.current = _e, window.clearTimeout(_.current), _e !== "" && (_.current = window.setTimeout(() => pe(""), 1e3));
      })(U), ue && setTimeout(() => ue.focus());
    };
    d.useEffect(() => () => window.clearTimeout(_.current), []), ka();
    const j = d.useCallback((F) => {
      var re, J;
      return L.current === ((re = T.current) == null ? void 0 : re.side) && Uy(F, (J = T.current) == null ? void 0 : J.area);
    }, []);
    return /* @__PURE__ */ p.jsx(
      My,
      {
        scope: n,
        searchRef: D,
        onItemEnter: d.useCallback(
          (F) => {
            j(F) && F.preventDefault();
          },
          [j]
        ),
        onItemLeave: d.useCallback(
          (F) => {
            var U;
            j(F) || ((U = E.current) == null || U.focus(), R(null));
          },
          [j]
        ),
        onTriggerLeave: d.useCallback(
          (F) => {
            j(F) && F.preventDefault();
          },
          [j]
        ),
        pointerGraceTimerRef: O,
        onPointerGraceIntentChange: d.useCallback((F) => {
          T.current = F;
        }, []),
        children: /* @__PURE__ */ p.jsx(B, { ...k, children: /* @__PURE__ */ p.jsx(
          Wr,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: G(a, (F) => {
              var U;
              F.preventDefault(), (U = E.current) == null || U.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ p.jsx(
              tn,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: l,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: g,
                onDismiss: b,
                children: /* @__PURE__ */ p.jsx(
                  ri,
                  {
                    asChild: !0,
                    ...x,
                    dir: h.dir,
                    orientation: "vertical",
                    loop: o,
                    currentTabStopId: w,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: G(c, (F) => {
                      h.isUsingKeyboardRef.current || F.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ p.jsx(
                      ti,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Ed(v.open),
                        "data-radix-menu-content": "",
                        dir: h.dir,
                        ...I,
                        ...m,
                        ref: N,
                        style: { outline: "none", ...m.style },
                        onKeyDown: G(m.onKeyDown, (F) => {
                          const re = F.target.closest("[data-radix-menu-content]") === F.currentTarget, J = F.ctrlKey || F.altKey || F.metaKey, Q = F.key.length === 1;
                          re && (F.key === "Tab" && F.preventDefault(), !J && Q && $(F.key));
                          const ge = E.current;
                          if (F.target !== ge || !Ey.includes(F.key)) return;
                          F.preventDefault();
                          const ue = y().filter((fe) => !fe.disabled).map((fe) => fe.ref.current);
                          td.includes(F.key) && ue.reverse(), Zy(ue);
                        }),
                        onBlur: G(e.onBlur, (F) => {
                          F.currentTarget.contains(F.target) || (window.clearTimeout(_.current), D.current = "");
                        }),
                        onPointerMove: G(
                          e.onPointerMove,
                          In((F) => {
                            const U = F.target, re = M.current !== F.clientX;
                            if (F.currentTarget.contains(U) && re) {
                              const J = F.clientX > M.current ? "right" : "left";
                              L.current = J, M.current = F.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
cd.displayName = Xe;
var ky = "MenuGroup", li = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ p.jsx(z.div, { role: "group", ...o, ref: t });
  }
);
li.displayName = ky;
var jy = "MenuLabel", ld = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ p.jsx(z.div, { ...o, ref: t });
  }
);
ld.displayName = jy;
var Er = "MenuItem", ks = "menu.itemSelect", Kr = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: o, ...r } = e, a = d.useRef(null), i = Vn(Er, e.__scopeMenu), s = si(Er, e.__scopeMenu), c = ne(t, a), l = d.useRef(!1), u = () => {
      const f = a.current;
      if (!n && f) {
        const g = new CustomEvent(ks, { bubbles: !0, cancelable: !0 });
        f.addEventListener(ks, (b) => o == null ? void 0 : o(b), { once: !0 }), Aa(f, g), g.defaultPrevented ? l.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ p.jsx(
      ud,
      {
        ...r,
        ref: c,
        disabled: n,
        onClick: G(e.onClick, u),
        onPointerDown: (f) => {
          var g;
          (g = e.onPointerDown) == null || g.call(e, f), l.current = !0;
        },
        onPointerUp: G(e.onPointerUp, (f) => {
          var g;
          l.current || (g = f.currentTarget) == null || g.click();
        }),
        onKeyDown: G(e.onKeyDown, (f) => {
          const g = s.searchRef.current !== "";
          n || g && f.key === " " || la.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Kr.displayName = Er;
var ud = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: o = !1, textValue: r, ...a } = e, i = si(Er, n), s = rd(n), c = d.useRef(null), l = ne(t, c), [u, f] = d.useState(!1), [g, b] = d.useState("");
    return d.useEffect(() => {
      const C = c.current;
      C && b((C.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ p.jsx(
      Cn.ItemSlot,
      {
        scope: n,
        disabled: o,
        textValue: r ?? g,
        children: /* @__PURE__ */ p.jsx(oi, { asChild: !0, ...s, focusable: !o, children: /* @__PURE__ */ p.jsx(
          z.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": o || void 0,
            "data-disabled": o ? "" : void 0,
            ...a,
            ref: l,
            onPointerMove: G(
              e.onPointerMove,
              In((C) => {
                o ? i.onItemLeave(C) : (i.onItemEnter(C), C.defaultPrevented || C.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: G(
              e.onPointerLeave,
              In((C) => i.onItemLeave(C))
            ),
            onFocus: G(e.onFocus, () => f(!0)),
            onBlur: G(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), Vy = "MenuCheckboxItem", dd = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: o, ...r } = e;
    return /* @__PURE__ */ p.jsx(bd, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ p.jsx(
      Kr,
      {
        role: "menuitemcheckbox",
        "aria-checked": Rr(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": fi(n),
        onSelect: G(
          r.onSelect,
          () => o == null ? void 0 : o(Rr(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
dd.displayName = Vy;
var fd = "MenuRadioGroup", [By, Ly] = Dt(
  fd,
  { value: void 0, onValueChange: () => {
  } }
), pd = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: o, ...r } = e, a = Me(o);
    return /* @__PURE__ */ p.jsx(By, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ p.jsx(li, { ...r, ref: t }) });
  }
);
pd.displayName = fd;
var gd = "MenuRadioItem", md = d.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = Ly(gd, e.__scopeMenu), a = n === r.value;
    return /* @__PURE__ */ p.jsx(bd, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ p.jsx(
      Kr,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...o,
        ref: t,
        "data-state": fi(a),
        onSelect: G(
          o.onSelect,
          () => {
            var i;
            return (i = r.onValueChange) == null ? void 0 : i.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
md.displayName = gd;
var ui = "MenuItemIndicator", [bd, Wy] = Dt(
  ui,
  { checked: !1 }
), vd = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: o, ...r } = e, a = Wy(ui, n);
    return /* @__PURE__ */ p.jsx(
      Se,
      {
        present: o || Rr(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ p.jsx(
          z.span,
          {
            ...r,
            ref: t,
            "data-state": fi(a.checked)
          }
        )
      }
    );
  }
);
vd.displayName = ui;
var Xy = "MenuSeparator", hd = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ p.jsx(
      z.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...o,
        ref: t
      }
    );
  }
);
hd.displayName = Xy;
var Hy = "MenuArrow", xd = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = jn(n);
    return /* @__PURE__ */ p.jsx(ni, { ...r, ...o, ref: t });
  }
);
xd.displayName = Hy;
var di = "MenuSub", [zy, yd] = Dt(di), Cd = (e) => {
  const { __scopeMenu: t, children: n, open: o = !1, onOpenChange: r } = e, a = Ct(di, t), i = jn(t), [s, c] = d.useState(null), [l, u] = d.useState(null), f = Me(r);
  return d.useEffect(() => (a.open === !1 && f(!1), () => f(!1)), [a.open, f]), /* @__PURE__ */ p.jsx(Ur, { ...i, children: /* @__PURE__ */ p.jsx(
    od,
    {
      scope: t,
      open: o,
      onOpenChange: f,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ p.jsx(
        zy,
        {
          scope: t,
          contentId: je(),
          triggerId: je(),
          trigger: s,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
Cd.displayName = di;
var gn = "MenuSubTrigger", Id = d.forwardRef(
  (e, t) => {
    const n = Ct(gn, e.__scopeMenu), o = Vn(gn, e.__scopeMenu), r = yd(gn, e.__scopeMenu), a = si(gn, e.__scopeMenu), i = d.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = a, l = { __scopeMenu: e.__scopeMenu }, u = d.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return d.useEffect(() => u, [u]), d.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), c(null);
      };
    }, [s, c]), /* @__PURE__ */ p.jsx(ai, { asChild: !0, ...l, children: /* @__PURE__ */ p.jsx(
      ud,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": Ed(n.open),
        ...e,
        ref: Fr(t, r.onTriggerChange),
        onClick: (f) => {
          var g;
          (g = e.onClick) == null || g.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: G(
          e.onPointerMove,
          In((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: G(
          e.onPointerLeave,
          In((f) => {
            var b, C;
            u();
            const g = (b = n.content) == null ? void 0 : b.getBoundingClientRect();
            if (g) {
              const m = (C = n.content) == null ? void 0 : C.dataset.side, v = m === "right", h = v ? -5 : 5, I = g[v ? "left" : "right"], x = g[v ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + h, y: f.clientY },
                  { x: I, y: g.top },
                  { x, y: g.top },
                  { x, y: g.bottom },
                  { x: I, y: g.bottom }
                ],
                side: m
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: G(e.onKeyDown, (f) => {
          var b;
          const g = a.searchRef.current !== "";
          e.disabled || g && f.key === " " || Ry[o.dir].includes(f.key) && (n.onOpenChange(!0), (b = n.content) == null || b.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Id.displayName = gn;
var wd = "MenuSubContent", Ad = d.forwardRef(
  (e, t) => {
    const n = id(Xe, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = Ct(Xe, e.__scopeMenu), i = Vn(Xe, e.__scopeMenu), s = yd(wd, e.__scopeMenu), c = d.useRef(null), l = ne(t, c);
    return /* @__PURE__ */ p.jsx(Cn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p.jsx(Se, { present: o || a.open, children: /* @__PURE__ */ p.jsx(Cn.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ p.jsx(
      ci,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...r,
        ref: l,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          i.isUsingKeyboardRef.current && ((f = c.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: G(e.onFocusOutside, (u) => {
          u.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: G(e.onEscapeKeyDown, (u) => {
          i.onClose(), u.preventDefault();
        }),
        onKeyDown: G(e.onKeyDown, (u) => {
          var b;
          const f = u.currentTarget.contains(u.target), g = Sy[i.dir].includes(u.key);
          f && g && (a.onOpenChange(!1), (b = s.trigger) == null || b.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
Ad.displayName = wd;
function Ed(e) {
  return e ? "open" : "closed";
}
function Rr(e) {
  return e === "indeterminate";
}
function fi(e) {
  return Rr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Zy(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function $y(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
function Yy(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = $y(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((l) => l !== n));
  const c = i.find(
    (l) => l.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Jy(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], c = t[i], l = s.x, u = s.y, f = c.x, g = c.y;
    u > o != g > o && n < (f - l) * (o - u) / (g - u) + l && (r = !r);
  }
  return r;
}
function Uy(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Jy(n, t);
}
function In(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Qy = ad, Ky = ai, qy = sd, eC = cd, tC = li, nC = ld, rC = Kr, oC = dd, aC = pd, iC = md, sC = vd, cC = hd, lC = xd, uC = Cd, dC = Id, fC = Ad, qr = "DropdownMenu", [pC, VE] = ye(
  qr,
  [nd]
), Ne = nd(), [gC, Rd] = pC(qr), Sd = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: o,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, c = Ne(t), l = d.useRef(null), [u, f] = Oe({
    prop: r,
    defaultProp: a ?? !1,
    onChange: i,
    caller: qr
  });
  return /* @__PURE__ */ p.jsx(
    gC,
    {
      scope: t,
      triggerId: je(),
      triggerRef: l,
      contentId: je(),
      open: u,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((g) => !g), [f]),
      modal: s,
      children: /* @__PURE__ */ p.jsx(Qy, { ...c, open: u, onOpenChange: f, dir: o, modal: s, children: n })
    }
  );
};
Sd.displayName = qr;
var Nd = "DropdownMenuTrigger", Pd = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, a = Rd(Nd, n), i = Ne(n);
    return /* @__PURE__ */ p.jsx(Ky, { asChild: !0, ...i, children: /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": o ? "" : void 0,
        disabled: o,
        ...r,
        ref: Fr(t, a.triggerRef),
        onPointerDown: G(e.onPointerDown, (s) => {
          !o && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: G(e.onKeyDown, (s) => {
          o || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Pd.displayName = Nd;
var mC = "DropdownMenuPortal", _d = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = Ne(t);
  return /* @__PURE__ */ p.jsx(qy, { ...o, ...n });
};
_d.displayName = mC;
var Td = "DropdownMenuContent", Dd = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Rd(Td, n), a = Ne(n), i = d.useRef(!1);
    return /* @__PURE__ */ p.jsx(
      eC,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...o,
        ref: t,
        onCloseAutoFocus: G(e.onCloseAutoFocus, (s) => {
          var c;
          i.current || (c = r.triggerRef.current) == null || c.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: G(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
          (!r.modal || u) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Dd.displayName = Td;
var bC = "DropdownMenuGroup", Md = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
    return /* @__PURE__ */ p.jsx(tC, { ...r, ...o, ref: t });
  }
);
Md.displayName = bC;
var vC = "DropdownMenuLabel", Fd = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
    return /* @__PURE__ */ p.jsx(nC, { ...r, ...o, ref: t });
  }
);
Fd.displayName = vC;
var hC = "DropdownMenuItem", Od = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
    return /* @__PURE__ */ p.jsx(rC, { ...r, ...o, ref: t });
  }
);
Od.displayName = hC;
var xC = "DropdownMenuCheckboxItem", Gd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(oC, { ...r, ...o, ref: t });
});
Gd.displayName = xC;
var yC = "DropdownMenuRadioGroup", CC = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(aC, { ...r, ...o, ref: t });
});
CC.displayName = yC;
var IC = "DropdownMenuRadioItem", kd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(iC, { ...r, ...o, ref: t });
});
kd.displayName = IC;
var wC = "DropdownMenuItemIndicator", jd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(sC, { ...r, ...o, ref: t });
});
jd.displayName = wC;
var AC = "DropdownMenuSeparator", Vd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(cC, { ...r, ...o, ref: t });
});
Vd.displayName = AC;
var EC = "DropdownMenuArrow", RC = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
    return /* @__PURE__ */ p.jsx(lC, { ...r, ...o, ref: t });
  }
);
RC.displayName = EC;
var SC = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: o, onOpenChange: r, defaultOpen: a } = e, i = Ne(t), [s, c] = Oe({
    prop: o,
    defaultProp: a ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ p.jsx(uC, { ...i, open: s, onOpenChange: c, children: n });
}, NC = "DropdownMenuSubTrigger", Bd = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(dC, { ...r, ...o, ref: t });
});
Bd.displayName = NC;
var PC = "DropdownMenuSubContent", Ld = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = Ne(n);
  return /* @__PURE__ */ p.jsx(
    fC,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Ld.displayName = PC;
var _C = Sd, TC = Pd, Wd = _d, Xd = Dd, DC = Md, Hd = Fd, zd = Od, Zd = Gd, $d = kd, Yd = jd, Jd = Vd, MC = SC, Ud = Bd, Qd = Ld;
const FC = _C, OC = TC, GC = DC, kC = Wd, jC = MC, Kd = d.forwardRef(({ className: e, inset: t, children: n, ...o }, r) => /* @__PURE__ */ p.jsxs(
  Ud,
  {
    ref: r,
    className: S(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...o,
    children: [
      n,
      /* @__PURE__ */ p.jsx(tb, { className: "ml-auto h-4 w-4" })
    ]
  }
));
Kd.displayName = Ud.displayName;
const qd = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  Qd,
  {
    ref: n,
    className: S(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
qd.displayName = Qd.displayName;
const ef = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, o) => /* @__PURE__ */ p.jsx(Wd, { children: /* @__PURE__ */ p.jsx(
  Xd,
  {
    ref: o,
    sideOffset: t,
    className: S(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
ef.displayName = Xd.displayName;
const tf = d.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ p.jsx(
  zd,
  {
    ref: o,
    className: S(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
tf.displayName = zd.displayName;
const VC = d.forwardRef(({ className: e, children: t, checked: n, ...o }, r) => /* @__PURE__ */ p.jsxs(
  Zd,
  {
    ref: r,
    className: S(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...o,
    children: [
      /* @__PURE__ */ p.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p.jsx(Yd, { children: /* @__PURE__ */ p.jsx(Lc, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
VC.displayName = Zd.displayName;
const BC = d.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ p.jsxs(
  $d,
  {
    ref: o,
    className: S(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p.jsx(Yd, { children: /* @__PURE__ */ p.jsx(Wc, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
BC.displayName = $d.displayName;
const nf = d.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ p.jsx(Hd, { ref: o, className: S("px-2 py-1.5 text-sm font-semibold", t && "pl-8", e), ...n }));
nf.displayName = Hd.displayName;
const LC = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Jd, { ref: n, className: S("-mx-1 my-1 h-px bg-muted", e), ...t }));
LC.displayName = Jd.displayName;
const rf = ({ className: e, ...t }) => /* @__PURE__ */ p.jsx("span", { className: S("ml-auto text-xs tracking-widest opacity-60", e), ...t });
rf.displayName = "DropdownMenuShortcut";
const of = {
  [Wt.XS]: "w-[80px]",
  [Wt.SM]: "w-[100px]",
  [Wt.MD]: "w-[150px]",
  [Wt.LG]: "w-[200px]"
}, BE = (e) => {
  const {
    trigger: t,
    children: n,
    className: o = "",
    triggerClassName: r = "",
    titleClassName: a = "",
    title: i = "",
    size: s = Wt.MD,
    side: c = "bottom",
    align: l = "end"
  } = e;
  return /* @__PURE__ */ p.jsxs(FC, { children: [
    /* @__PURE__ */ p.jsx(OC, { className: S(`nyn-menu-trigger ${r}`), children: t }),
    /* @__PURE__ */ p.jsxs(
      ef,
      {
        side: c,
        align: l,
        className: S(`nyn-menu-content rounded bg-card border border-border shadow-lg ${of[s]} ${o}`),
        children: [
          i && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            /* @__PURE__ */ p.jsx(nf, { className: S(`text-text ${a}`), children: i }),
            /* @__PURE__ */ p.jsx(yu, {})
          ] }),
          /* @__PURE__ */ p.jsx(GC, { children: n })
        ]
      }
    )
  ] });
}, LE = (e) => {
  const { trigger: t, children: n, className: o = "", triggerClassName: r = "", size: a = qc.MD } = e;
  return /* @__PURE__ */ p.jsxs(jC, { children: [
    /* @__PURE__ */ p.jsx(
      Kd,
      {
        className: S(`nyn-menu-nested-trigger text-muted hover:bg-border focus:bg-border active:bg-border py-2.5 ${r}`),
        children: t
      }
    ),
    /* @__PURE__ */ p.jsx(kC, { children: /* @__PURE__ */ p.jsx(
      qd,
      {
        className: S(`nyn-menu-nested-content rounded bg-card border border-border shadow-lg ${of[a]} ${o}`),
        children: n
      }
    ) })
  ] });
}, WE = (e) => {
  const { title: t, shortcut: n = "", separator: o = !1, className: r = "", titleClassName: a = "", iconClassName: i = "", shortcutClassName: s = "" } = e, c = e.icon;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs(
      tf,
      {
        className: S(`nyn-menu-item text-text hover:bg-border focus:bg-border active:bg-border cursor-pointer py-2 ${r}`),
        onClick: e.onClick,
        children: [
          e.icon && /* @__PURE__ */ p.jsx(c, { className: S(`mr-2 h-4 w-4 ${i}`) }),
          /* @__PURE__ */ p.jsx("span", { className: a, children: t }),
          n && /* @__PURE__ */ p.jsx(rf, { className: S(`text-muted ${s}`), children: "⇧⌘P" })
        ]
      }
    ),
    o && /* @__PURE__ */ p.jsx(yu, {})
  ] });
};
var eo = "Popover", [af, XE] = ye(eo, [
  on
]), Bn = on(), [WC, It] = af(eo), sf = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !1
  } = e, s = Bn(t), c = d.useRef(null), [l, u] = d.useState(!1), [f, g] = Oe({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: eo
  });
  return /* @__PURE__ */ p.jsx(Ur, { ...s, children: /* @__PURE__ */ p.jsx(
    WC,
    {
      scope: t,
      contentId: je(),
      triggerRef: c,
      open: f,
      onOpenChange: g,
      onOpenToggle: d.useCallback(() => g((b) => !b), [g]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: d.useCallback(() => u(!0), []),
      onCustomAnchorRemove: d.useCallback(() => u(!1), []),
      modal: i,
      children: n
    }
  ) });
};
sf.displayName = eo;
var cf = "PopoverAnchor", XC = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = It(cf, n), a = Bn(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = r;
    return d.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ p.jsx(Qr, { ...a, ...o, ref: t });
  }
);
XC.displayName = cf;
var lf = "PopoverTrigger", uf = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = It(lf, n), a = Bn(n), i = ne(t, r.triggerRef), s = /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": mf(r.open),
        ...o,
        ref: i,
        onClick: G(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? s : /* @__PURE__ */ p.jsx(Qr, { asChild: !0, ...a, children: s });
  }
);
uf.displayName = lf;
var pi = "PopoverPortal", [HC, zC] = af(pi, {
  forceMount: void 0
}), df = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, a = It(pi, t);
  return /* @__PURE__ */ p.jsx(HC, { scope: t, forceMount: n, children: /* @__PURE__ */ p.jsx(Se, { present: n || a.open, children: /* @__PURE__ */ p.jsx(Pn, { asChild: !0, container: r, children: o }) }) });
};
df.displayName = pi;
var Qt = "PopoverContent", ff = d.forwardRef(
  (e, t) => {
    const n = zC(Qt, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, a = It(Qt, e.__scopePopover);
    return /* @__PURE__ */ p.jsx(Se, { present: o || a.open, children: a.modal ? /* @__PURE__ */ p.jsx($C, { ...r, ref: t }) : /* @__PURE__ */ p.jsx(YC, { ...r, ref: t }) });
  }
);
ff.displayName = Qt;
var ZC = /* @__PURE__ */ Rt("PopoverContent.RemoveScroll"), $C = d.forwardRef(
  (e, t) => {
    const n = It(Qt, e.__scopePopover), o = d.useRef(null), r = ne(t, o), a = d.useRef(!1);
    return d.useEffect(() => {
      const i = o.current;
      if (i) return ja(i);
    }, []), /* @__PURE__ */ p.jsx(Hr, { as: ZC, allowPinchZoom: !0, children: /* @__PURE__ */ p.jsx(
      pf,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: G(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), a.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: G(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            a.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: G(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), YC = d.forwardRef(
  (e, t) => {
    const n = It(Qt, e.__scopePopover), o = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ p.jsx(
      pf,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), pf = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: o,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: u,
      ...f
    } = e, g = It(Qt, n), b = Bn(n);
    return ka(), /* @__PURE__ */ p.jsx(
      Wr,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ p.jsx(
          tn,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => g.onOpenChange(!1),
            children: /* @__PURE__ */ p.jsx(
              ti,
              {
                "data-state": mf(g.open),
                role: "dialog",
                id: g.contentId,
                ...b,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), gf = "PopoverClose", JC = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = It(gf, n);
    return /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: G(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
JC.displayName = gf;
var UC = "PopoverArrow", QC = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = Bn(n);
    return /* @__PURE__ */ p.jsx(ni, { ...r, ...o, ref: t });
  }
);
QC.displayName = UC;
function mf(e) {
  return e ? "open" : "closed";
}
var KC = sf, qC = uf, e0 = df, bf = ff;
const t0 = KC, n0 = qC, vf = d.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...o }, r) => /* @__PURE__ */ p.jsx(e0, { children: /* @__PURE__ */ p.jsx(
  bf,
  {
    ref: r,
    align: t,
    sideOffset: n,
    className: S(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...o
  }
) }));
vf.displayName = bf.displayName;
const r0 = {
  [Xt.XS]: "w-[150px]",
  [Xt.SM]: "w-[200px]",
  [Xt.MD]: "w-[250px]",
  [Xt.LG]: "w-[300px]"
}, HE = (e) => {
  const { trigger: t, children: n, size: o = Xt.SM, className: r = "", triggerClassName: a = "", side: i = "bottom", align: s = "end" } = e;
  return /* @__PURE__ */ p.jsxs(t0, { children: [
    /* @__PURE__ */ p.jsx(n0, { className: S(`nyn-popover ${a}`), children: t }),
    /* @__PURE__ */ p.jsx(
      vf,
      {
        side: i,
        align: s,
        className: S(`nyn-popover-content rounded bg-card border border-border shadow-lg p-0 ${r0[o]} ${r}`),
        children: n
      }
    )
  ] });
};
var gi = "Progress", mi = 100, [o0, zE] = ye(gi), [a0, i0] = o0(gi), hf = d.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: o = null,
      max: r,
      getValueLabel: a = s0,
      ...i
    } = e;
    (r || r === 0) && !js(r) && console.error(c0(`${r}`, "Progress"));
    const s = js(r) ? r : mi;
    o !== null && !Vs(o, s) && console.error(l0(`${o}`, "Progress"));
    const c = Vs(o, s) ? o : null, l = Sr(c) ? a(c, s) : void 0;
    return /* @__PURE__ */ p.jsx(a0, { scope: n, value: c, max: s, children: /* @__PURE__ */ p.jsx(
      z.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": Sr(c) ? c : void 0,
        "aria-valuetext": l,
        role: "progressbar",
        "data-state": Cf(c, s),
        "data-value": c ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
hf.displayName = gi;
var xf = "ProgressIndicator", yf = d.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...o } = e, r = i0(xf, n);
    return /* @__PURE__ */ p.jsx(
      z.div,
      {
        "data-state": Cf(r.value, r.max),
        "data-value": r.value ?? void 0,
        "data-max": r.max,
        ...o,
        ref: t
      }
    );
  }
);
yf.displayName = xf;
function s0(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Cf(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Sr(e) {
  return typeof e == "number";
}
function js(e) {
  return Sr(e) && !isNaN(e) && e > 0;
}
function Vs(e, t) {
  return Sr(e) && !isNaN(e) && e <= t && e >= 0;
}
function c0(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${mi}\`.`;
}
function l0(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${mi} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var If = hf, u0 = yf;
const wf = d.forwardRef(
  ({ className: e, value: t, ...n }, o) => /* @__PURE__ */ p.jsx(If, { ref: o, className: S("relative h-4 w-full overflow-hidden rounded-full bg-secondary", e), ...n, children: /* @__PURE__ */ p.jsx(
    u0,
    {
      className: "h-full w-full flex-1 bg-primary transition-all",
      style: { transform: `translateX(-${100 - (t || 0)}%)` }
    }
  ) })
);
wf.displayName = If.displayName;
const ZE = (e) => {
  const { className: t = "", value: n } = e;
  return /* @__PURE__ */ p.jsx(wf, { value: n, className: S(`nyn-progress bg-border rounded ${t}`) });
};
var bi = "Radio", [d0, Af] = ye(bi), [f0, p0] = d0(bi), Ef = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: o,
      checked: r = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: c,
      form: l,
      ...u
    } = e, [f, g] = d.useState(null), b = ne(t, (v) => g(v)), C = d.useRef(!1), m = f ? l || !!f.closest("form") : !0;
    return /* @__PURE__ */ p.jsxs(f0, { scope: n, checked: r, disabled: i, children: [
      /* @__PURE__ */ p.jsx(
        z.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": r,
          "data-state": Pf(r),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...u,
          ref: b,
          onClick: G(e.onClick, (v) => {
            r || c == null || c(), m && (C.current = v.isPropagationStopped(), C.current || v.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ p.jsx(
        Nf,
        {
          control: f,
          bubbles: !C.current,
          name: o,
          value: s,
          checked: r,
          required: a,
          disabled: i,
          form: l,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Ef.displayName = bi;
var Rf = "RadioIndicator", Sf = d.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: o, ...r } = e, a = p0(Rf, n);
    return /* @__PURE__ */ p.jsx(Se, { present: o || a.checked, children: /* @__PURE__ */ p.jsx(
      z.span,
      {
        "data-state": Pf(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    ) });
  }
);
Sf.displayName = Rf;
var g0 = "RadioBubbleInput", Nf = d.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const i = d.useRef(null), s = ne(i, a), c = Fa(n), l = Br(t);
    return d.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const f = window.HTMLInputElement.prototype, b = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (c !== n && b) {
        const C = new Event("click", { bubbles: o });
        b.call(u, n), u.dispatchEvent(C);
      }
    }, [c, n, o]), /* @__PURE__ */ p.jsx(
      z.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...l,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Nf.displayName = g0;
function Pf(e) {
  return e ? "checked" : "unchecked";
}
var m0 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], to = "RadioGroup", [b0, $E] = ye(to, [
  an,
  Af
]), _f = an(), Tf = Af(), [v0, h0] = b0(to), Df = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: o,
      defaultValue: r,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: c,
      dir: l,
      loop: u = !0,
      onValueChange: f,
      ...g
    } = e, b = _f(n), C = Nn(l), [m, v] = Oe({
      prop: a,
      defaultProp: r ?? null,
      onChange: f,
      caller: to
    });
    return /* @__PURE__ */ p.jsx(
      v0,
      {
        scope: n,
        name: o,
        required: i,
        disabled: s,
        value: m,
        onValueChange: v,
        children: /* @__PURE__ */ p.jsx(
          ri,
          {
            asChild: !0,
            ...b,
            orientation: c,
            dir: C,
            loop: u,
            children: /* @__PURE__ */ p.jsx(
              z.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": c,
                "data-disabled": s ? "" : void 0,
                dir: C,
                ...g,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Df.displayName = to;
var Mf = "RadioGroupItem", Ff = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: o, ...r } = e, a = h0(Mf, n), i = a.disabled || o, s = _f(n), c = Tf(n), l = d.useRef(null), u = ne(t, l), f = a.value === r.value, g = d.useRef(!1);
    return d.useEffect(() => {
      const b = (m) => {
        m0.includes(m.key) && (g.current = !0);
      }, C = () => g.current = !1;
      return document.addEventListener("keydown", b), document.addEventListener("keyup", C), () => {
        document.removeEventListener("keydown", b), document.removeEventListener("keyup", C);
      };
    }, []), /* @__PURE__ */ p.jsx(
      oi,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: f,
        children: /* @__PURE__ */ p.jsx(
          Ef,
          {
            disabled: i,
            required: a.required,
            checked: f,
            ...c,
            ...r,
            name: a.name,
            ref: u,
            onCheck: () => a.onValueChange(r.value),
            onKeyDown: G((b) => {
              b.key === "Enter" && b.preventDefault();
            }),
            onFocus: G(r.onFocus, () => {
              var b;
              g.current && ((b = l.current) == null || b.click());
            })
          }
        )
      }
    );
  }
);
Ff.displayName = Mf;
var x0 = "RadioGroupIndicator", Of = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...o } = e, r = Tf(n);
    return /* @__PURE__ */ p.jsx(Sf, { ...r, ...o, ref: t });
  }
);
Of.displayName = x0;
var Gf = Df, kf = Ff, y0 = Of;
const jf = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Gf, { className: S("grid gap-2", e), ...t, ref: n }));
jf.displayName = Gf.displayName;
const Vf = d.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ p.jsx(
  kf,
  {
    ref: o,
    className: S(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...n,
    children: /* @__PURE__ */ p.jsx(y0, { className: "flex items-center justify-center", children: /* @__PURE__ */ p.jsx(Wc, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
Vf.displayName = kf.displayName;
const YE = (e) => {
  const {
    items: t,
    selected: n,
    onChange: o,
    orientation: r = "horizontal",
    className: a = "",
    itemClassName: i = "",
    radioClassName: s = "",
    labelClassName: c = "",
    disabled: l = !1
  } = e;
  return /* @__PURE__ */ p.jsx(
    jf,
    {
      orientation: r,
      defaultValue: n,
      value: n,
      disabled: l,
      onValueChange: o,
      className: S(`${r === "horizontal" ? "flex flex-row flex-wrap" : "flex flex-col"} ${a}`),
      children: t.map((u, f) => /* @__PURE__ */ p.jsxs("div", { className: S(`flex items-center space-x-2 ${i}`), children: [
        /* @__PURE__ */ p.jsx(Vf, { className: "" + s, value: u.value, id: "r" + f }),
        /* @__PURE__ */ p.jsx(Tt, { htmlFor: "radio-" + f, className: S(`text-text ${c}`), children: u.label })
      ] }, f))
    }
  );
};
function Pt(e) {
  "@babel/helpers - typeof";
  return Pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pt(e);
}
function C0(e, t) {
  if (Pt(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Pt(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bf(e) {
  var t = C0(e, "string");
  return Pt(t) == "symbol" ? t : t + "";
}
function mn(e, t, n) {
  return (t = Bf(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Bs(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function H(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bs(Object(n), !0).forEach(function(o) {
      mn(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bs(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function I0(e) {
  if (Array.isArray(e)) return e;
}
function w0(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var o, r, a, i, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (o = a.call(n)).done) && (s.push(o.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, r = u;
    } finally {
      try {
        if (!c && n.return != null && (i = n.return(), Object(i) !== i)) return;
      } finally {
        if (l) throw r;
      }
    }
    return s;
  }
}
function ua(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Lf(e, t) {
  if (e) {
    if (typeof e == "string") return ua(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ua(e, t) : void 0;
  }
}
function A0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ft(e, t) {
  return I0(e) || w0(e, t) || Lf(e, t) || A0();
}
function E0(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    n[o] = e[o];
  }
  return n;
}
function st(e, t) {
  if (e == null) return {};
  var n, o, r = E0(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++) n = a[o], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
var R0 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Wf(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, o = e.defaultMenuIsOpen, r = o === void 0 ? !1 : o, a = e.defaultValue, i = a === void 0 ? null : a, s = e.inputValue, c = e.menuIsOpen, l = e.onChange, u = e.onInputChange, f = e.onMenuClose, g = e.onMenuOpen, b = e.value, C = st(e, R0), m = dt(s !== void 0 ? s : n), v = ft(m, 2), h = v[0], I = v[1], x = dt(c !== void 0 ? c : r), y = ft(x, 2), w = y[0], R = y[1], E = dt(b !== void 0 ? b : i), N = ft(E, 2), _ = N[0], D = N[1], O = Ee(function(j, F) {
    typeof l == "function" && l(j, F), D(j);
  }, [l]), T = Ee(function(j, F) {
    var U;
    typeof u == "function" && (U = u(j, F)), I(U !== void 0 ? U : j);
  }, [u]), L = Ee(function() {
    typeof g == "function" && g(), R(!0);
  }, [g]), M = Ee(function() {
    typeof f == "function" && f(), R(!1);
  }, [f]), B = s !== void 0 ? s : h, k = c !== void 0 ? c : w, $ = b !== void 0 ? b : _;
  return H(H({}, C), {}, {
    inputValue: B,
    menuIsOpen: k,
    onChange: O,
    onInputChange: T,
    onMenuClose: M,
    onMenuOpen: L,
    value: $
  });
}
function Z() {
  return Z = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Z.apply(null, arguments);
}
function S0(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ls(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Bf(o.key), o);
  }
}
function N0(e, t, n) {
  return t && Ls(e.prototype, t), n && Ls(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function da(e, t) {
  return da = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, da(e, t);
}
function P0(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && da(e, t);
}
function Nr(e) {
  return Nr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Nr(e);
}
function Xf() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Xf = function() {
    return !!e;
  })();
}
function _0(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function T0(e, t) {
  if (t && (Pt(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _0(e);
}
function D0(e) {
  var t = Xf();
  return function() {
    var n, o = Nr(e);
    if (t) {
      var r = Nr(this).constructor;
      n = Reflect.construct(o, arguments, r);
    } else n = o.apply(this, arguments);
    return T0(this, n);
  };
}
function M0(e) {
  if (Array.isArray(e)) return ua(e);
}
function F0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function O0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yt(e) {
  return M0(e) || F0(e) || Lf(e) || O0();
}
function G0(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function k0(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var j0 = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(r) {
      var a;
      o.tags.length === 0 ? o.insertionPoint ? a = o.insertionPoint.nextSibling : o.prepend ? a = o.container.firstChild : a = o.before : a = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(r, a), o.tags.push(r);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(k0(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = G0(r);
      try {
        a.insertRule(o, a.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      var r;
      return (r = o.parentNode) == null ? void 0 : r.removeChild(o);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Ae = "-ms-", Pr = "-moz-", oe = "-webkit-", Hf = "comm", vi = "rule", hi = "decl", V0 = "@import", zf = "@keyframes", B0 = "@layer", L0 = Math.abs, no = String.fromCharCode, W0 = Object.assign;
function X0(e, t) {
  return we(e, 0) ^ 45 ? (((t << 2 ^ we(e, 0)) << 2 ^ we(e, 1)) << 2 ^ we(e, 2)) << 2 ^ we(e, 3) : 0;
}
function Zf(e) {
  return e.trim();
}
function H0(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ae(e, t, n) {
  return e.replace(t, n);
}
function fa(e, t) {
  return e.indexOf(t);
}
function we(e, t) {
  return e.charCodeAt(t) | 0;
}
function wn(e, t, n) {
  return e.slice(t, n);
}
function Ue(e) {
  return e.length;
}
function xi(e) {
  return e.length;
}
function ar(e, t) {
  return t.push(e), e;
}
function z0(e, t) {
  return e.map(t).join("");
}
var ro = 1, Kt = 1, $f = 0, Fe = 0, xe = 0, sn = "";
function oo(e, t, n, o, r, a, i) {
  return { value: e, root: t, parent: n, type: o, props: r, children: a, line: ro, column: Kt, length: i, return: "" };
}
function fn(e, t) {
  return W0(oo("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Z0() {
  return xe;
}
function $0() {
  return xe = Fe > 0 ? we(sn, --Fe) : 0, Kt--, xe === 10 && (Kt = 1, ro--), xe;
}
function Be() {
  return xe = Fe < $f ? we(sn, Fe++) : 0, Kt++, xe === 10 && (Kt = 1, ro++), xe;
}
function nt() {
  return we(sn, Fe);
}
function pr() {
  return Fe;
}
function Ln(e, t) {
  return wn(sn, e, t);
}
function An(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Yf(e) {
  return ro = Kt = 1, $f = Ue(sn = e), Fe = 0, [];
}
function Jf(e) {
  return sn = "", e;
}
function gr(e) {
  return Zf(Ln(Fe - 1, pa(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y0(e) {
  for (; (xe = nt()) && xe < 33; )
    Be();
  return An(e) > 2 || An(xe) > 3 ? "" : " ";
}
function J0(e, t) {
  for (; --t && Be() && !(xe < 48 || xe > 102 || xe > 57 && xe < 65 || xe > 70 && xe < 97); )
    ;
  return Ln(e, pr() + (t < 6 && nt() == 32 && Be() == 32));
}
function pa(e) {
  for (; Be(); )
    switch (xe) {
      // ] ) " '
      case e:
        return Fe;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && pa(xe);
        break;
      // (
      case 40:
        e === 41 && pa(e);
        break;
      // \
      case 92:
        Be();
        break;
    }
  return Fe;
}
function U0(e, t) {
  for (; Be() && e + xe !== 57; )
    if (e + xe === 84 && nt() === 47)
      break;
  return "/*" + Ln(t, Fe - 1) + "*" + no(e === 47 ? e : Be());
}
function Q0(e) {
  for (; !An(nt()); )
    Be();
  return Ln(e, Fe);
}
function K0(e) {
  return Jf(mr("", null, null, null, [""], e = Yf(e), 0, [0], e));
}
function mr(e, t, n, o, r, a, i, s, c) {
  for (var l = 0, u = 0, f = i, g = 0, b = 0, C = 0, m = 1, v = 1, h = 1, I = 0, x = "", y = r, w = a, R = o, E = x; v; )
    switch (C = I, I = Be()) {
      // (
      case 40:
        if (C != 108 && we(E, f - 1) == 58) {
          fa(E += ae(gr(I), "&", "&\f"), "&\f") != -1 && (h = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        E += gr(I);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        E += Y0(C);
        break;
      // \
      case 92:
        E += J0(pr() - 1, 7);
        continue;
      // /
      case 47:
        switch (nt()) {
          case 42:
          case 47:
            ar(q0(U0(Be(), pr()), t, n), c);
            break;
          default:
            E += "/";
        }
        break;
      // {
      case 123 * m:
        s[l++] = Ue(E) * h;
      // } ; \0
      case 125 * m:
      case 59:
      case 0:
        switch (I) {
          // \0 }
          case 0:
          case 125:
            v = 0;
          // ;
          case 59 + u:
            h == -1 && (E = ae(E, /\f/g, "")), b > 0 && Ue(E) - f && ar(b > 32 ? Xs(E + ";", o, n, f - 1) : Xs(ae(E, " ", "") + ";", o, n, f - 2), c);
            break;
          // @ ;
          case 59:
            E += ";";
          // { rule/at-rule
          default:
            if (ar(R = Ws(E, t, n, l, u, r, s, x, y = [], w = [], f), a), I === 123)
              if (u === 0)
                mr(E, t, R, R, y, a, f, s, w);
              else
                switch (g === 99 && we(E, 3) === 110 ? 100 : g) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    mr(e, R, R, o && ar(Ws(e, R, R, 0, 0, r, s, x, r, y = [], f), w), r, w, f, s, o ? y : w);
                    break;
                  default:
                    mr(E, R, R, R, [""], w, 0, s, w);
                }
        }
        l = u = b = 0, m = h = 1, x = E = "", f = i;
        break;
      // :
      case 58:
        f = 1 + Ue(E), b = C;
      default:
        if (m < 1) {
          if (I == 123)
            --m;
          else if (I == 125 && m++ == 0 && $0() == 125)
            continue;
        }
        switch (E += no(I), I * m) {
          // &
          case 38:
            h = u > 0 ? 1 : (E += "\f", -1);
            break;
          // ,
          case 44:
            s[l++] = (Ue(E) - 1) * h, h = 1;
            break;
          // @
          case 64:
            nt() === 45 && (E += gr(Be())), g = nt(), u = f = Ue(x = E += Q0(pr())), I++;
            break;
          // -
          case 45:
            C === 45 && Ue(E) == 2 && (m = 0);
        }
    }
  return a;
}
function Ws(e, t, n, o, r, a, i, s, c, l, u) {
  for (var f = r - 1, g = r === 0 ? a : [""], b = xi(g), C = 0, m = 0, v = 0; C < o; ++C)
    for (var h = 0, I = wn(e, f + 1, f = L0(m = i[C])), x = e; h < b; ++h)
      (x = Zf(m > 0 ? g[h] + " " + I : ae(I, /&\f/g, g[h]))) && (c[v++] = x);
  return oo(e, t, n, r === 0 ? vi : s, c, l, u);
}
function q0(e, t, n) {
  return oo(e, t, n, Hf, no(Z0()), wn(e, 2, -2), 0);
}
function Xs(e, t, n, o) {
  return oo(e, t, n, hi, wn(e, 0, o), wn(e, o + 1, -1), o);
}
function Jt(e, t) {
  for (var n = "", o = xi(e), r = 0; r < o; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function eI(e, t, n, o) {
  switch (e.type) {
    case B0:
      if (e.children.length) break;
    case V0:
    case hi:
      return e.return = e.return || e.value;
    case Hf:
      return "";
    case zf:
      return e.return = e.value + "{" + Jt(e.children, o) + "}";
    case vi:
      e.value = e.props.join(",");
  }
  return Ue(n = Jt(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function tI(e) {
  var t = xi(e);
  return function(n, o, r, a) {
    for (var i = "", s = 0; s < t; s++)
      i += e[s](n, o, r, a) || "";
    return i;
  };
}
function nI(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function rI(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var oI = function(t, n, o) {
  for (var r = 0, a = 0; r = a, a = nt(), r === 38 && a === 12 && (n[o] = 1), !An(a); )
    Be();
  return Ln(t, Fe);
}, aI = function(t, n) {
  var o = -1, r = 44;
  do
    switch (An(r)) {
      case 0:
        r === 38 && nt() === 12 && (n[o] = 1), t[o] += oI(Fe - 1, n, o);
        break;
      case 2:
        t[o] += gr(r);
        break;
      case 4:
        if (r === 44) {
          t[++o] = nt() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      // fallthrough
      default:
        t[o] += no(r);
    }
  while (r = Be());
  return t;
}, iI = function(t, n) {
  return Jf(aI(Yf(t), n));
}, Hs = /* @__PURE__ */ new WeakMap(), sI = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, r = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !Hs.get(o)) && !r) {
      Hs.set(t, !0);
      for (var a = [], i = iI(n, a), s = o.props, c = 0, l = 0; c < i.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = a[c] ? i[c].replace(/&\f/g, s[u]) : s[u] + " " + i[c];
    }
  }
}, cI = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Uf(e, t) {
  switch (X0(e, t)) {
    // color-adjust
    case 5103:
      return oe + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return oe + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return oe + e + Pr + e + Ae + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return oe + e + Ae + e + e;
    // order
    case 6165:
      return oe + e + Ae + "flex-" + e + e;
    // align-items
    case 5187:
      return oe + e + ae(e, /(\w+).+(:[^]+)/, oe + "box-$1$2" + Ae + "flex-$1$2") + e;
    // align-self
    case 5443:
      return oe + e + Ae + "flex-item-" + ae(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return oe + e + Ae + "flex-line-pack" + ae(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return oe + e + Ae + ae(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return oe + e + Ae + ae(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return oe + "box-" + ae(e, "-grow", "") + oe + e + Ae + ae(e, "grow", "positive") + e;
    // transition
    case 4554:
      return oe + ae(e, /([^-])(transform)/g, "$1" + oe + "$2") + e;
    // cursor
    case 6187:
      return ae(ae(ae(e, /(zoom-|grab)/, oe + "$1"), /(image-set)/, oe + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return ae(e, /(image-set\([^]*)/, oe + "$1$`$1");
    // justify-content
    case 4968:
      return ae(ae(e, /(.+:)(flex-)?(.*)/, oe + "box-pack:$3" + Ae + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + oe + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ae(e, /(.+)-inline(.+)/, oe + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ue(e) - 1 - t > 6) switch (we(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (we(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return ae(e, /(.+:)(.+)-([^]+)/, "$1" + oe + "$2-$3$1" + Pr + (we(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~fa(e, "stretch") ? Uf(ae(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (we(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (we(e, Ue(e) - 3 - (~fa(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return ae(e, ":", ":" + oe) + e;
        // (inline-)?fl(e)x
        case 101:
          return ae(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + oe + (we(e, 14) === 45 ? "inline-" : "") + "box$3$1" + oe + "$2$3$1" + Ae + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (we(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return oe + e + Ae + ae(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return oe + e + Ae + ae(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return oe + e + Ae + ae(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return oe + e + Ae + e + e;
  }
  return e;
}
var lI = function(t, n, o, r) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case hi:
      t.return = Uf(t.value, t.length);
      break;
    case zf:
      return Jt([fn(t, {
        value: ae(t.value, "@", "@" + oe)
      })], r);
    case vi:
      if (t.length) return z0(t.props, function(a) {
        switch (H0(a, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return Jt([fn(t, {
              props: [ae(a, /:(read-\w+)/, ":" + Pr + "$1")]
            })], r);
          // :placeholder
          case "::placeholder":
            return Jt([fn(t, {
              props: [ae(a, /:(plac\w+)/, ":" + oe + "input-$1")]
            }), fn(t, {
              props: [ae(a, /:(plac\w+)/, ":" + Pr + "$1")]
            }), fn(t, {
              props: [ae(a, /:(plac\w+)/, Ae + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, uI = [lI], dI = function(t) {
  var n = t.key;
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(m) {
      var v = m.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || uI, a = {}, i, s = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(m) {
      for (var v = m.getAttribute("data-emotion").split(" "), h = 1; h < v.length; h++)
        a[v[h]] = !0;
      s.push(m);
    }
  );
  var c, l = [sI, cI];
  {
    var u, f = [eI, nI(function(m) {
      u.insert(m);
    })], g = tI(l.concat(r, f)), b = function(v) {
      return Jt(K0(v), g);
    };
    c = function(v, h, I, x) {
      u = I, b(v ? v + "{" + h.styles + "}" : h.styles), x && (C.inserted[h.name] = !0);
    };
  }
  var C = {
    key: n,
    sheet: new j0({
      key: n,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return C.sheet.hydrate(s), C;
}, ir = { exports: {} }, se = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zs;
function fI() {
  if (zs) return se;
  zs = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function x(w) {
    if (typeof w == "object" && w !== null) {
      var R = w.$$typeof;
      switch (R) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case o:
            case a:
            case r:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case C:
                case b:
                case i:
                  return w;
                default:
                  return R;
              }
          }
        case n:
          return R;
      }
    }
  }
  function y(w) {
    return x(w) === l;
  }
  return se.AsyncMode = c, se.ConcurrentMode = l, se.ContextConsumer = s, se.ContextProvider = i, se.Element = t, se.ForwardRef = u, se.Fragment = o, se.Lazy = C, se.Memo = b, se.Portal = n, se.Profiler = a, se.StrictMode = r, se.Suspense = f, se.isAsyncMode = function(w) {
    return y(w) || x(w) === c;
  }, se.isConcurrentMode = y, se.isContextConsumer = function(w) {
    return x(w) === s;
  }, se.isContextProvider = function(w) {
    return x(w) === i;
  }, se.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, se.isForwardRef = function(w) {
    return x(w) === u;
  }, se.isFragment = function(w) {
    return x(w) === o;
  }, se.isLazy = function(w) {
    return x(w) === C;
  }, se.isMemo = function(w) {
    return x(w) === b;
  }, se.isPortal = function(w) {
    return x(w) === n;
  }, se.isProfiler = function(w) {
    return x(w) === a;
  }, se.isStrictMode = function(w) {
    return x(w) === r;
  }, se.isSuspense = function(w) {
    return x(w) === f;
  }, se.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === o || w === l || w === a || w === r || w === f || w === g || typeof w == "object" && w !== null && (w.$$typeof === C || w.$$typeof === b || w.$$typeof === i || w.$$typeof === s || w.$$typeof === u || w.$$typeof === v || w.$$typeof === h || w.$$typeof === I || w.$$typeof === m);
  }, se.typeOf = x, se;
}
var ce = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zs;
function pI() {
  return Zs || (Zs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, r = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function x(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === o || W === l || W === a || W === r || W === f || W === g || typeof W == "object" && W !== null && (W.$$typeof === C || W.$$typeof === b || W.$$typeof === i || W.$$typeof === s || W.$$typeof === u || W.$$typeof === v || W.$$typeof === h || W.$$typeof === I || W.$$typeof === m);
    }
    function y(W) {
      if (typeof W == "object" && W !== null) {
        var Ge = W.$$typeof;
        switch (Ge) {
          case t:
            var Le = W.type;
            switch (Le) {
              case c:
              case l:
              case o:
              case a:
              case r:
              case f:
                return Le;
              default:
                var He = Le && Le.$$typeof;
                switch (He) {
                  case s:
                  case u:
                  case C:
                  case b:
                  case i:
                    return He;
                  default:
                    return Ge;
                }
            }
          case n:
            return Ge;
        }
      }
    }
    var w = c, R = l, E = s, N = i, _ = t, D = u, O = o, T = C, L = b, M = n, B = a, k = r, $ = f, j = !1;
    function F(W) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(W) || y(W) === c;
    }
    function U(W) {
      return y(W) === l;
    }
    function re(W) {
      return y(W) === s;
    }
    function J(W) {
      return y(W) === i;
    }
    function Q(W) {
      return typeof W == "object" && W !== null && W.$$typeof === t;
    }
    function ge(W) {
      return y(W) === u;
    }
    function Ce(W) {
      return y(W) === o;
    }
    function ue(W) {
      return y(W) === C;
    }
    function fe(W) {
      return y(W) === b;
    }
    function me(W) {
      return y(W) === n;
    }
    function pe(W) {
      return y(W) === a;
    }
    function _e(W) {
      return y(W) === r;
    }
    function ct(W) {
      return y(W) === f;
    }
    ce.AsyncMode = w, ce.ConcurrentMode = R, ce.ContextConsumer = E, ce.ContextProvider = N, ce.Element = _, ce.ForwardRef = D, ce.Fragment = O, ce.Lazy = T, ce.Memo = L, ce.Portal = M, ce.Profiler = B, ce.StrictMode = k, ce.Suspense = $, ce.isAsyncMode = F, ce.isConcurrentMode = U, ce.isContextConsumer = re, ce.isContextProvider = J, ce.isElement = Q, ce.isForwardRef = ge, ce.isFragment = Ce, ce.isLazy = ue, ce.isMemo = fe, ce.isPortal = me, ce.isProfiler = pe, ce.isStrictMode = _e, ce.isSuspense = ct, ce.isValidElementType = x, ce.typeOf = y;
  }()), ce;
}
var $s;
function gI() {
  return $s || ($s = 1, process.env.NODE_ENV === "production" ? ir.exports = fI() : ir.exports = pI()), ir.exports;
}
var ko, Ys;
function mI() {
  if (Ys) return ko;
  Ys = 1;
  var e = gI(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, o = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, r = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, a = {};
  a[e.ForwardRef] = o, a[e.Memo] = r;
  function i(C) {
    return e.isMemo(C) ? r : a[C.$$typeof] || t;
  }
  var s = Object.defineProperty, c = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, u = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, g = Object.prototype;
  function b(C, m, v) {
    if (typeof m != "string") {
      if (g) {
        var h = f(m);
        h && h !== g && b(C, h, v);
      }
      var I = c(m);
      l && (I = I.concat(l(m)));
      for (var x = i(C), y = i(m), w = 0; w < I.length; ++w) {
        var R = I[w];
        if (!n[R] && !(v && v[R]) && !(y && y[R]) && !(x && x[R])) {
          var E = u(m, R);
          try {
            s(C, R, E);
          } catch {
          }
        }
      }
    }
    return C;
  }
  return ko = b, ko;
}
mI();
var bI = !0;
function vI(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : r && (o += r + " ");
  }), o;
}
var Qf = function(t, n, o) {
  var r = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  bI === !1) && t.registered[r] === void 0 && (t.registered[r] = n.styles);
}, hI = function(t, n, o) {
  Qf(t, n, o);
  var r = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + r : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function xI(e) {
  for (var t = 0, n, o = 0, r = e.length; r >= 4; ++o, r -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var yI = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, CI = /[A-Z]|^ms/g, II = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Kf = function(t) {
  return t.charCodeAt(1) === 45;
}, Js = function(t) {
  return t != null && typeof t != "boolean";
}, jo = /* @__PURE__ */ rI(function(e) {
  return Kf(e) ? e : e.replace(CI, "-$&").toLowerCase();
}), Us = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(II, function(o, r, a) {
          return Qe = {
            name: r,
            styles: a,
            next: Qe
          }, r;
        });
  }
  return yI[t] !== 1 && !Kf(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function En(e, t, n) {
  if (n == null)
    return "";
  var o = n;
  if (o.__emotion_styles !== void 0)
    return o;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var r = n;
      if (r.anim === 1)
        return Qe = {
          name: r.name,
          styles: r.styles,
          next: Qe
        }, r.name;
      var a = n;
      if (a.styles !== void 0) {
        var i = a.next;
        if (i !== void 0)
          for (; i !== void 0; )
            Qe = {
              name: i.name,
              styles: i.styles,
              next: Qe
            }, i = i.next;
        var s = a.styles + ";";
        return s;
      }
      return wI(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Qe, l = n(e);
        return Qe = c, En(e, t, l);
      }
      break;
    }
  }
  var u = n;
  return u;
}
function wI(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      o += En(e, t, n[r]) + ";";
  else
    for (var a in n) {
      var i = n[a];
      if (typeof i != "object") {
        var s = i;
        Js(s) && (o += jo(a) + ":" + Us(a, s) + ";");
      } else if (Array.isArray(i) && typeof i[0] == "string" && t == null)
        for (var c = 0; c < i.length; c++)
          Js(i[c]) && (o += jo(a) + ":" + Us(a, i[c]) + ";");
      else {
        var l = En(e, t, i);
        switch (a) {
          case "animation":
          case "animationName": {
            o += jo(a) + ":" + l + ";";
            break;
          }
          default:
            o += a + "{" + l + "}";
        }
      }
    }
  return o;
}
var Qs = /label:\s*([^\s;{]+)\s*(;|$)/g, Qe;
function qf(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, r = "";
  Qe = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    o = !1, r += En(n, t, a);
  else {
    var i = a;
    r += i[0];
  }
  for (var s = 1; s < e.length; s++)
    if (r += En(n, t, e[s]), o) {
      var c = a;
      r += c[s];
    }
  Qs.lastIndex = 0;
  for (var l = "", u; (u = Qs.exec(r)) !== null; )
    l += "-" + u[1];
  var f = xI(r) + l;
  return {
    name: f,
    styles: r,
    next: Qe
  };
}
var AI = function(t) {
  return t();
}, EI = d.useInsertionEffect ? d.useInsertionEffect : !1, RI = EI || AI, ep = /* @__PURE__ */ d.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ dI({
    key: "css"
  }) : null
);
ep.Provider;
var SI = function(t) {
  return /* @__PURE__ */ Sn(function(n, o) {
    var r = xc(ep);
    return t(n, r, o);
  });
}, NI = /* @__PURE__ */ d.createContext({}), yi = {}.hasOwnProperty, ga = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", PI = function(t, n) {
  var o = {};
  for (var r in n)
    yi.call(n, r) && (o[r] = n[r]);
  return o[ga] = t, o;
}, _I = function(t) {
  var n = t.cache, o = t.serialized, r = t.isStringTag;
  return Qf(n, o, r), RI(function() {
    return hI(n, o, r);
  }), null;
}, TI = /* @__PURE__ */ SI(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var r = e[ga], a = [o], i = "";
  typeof e.className == "string" ? i = vI(t.registered, a, e.className) : e.className != null && (i = e.className + " ");
  var s = qf(a, void 0, d.useContext(NI));
  i += t.key + "-" + s.name;
  var c = {};
  for (var l in e)
    yi.call(e, l) && l !== "css" && l !== ga && (c[l] = e[l]);
  return c.className = i, n && (c.ref = n), /* @__PURE__ */ d.createElement(d.Fragment, null, /* @__PURE__ */ d.createElement(_I, {
    cache: t,
    serialized: s,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ d.createElement(r, c));
}), DI = TI, X = function(t, n) {
  var o = arguments;
  if (n == null || !yi.call(n, "css"))
    return d.createElement.apply(void 0, o);
  var r = o.length, a = new Array(r);
  a[0] = DI, a[1] = PI(t, n);
  for (var i = 2; i < r; i++)
    a[i] = o[i];
  return d.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(X || (X = {}));
function Ci() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return qf(t);
}
function MI() {
  var e = Ci.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function FI(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
var ma = hc, OI = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], _r = function() {
};
function GI(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function kI(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    o[r - 2] = arguments[r];
  var a = [].concat(o);
  if (t && e)
    for (var i in t)
      t.hasOwnProperty(i) && t[i] && a.push("".concat(GI(e, i)));
  return a.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Tr = function(t) {
  return ZI(t) ? t.filter(Boolean) : Pt(t) === "object" && t !== null ? [t] : [];
}, tp = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = st(t, OI);
  return H({}, n);
}, be = function(t, n, o) {
  var r = t.cx, a = t.getStyles, i = t.getClassNames, s = t.className;
  return {
    css: a(n, t),
    className: r(o ?? {}, i(n, t), s)
  };
};
function ao(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function jI(e) {
  return ao(e) ? window.innerHeight : e.clientHeight;
}
function np(e) {
  return ao(e) ? window.pageYOffset : e.scrollTop;
}
function Dr(e, t) {
  if (ao(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function VI(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", o = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var r = e; r = r.parentElement; )
    if (t = getComputedStyle(r), !(n && t.position === "static") && o.test(t.overflow + t.overflowY + t.overflowX))
      return r;
  return document.documentElement;
}
function BI(e, t, n, o) {
  return n * ((e = e / o - 1) * e * e + 1) + t;
}
function sr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : _r, r = np(e), a = t - r, i = 10, s = 0;
  function c() {
    s += i;
    var l = BI(s, r, a, n);
    Dr(e, l), s < n ? window.requestAnimationFrame(c) : o(e);
  }
  c();
}
function Ks(e, t) {
  var n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = t.offsetHeight / 3;
  o.bottom + r > n.bottom ? Dr(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : o.top - r < n.top && Dr(e, Math.max(t.offsetTop - r, 0));
}
function LI(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function qs() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function WI() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var rp = !1, XI = {
  get passive() {
    return rp = !0;
  }
}, cr = typeof window < "u" ? window : {};
cr.addEventListener && cr.removeEventListener && (cr.addEventListener("p", _r, XI), cr.removeEventListener("p", _r, !1));
var HI = rp;
function zI(e) {
  return e != null;
}
function ZI(e) {
  return Array.isArray(e);
}
function bn(e, t, n) {
  return e ? t : n;
}
var $I = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    o[r - 1] = arguments[r];
  var a = Object.entries(t).filter(function(i) {
    var s = ft(i, 1), c = s[0];
    return !o.includes(c);
  });
  return a.reduce(function(i, s) {
    var c = ft(s, 2), l = c[0], u = c[1];
    return i[l] = u, i;
  }, {});
}, YI = ["children", "innerProps"], JI = ["children", "innerProps"];
function UI(e) {
  var t = e.maxHeight, n = e.menuEl, o = e.minHeight, r = e.placement, a = e.shouldScroll, i = e.isFixedPosition, s = e.controlHeight, c = VI(n), l = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent) return l;
  var u = c.getBoundingClientRect(), f = u.height, g = n.getBoundingClientRect(), b = g.bottom, C = g.height, m = g.top, v = n.offsetParent.getBoundingClientRect(), h = v.top, I = i ? window.innerHeight : jI(c), x = np(c), y = parseInt(getComputedStyle(n).marginBottom, 10), w = parseInt(getComputedStyle(n).marginTop, 10), R = h - w, E = I - m, N = R + x, _ = f - x - m, D = b - I + x + y, O = x + m - w, T = 160;
  switch (r) {
    case "auto":
    case "bottom":
      if (E >= C)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (_ >= C && !i)
        return a && sr(c, D, T), {
          placement: "bottom",
          maxHeight: t
        };
      if (!i && _ >= o || i && E >= o) {
        a && sr(c, D, T);
        var L = i ? E - y : _ - y;
        return {
          placement: "bottom",
          maxHeight: L
        };
      }
      if (r === "auto" || i) {
        var M = t, B = i ? R : N;
        return B >= o && (M = Math.min(B - y - s, t)), {
          placement: "top",
          maxHeight: M
        };
      }
      if (r === "bottom")
        return a && Dr(c, D), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (R >= C)
        return {
          placement: "top",
          maxHeight: t
        };
      if (N >= C && !i)
        return a && sr(c, O, T), {
          placement: "top",
          maxHeight: t
        };
      if (!i && N >= o || i && R >= o) {
        var k = t;
        return (!i && N >= o || i && R >= o) && (k = i ? R - w : N - w), a && sr(c, O, T), {
          placement: "top",
          maxHeight: k
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }
  return l;
}
function QI(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var op = function(t) {
  return t === "auto" ? "bottom" : t;
}, KI = function(t, n) {
  var o, r = t.placement, a = t.theme, i = a.borderRadius, s = a.spacing, c = a.colors;
  return H((o = {
    label: "menu"
  }, mn(o, QI(r), "100%"), mn(o, "position", "absolute"), mn(o, "width", "100%"), mn(o, "zIndex", 1), o), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, ap = /* @__PURE__ */ cm(null), qI = function(t) {
  var n = t.children, o = t.minMenuHeight, r = t.maxMenuHeight, a = t.menuPlacement, i = t.menuPosition, s = t.menuShouldScrollIntoView, c = t.theme, l = xc(ap) || {}, u = l.setPortalPlacement, f = qe(null), g = dt(r), b = ft(g, 2), C = b[0], m = b[1], v = dt(null), h = ft(v, 2), I = h[0], x = h[1], y = c.spacing.controlHeight;
  return ma(function() {
    var w = f.current;
    if (w) {
      var R = i === "fixed", E = s && !R, N = UI({
        maxHeight: r,
        menuEl: w,
        minHeight: o,
        placement: a,
        shouldScroll: E,
        isFixedPosition: R,
        controlHeight: y
      });
      m(N.maxHeight), x(N.placement), u == null || u(N.placement);
    }
  }, [r, a, i, s, o, u, y]), n({
    ref: f,
    placerProps: H(H({}, t), {}, {
      placement: I || op(a),
      maxHeight: C
    })
  });
}, ew = function(t) {
  var n = t.children, o = t.innerRef, r = t.innerProps;
  return X("div", Z({}, be(t, "menu", {
    menu: !0
  }), {
    ref: o
  }, r), n);
}, tw = ew, nw = function(t, n) {
  var o = t.maxHeight, r = t.theme.spacing.baseUnit;
  return H({
    maxHeight: o,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: r,
    paddingTop: r
  });
}, rw = function(t) {
  var n = t.children, o = t.innerProps, r = t.innerRef, a = t.isMulti;
  return X("div", Z({}, be(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: r
  }, o), n);
}, ip = function(t, n) {
  var o = t.theme, r = o.spacing.baseUnit, a = o.colors;
  return H({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px")
  });
}, ow = ip, aw = ip, iw = function(t) {
  var n = t.children, o = n === void 0 ? "No options" : n, r = t.innerProps, a = st(t, YI);
  return X("div", Z({}, be(H(H({}, a), {}, {
    children: o,
    innerProps: r
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), r), o);
}, sw = function(t) {
  var n = t.children, o = n === void 0 ? "Loading..." : n, r = t.innerProps, a = st(t, JI);
  return X("div", Z({}, be(H(H({}, a), {}, {
    children: o,
    innerProps: r
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), r), o);
}, cw = function(t) {
  var n = t.rect, o = t.offset, r = t.position;
  return {
    left: n.left,
    position: r,
    top: o,
    width: n.width,
    zIndex: 1
  };
}, lw = function(t) {
  var n = t.appendTo, o = t.children, r = t.controlElement, a = t.innerProps, i = t.menuPlacement, s = t.menuPosition, c = qe(null), l = qe(null), u = dt(op(i)), f = ft(u, 2), g = f[0], b = f[1], C = ut(function() {
    return {
      setPortalPlacement: b
    };
  }, []), m = dt(null), v = ft(m, 2), h = v[0], I = v[1], x = Ee(function() {
    if (r) {
      var E = LI(r), N = s === "fixed" ? 0 : window.pageYOffset, _ = E[g] + N;
      (_ !== (h == null ? void 0 : h.offset) || E.left !== (h == null ? void 0 : h.rect.left) || E.width !== (h == null ? void 0 : h.rect.width)) && I({
        offset: _,
        rect: E
      });
    }
  }, [r, s, g, h == null ? void 0 : h.offset, h == null ? void 0 : h.rect.left, h == null ? void 0 : h.rect.width]);
  ma(function() {
    x();
  }, [x]);
  var y = Ee(function() {
    typeof l.current == "function" && (l.current(), l.current = null), r && c.current && (l.current = ju(r, c.current, x, {
      elementResize: "ResizeObserver" in window
    }));
  }, [r, x]);
  ma(function() {
    y();
  }, [y]);
  var w = Ee(function(E) {
    c.current = E, y();
  }, [y]);
  if (!n && s !== "fixed" || !h) return null;
  var R = X("div", Z({
    ref: w
  }, be(H(H({}, t), {}, {
    offset: h.offset,
    position: s,
    rect: h.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), o);
  return X(ap.Provider, {
    value: C
  }, n ? /* @__PURE__ */ um(R, n) : R);
}, uw = function(t) {
  var n = t.isDisabled, o = t.isRtl;
  return {
    label: "container",
    direction: o ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, dw = function(t) {
  var n = t.children, o = t.innerProps, r = t.isDisabled, a = t.isRtl;
  return X("div", Z({}, be(t, "container", {
    "--is-disabled": r,
    "--is-rtl": a
  }), o), n);
}, fw = function(t, n) {
  var o = t.theme.spacing, r = t.isMulti, a = t.hasValue, i = t.selectProps.controlShouldRenderValue;
  return H({
    alignItems: "center",
    display: r && a && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(o.baseUnit / 2, "px ").concat(o.baseUnit * 2, "px")
  });
}, pw = function(t) {
  var n = t.children, o = t.innerProps, r = t.isMulti, a = t.hasValue;
  return X("div", Z({}, be(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": r,
    "value-container--has-value": a
  }), o), n);
}, gw = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, mw = function(t) {
  var n = t.children, o = t.innerProps;
  return X("div", Z({}, be(t, "indicatorsContainer", {
    indicators: !0
  }), o), n);
}, ec, bw = ["size"], vw = ["innerProps", "isRtl", "size"];
function hw() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var xw = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: hw
}, sp = function(t) {
  var n = t.size, o = st(t, bw);
  return X("svg", Z({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: xw
  }, o));
}, Ii = function(t) {
  return X(sp, Z({
    size: 20
  }, t), X("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, cp = function(t) {
  return X(sp, Z({
    size: 20
  }, t), X("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, lp = function(t, n) {
  var o = t.isFocused, r = t.theme, a = r.spacing.baseUnit, i = r.colors;
  return H({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: o ? i.neutral60 : i.neutral20,
    padding: a * 2,
    ":hover": {
      color: o ? i.neutral80 : i.neutral40
    }
  });
}, yw = lp, Cw = function(t) {
  var n = t.children, o = t.innerProps;
  return X("div", Z({}, be(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), o), n || X(cp, null));
}, Iw = lp, ww = function(t) {
  var n = t.children, o = t.innerProps;
  return X("div", Z({}, be(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), o), n || X(Ii, null));
}, Aw = function(t, n) {
  var o = t.isDisabled, r = t.theme, a = r.spacing.baseUnit, i = r.colors;
  return H({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: o ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, Ew = function(t) {
  var n = t.innerProps;
  return X("span", Z({}, n, be(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Rw = MI(ec || (ec = FI([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), Sw = function(t, n) {
  var o = t.isFocused, r = t.size, a = t.theme, i = a.colors, s = a.spacing.baseUnit;
  return H({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: o ? i.neutral60 : i.neutral20,
    padding: s * 2
  });
}, Vo = function(t) {
  var n = t.delay, o = t.offset;
  return X("span", {
    css: /* @__PURE__ */ Ci({
      animation: "".concat(Rw, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: o ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Nw = function(t) {
  var n = t.innerProps, o = t.isRtl, r = t.size, a = r === void 0 ? 4 : r, i = st(t, vw);
  return X("div", Z({}, be(H(H({}, i), {}, {
    innerProps: n,
    isRtl: o,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), X(Vo, {
    delay: 0,
    offset: o
  }), X(Vo, {
    delay: 160,
    offset: !0
  }), X(Vo, {
    delay: 320,
    offset: !o
  }));
}, Pw = function(t, n) {
  var o = t.isDisabled, r = t.isFocused, a = t.theme, i = a.colors, s = a.borderRadius, c = a.spacing;
  return H({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: o ? i.neutral5 : i.neutral0,
    borderColor: o ? i.neutral10 : r ? i.primary : i.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: r ? i.primary : i.neutral30
    }
  });
}, _w = function(t) {
  var n = t.children, o = t.isDisabled, r = t.isFocused, a = t.innerRef, i = t.innerProps, s = t.menuIsOpen;
  return X("div", Z({
    ref: a
  }, be(t, "control", {
    control: !0,
    "control--is-disabled": o,
    "control--is-focused": r,
    "control--menu-is-open": s
  }), i, {
    "aria-disabled": o || void 0
  }), n);
}, Tw = _w, Dw = ["data"], Mw = function(t, n) {
  var o = t.theme.spacing;
  return n ? {} : {
    paddingBottom: o.baseUnit * 2,
    paddingTop: o.baseUnit * 2
  };
}, Fw = function(t) {
  var n = t.children, o = t.cx, r = t.getStyles, a = t.getClassNames, i = t.Heading, s = t.headingProps, c = t.innerProps, l = t.label, u = t.theme, f = t.selectProps;
  return X("div", Z({}, be(t, "group", {
    group: !0
  }), c), X(i, Z({}, s, {
    selectProps: f,
    theme: u,
    getStyles: r,
    getClassNames: a,
    cx: o
  }), l), X("div", null, n));
}, Ow = function(t, n) {
  var o = t.theme, r = o.colors, a = o.spacing;
  return H({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: r.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Gw = function(t) {
  var n = tp(t);
  n.data;
  var o = st(n, Dw);
  return X("div", Z({}, be(t, "groupHeading", {
    "group-heading": !0
  }), o));
}, kw = Fw, jw = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Vw = function(t, n) {
  var o = t.isDisabled, r = t.value, a = t.theme, i = a.spacing, s = a.colors;
  return H(H({
    visibility: o ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: r ? "translateZ(0)" : ""
  }, Bw), n ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: s.neutral80
  });
}, up = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Bw = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": H({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, up)
}, Lw = function(t) {
  return H({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, up);
}, Ww = function(t) {
  var n = t.cx, o = t.value, r = tp(t), a = r.innerRef, i = r.isDisabled, s = r.isHidden, c = r.inputClassName, l = st(r, jw);
  return X("div", Z({}, be(t, "input", {
    "input-container": !0
  }), {
    "data-value": o || ""
  }), X("input", Z({
    className: n({
      input: !0
    }, c),
    ref: a,
    style: Lw(s),
    disabled: i
  }, l)));
}, Xw = Ww, Hw = function(t, n) {
  var o = t.theme, r = o.spacing, a = o.borderRadius, i = o.colors;
  return H({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    margin: r.baseUnit / 2
  });
}, zw = function(t, n) {
  var o = t.theme, r = o.borderRadius, a = o.colors, i = t.cropWithEllipsis;
  return H({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: r / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, Zw = function(t, n) {
  var o = t.theme, r = o.spacing, a = o.borderRadius, i = o.colors, s = t.isFocused;
  return H({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: s ? i.dangerLight : void 0,
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, dp = function(t) {
  var n = t.children, o = t.innerProps;
  return X("div", o, n);
}, $w = dp, Yw = dp;
function Jw(e) {
  var t = e.children, n = e.innerProps;
  return X("div", Z({
    role: "button"
  }, n), t || X(Ii, {
    size: 14
  }));
}
var Uw = function(t) {
  var n = t.children, o = t.components, r = t.data, a = t.innerProps, i = t.isDisabled, s = t.removeProps, c = t.selectProps, l = o.Container, u = o.Label, f = o.Remove;
  return X(l, {
    data: r,
    innerProps: H(H({}, be(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), a),
    selectProps: c
  }, X(u, {
    data: r,
    innerProps: H({}, be(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), X(f, {
    data: r,
    innerProps: H(H({}, be(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: c
  }));
}, Qw = Uw, Kw = function(t, n) {
  var o = t.isDisabled, r = t.isFocused, a = t.isSelected, i = t.theme, s = i.spacing, c = i.colors;
  return H({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? c.primary : r ? c.primary25 : "transparent",
    color: o ? c.neutral20 : a ? c.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: o ? void 0 : a ? c.primary : c.primary50
    }
  });
}, qw = function(t) {
  var n = t.children, o = t.isDisabled, r = t.isFocused, a = t.isSelected, i = t.innerRef, s = t.innerProps;
  return X("div", Z({}, be(t, "option", {
    option: !0,
    "option--is-disabled": o,
    "option--is-focused": r,
    "option--is-selected": a
  }), {
    ref: i,
    "aria-disabled": o
  }, s), n);
}, eA = qw, tA = function(t, n) {
  var o = t.theme, r = o.spacing, a = o.colors;
  return H({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  });
}, nA = function(t) {
  var n = t.children, o = t.innerProps;
  return X("div", Z({}, be(t, "placeholder", {
    placeholder: !0
  }), o), n);
}, rA = nA, oA = function(t, n) {
  var o = t.isDisabled, r = t.theme, a = r.spacing, i = r.colors;
  return H({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: o ? i.neutral40 : i.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, aA = function(t) {
  var n = t.children, o = t.isDisabled, r = t.innerProps;
  return X("div", Z({}, be(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": o
  }), r), n);
}, iA = aA, sA = {
  ClearIndicator: ww,
  Control: Tw,
  DropdownIndicator: Cw,
  DownChevron: cp,
  CrossIcon: Ii,
  Group: kw,
  GroupHeading: Gw,
  IndicatorsContainer: mw,
  IndicatorSeparator: Ew,
  Input: Xw,
  LoadingIndicator: Nw,
  Menu: tw,
  MenuList: rw,
  MenuPortal: lw,
  LoadingMessage: sw,
  NoOptionsMessage: iw,
  MultiValue: Qw,
  MultiValueContainer: $w,
  MultiValueLabel: Yw,
  MultiValueRemove: Jw,
  Option: eA,
  Placeholder: rA,
  SelectContainer: dw,
  SingleValue: iA,
  ValueContainer: pw
}, cA = function(t) {
  return H(H({}, sA), t.components);
}, tc = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function lA(e, t) {
  return !!(e === t || tc(e) && tc(t));
}
function uA(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!lA(e[n], t[n]))
      return !1;
  return !0;
}
function dA(e, t) {
  t === void 0 && (t = uA);
  var n = null;
  function o() {
    for (var r = [], a = 0; a < arguments.length; a++)
      r[a] = arguments[a];
    if (n && n.lastThis === this && t(r, n.lastArgs))
      return n.lastResult;
    var i = e.apply(this, r);
    return n = {
      lastResult: i,
      lastArgs: r,
      lastThis: this
    }, i;
  }
  return o.clear = function() {
    n = null;
  }, o;
}
function fA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var pA = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: fA
}, gA = function(t) {
  return X("span", Z({
    css: pA
  }, t));
}, nc = gA, mA = {
  guidance: function(t) {
    var n = t.isSearchable, o = t.isMulti, r = t.tabSelectsValue, a = t.context, i = t.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(r ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(o ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, o = t.label, r = o === void 0 ? "" : o, a = t.labels, i = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(r, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(r, " is disabled. Select another option.") : "option ".concat(r, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, o = t.focused, r = t.options, a = t.label, i = a === void 0 ? "" : a, s = t.selectValue, c = t.isDisabled, l = t.isSelected, u = t.isAppleDevice, f = function(m, v) {
      return m && m.length ? "".concat(m.indexOf(v) + 1, " of ").concat(m.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(i, " focused, ").concat(f(s, o), ".");
    if (n === "menu" && u) {
      var g = c ? " disabled" : "", b = "".concat(l ? " selected" : "").concat(g);
      return "".concat(i).concat(b, ", ").concat(f(r, o), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, o = t.resultsMessage;
    return "".concat(o).concat(n ? " for search term " + n : "", ".");
  }
}, bA = function(t) {
  var n = t.ariaSelection, o = t.focusedOption, r = t.focusedValue, a = t.focusableOptions, i = t.isFocused, s = t.selectValue, c = t.selectProps, l = t.id, u = t.isAppleDevice, f = c.ariaLiveMessages, g = c.getOptionLabel, b = c.inputValue, C = c.isMulti, m = c.isOptionDisabled, v = c.isSearchable, h = c.menuIsOpen, I = c.options, x = c.screenReaderStatus, y = c.tabSelectsValue, w = c.isLoading, R = c["aria-label"], E = c["aria-live"], N = ut(function() {
    return H(H({}, mA), f || {});
  }, [f]), _ = ut(function() {
    var B = "";
    if (n && N.onChange) {
      var k = n.option, $ = n.options, j = n.removedValue, F = n.removedValues, U = n.value, re = function(me) {
        return Array.isArray(me) ? null : me;
      }, J = j || k || re(U), Q = J ? g(J) : "", ge = $ || F || void 0, Ce = ge ? ge.map(g) : [], ue = H({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: J && m(J, s),
        label: Q,
        labels: Ce
      }, n);
      B = N.onChange(ue);
    }
    return B;
  }, [n, N, m, s, g]), D = ut(function() {
    var B = "", k = o || r, $ = !!(o && s && s.includes(o));
    if (k && N.onFocus) {
      var j = {
        focused: k,
        label: g(k),
        isDisabled: m(k, s),
        isSelected: $,
        options: a,
        context: k === o ? "menu" : "value",
        selectValue: s,
        isAppleDevice: u
      };
      B = N.onFocus(j);
    }
    return B;
  }, [o, r, g, m, N, a, s, u]), O = ut(function() {
    var B = "";
    if (h && I.length && !w && N.onFilter) {
      var k = x({
        count: a.length
      });
      B = N.onFilter({
        inputValue: b,
        resultsMessage: k
      });
    }
    return B;
  }, [a, b, h, N, I, x, w]), T = (n == null ? void 0 : n.action) === "initial-input-focus", L = ut(function() {
    var B = "";
    if (N.guidance) {
      var k = r ? "value" : h ? "menu" : "input";
      B = N.guidance({
        "aria-label": R,
        context: k,
        isDisabled: o && m(o, s),
        isMulti: C,
        isSearchable: v,
        tabSelectsValue: y,
        isInitialFocus: T
      });
    }
    return B;
  }, [R, o, r, C, m, v, h, N, s, y, T]), M = X(Uo, null, X("span", {
    id: "aria-selection"
  }, _), X("span", {
    id: "aria-focused"
  }, D), X("span", {
    id: "aria-results"
  }, O), X("span", {
    id: "aria-guidance"
  }, L));
  return X(Uo, null, X(nc, {
    id: l
  }, T && M), X(nc, {
    "aria-live": E,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !T && M));
}, vA = bA, ba = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], hA = new RegExp("[" + ba.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), fp = {};
for (var Bo = 0; Bo < ba.length; Bo++)
  for (var Lo = ba[Bo], Wo = 0; Wo < Lo.letters.length; Wo++)
    fp[Lo.letters[Wo]] = Lo.base;
var pp = function(t) {
  return t.replace(hA, function(n) {
    return fp[n];
  });
}, xA = dA(pp), rc = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, yA = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, CA = function(t) {
  return function(n, o) {
    if (n.data.__isNew__) return !0;
    var r = H({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: yA,
      trim: !0,
      matchFrom: "any"
    }, t), a = r.ignoreCase, i = r.ignoreAccents, s = r.stringify, c = r.trim, l = r.matchFrom, u = c ? rc(o) : o, f = c ? rc(s(n)) : s(n);
    return a && (u = u.toLowerCase(), f = f.toLowerCase()), i && (u = xA(u), f = pp(f)), l === "start" ? f.substr(0, u.length) === u : f.indexOf(u) > -1;
  };
}, IA = ["innerRef"];
function wA(e) {
  var t = e.innerRef, n = st(e, IA), o = $I(n, "onExited", "in", "enter", "exit", "appear");
  return X("input", Z({
    ref: t
  }, o, {
    css: /* @__PURE__ */ Ci({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var AA = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function EA(e) {
  var t = e.isEnabled, n = e.onBottomArrive, o = e.onBottomLeave, r = e.onTopArrive, a = e.onTopLeave, i = qe(!1), s = qe(!1), c = qe(0), l = qe(null), u = Ee(function(v, h) {
    if (l.current !== null) {
      var I = l.current, x = I.scrollTop, y = I.scrollHeight, w = I.clientHeight, R = l.current, E = h > 0, N = y - w - x, _ = !1;
      N > h && i.current && (o && o(v), i.current = !1), E && s.current && (a && a(v), s.current = !1), E && h > N ? (n && !i.current && n(v), R.scrollTop = y, _ = !0, i.current = !0) : !E && -h > x && (r && !s.current && r(v), R.scrollTop = 0, _ = !0, s.current = !0), _ && AA(v);
    }
  }, [n, o, r, a]), f = Ee(function(v) {
    u(v, v.deltaY);
  }, [u]), g = Ee(function(v) {
    c.current = v.changedTouches[0].clientY;
  }, []), b = Ee(function(v) {
    var h = c.current - v.changedTouches[0].clientY;
    u(v, h);
  }, [u]), C = Ee(function(v) {
    if (v) {
      var h = HI ? {
        passive: !1
      } : !1;
      v.addEventListener("wheel", f, h), v.addEventListener("touchstart", g, h), v.addEventListener("touchmove", b, h);
    }
  }, [b, g, f]), m = Ee(function(v) {
    v && (v.removeEventListener("wheel", f, !1), v.removeEventListener("touchstart", g, !1), v.removeEventListener("touchmove", b, !1));
  }, [b, g, f]);
  return hn(function() {
    if (t) {
      var v = l.current;
      return C(v), function() {
        m(v);
      };
    }
  }, [t, C, m]), function(v) {
    l.current = v;
  };
}
var oc = ["boxSizing", "height", "overflow", "paddingRight", "position"], ac = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function ic(e) {
  e.cancelable && e.preventDefault();
}
function sc(e) {
  e.stopPropagation();
}
function cc() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function lc() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var uc = !!(typeof window < "u" && window.document && window.document.createElement), pn = 0, jt = {
  capture: !1,
  passive: !1
};
function RA(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, o = n === void 0 ? !0 : n, r = qe({}), a = qe(null), i = Ee(function(c) {
    if (uc) {
      var l = document.body, u = l && l.style;
      if (o && oc.forEach(function(C) {
        var m = u && u[C];
        r.current[C] = m;
      }), o && pn < 1) {
        var f = parseInt(r.current.paddingRight, 10) || 0, g = document.body ? document.body.clientWidth : 0, b = window.innerWidth - g + f || 0;
        Object.keys(ac).forEach(function(C) {
          var m = ac[C];
          u && (u[C] = m);
        }), u && (u.paddingRight = "".concat(b, "px"));
      }
      l && lc() && (l.addEventListener("touchmove", ic, jt), c && (c.addEventListener("touchstart", cc, jt), c.addEventListener("touchmove", sc, jt))), pn += 1;
    }
  }, [o]), s = Ee(function(c) {
    if (uc) {
      var l = document.body, u = l && l.style;
      pn = Math.max(pn - 1, 0), o && pn < 1 && oc.forEach(function(f) {
        var g = r.current[f];
        u && (u[f] = g);
      }), l && lc() && (l.removeEventListener("touchmove", ic, jt), c && (c.removeEventListener("touchstart", cc, jt), c.removeEventListener("touchmove", sc, jt)));
    }
  }, [o]);
  return hn(function() {
    if (t) {
      var c = a.current;
      return i(c), function() {
        s(c);
      };
    }
  }, [t, i, s]), function(c) {
    a.current = c;
  };
}
function SA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var NA = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, PA = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbE1hbmFnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9EVSIsImZpbGUiOiJTY3JvbGxNYW5hZ2VyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRnJhZ21lbnQsIFJlYWN0RWxlbWVudCwgUmVmQ2FsbGJhY2ssIE1vdXNlRXZlbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdXNlU2Nyb2xsQ2FwdHVyZSBmcm9tICcuL3VzZVNjcm9sbENhcHR1cmUnO1xuaW1wb3J0IHVzZVNjcm9sbExvY2sgZnJvbSAnLi91c2VTY3JvbGxMb2NrJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgcmVhZG9ubHkgY2hpbGRyZW46IChyZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PikgPT4gUmVhY3RFbGVtZW50O1xuICByZWFkb25seSBsb2NrRW5hYmxlZDogYm9vbGVhbjtcbiAgcmVhZG9ubHkgY2FwdHVyZUVuYWJsZWQ6IGJvb2xlYW47XG4gIHJlYWRvbmx5IG9uQm90dG9tQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Cb3R0b21MZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG4gIHJlYWRvbmx5IG9uVG9wQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Ub3BMZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG59XG5cbmNvbnN0IGJsdXJTZWxlY3RJbnB1dCA9IChldmVudDogTW91c2VFdmVudDxIVE1MRGl2RWxlbWVudD4pID0+IHtcbiAgY29uc3QgZWxlbWVudCA9IGV2ZW50LnRhcmdldCBhcyBIVE1MRGl2RWxlbWVudDtcbiAgcmV0dXJuIChcbiAgICBlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCAmJlxuICAgIChlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCBhcyBIVE1MRWxlbWVudCkuYmx1cigpXG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBTY3JvbGxNYW5hZ2VyKHtcbiAgY2hpbGRyZW4sXG4gIGxvY2tFbmFibGVkLFxuICBjYXB0dXJlRW5hYmxlZCA9IHRydWUsXG4gIG9uQm90dG9tQXJyaXZlLFxuICBvbkJvdHRvbUxlYXZlLFxuICBvblRvcEFycml2ZSxcbiAgb25Ub3BMZWF2ZSxcbn06IFByb3BzKSB7XG4gIGNvbnN0IHNldFNjcm9sbENhcHR1cmVUYXJnZXQgPSB1c2VTY3JvbGxDYXB0dXJlKHtcbiAgICBpc0VuYWJsZWQ6IGNhcHR1cmVFbmFibGVkLFxuICAgIG9uQm90dG9tQXJyaXZlLFxuICAgIG9uQm90dG9tTGVhdmUsXG4gICAgb25Ub3BBcnJpdmUsXG4gICAgb25Ub3BMZWF2ZSxcbiAgfSk7XG4gIGNvbnN0IHNldFNjcm9sbExvY2tUYXJnZXQgPSB1c2VTY3JvbGxMb2NrKHsgaXNFbmFibGVkOiBsb2NrRW5hYmxlZCB9KTtcblxuICBjb25zdCB0YXJnZXRSZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PiA9IChlbGVtZW50KSA9PiB7XG4gICAgc2V0U2Nyb2xsQ2FwdHVyZVRhcmdldChlbGVtZW50KTtcbiAgICBzZXRTY3JvbGxMb2NrVGFyZ2V0KGVsZW1lbnQpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEZyYWdtZW50PlxuICAgICAge2xvY2tFbmFibGVkICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIG9uQ2xpY2s9e2JsdXJTZWxlY3RJbnB1dH1cbiAgICAgICAgICBjc3M9e3sgcG9zaXRpb246ICdmaXhlZCcsIGxlZnQ6IDAsIGJvdHRvbTogMCwgcmlnaHQ6IDAsIHRvcDogMCB9fVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICAgIHtjaGlsZHJlbih0YXJnZXRSZWYpfVxuICAgIDwvRnJhZ21lbnQ+XG4gICk7XG59XG4iXX0= */",
  toString: SA
};
function _A(e) {
  var t = e.children, n = e.lockEnabled, o = e.captureEnabled, r = o === void 0 ? !0 : o, a = e.onBottomArrive, i = e.onBottomLeave, s = e.onTopArrive, c = e.onTopLeave, l = EA({
    isEnabled: r,
    onBottomArrive: a,
    onBottomLeave: i,
    onTopArrive: s,
    onTopLeave: c
  }), u = RA({
    isEnabled: n
  }), f = function(b) {
    l(b), u(b);
  };
  return X(Uo, null, n && X("div", {
    onClick: NA,
    css: PA
  }), t(f));
}
function TA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var DA = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: TA
}, MA = function(t) {
  var n = t.name, o = t.onFocus;
  return X("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: o,
    css: DA,
    value: "",
    onChange: function() {
    }
  });
}, FA = MA;
function wi(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function OA() {
  return wi(/^iPhone/i);
}
function gp() {
  return wi(/^Mac/i);
}
function GA() {
  return wi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  gp() && navigator.maxTouchPoints > 1;
}
function kA() {
  return OA() || GA();
}
function jA() {
  return gp() || kA();
}
var VA = function(t) {
  return t.label;
}, mp = function(t) {
  return t.label;
}, bp = function(t) {
  return t.value;
}, BA = function(t) {
  return !!t.isDisabled;
}, LA = {
  clearIndicator: Iw,
  container: uw,
  control: Pw,
  dropdownIndicator: yw,
  group: Mw,
  groupHeading: Ow,
  indicatorsContainer: gw,
  indicatorSeparator: Aw,
  input: Vw,
  loadingIndicator: Sw,
  loadingMessage: aw,
  menu: KI,
  menuList: nw,
  menuPortal: cw,
  multiValue: Hw,
  multiValueLabel: zw,
  multiValueRemove: Zw,
  noOptionsMessage: ow,
  option: Kw,
  placeholder: tA,
  singleValue: oA,
  valueContainer: fw
}, WA = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, XA = 4, vp = 4, HA = 38, zA = vp * 2, ZA = {
  baseUnit: vp,
  controlHeight: HA,
  menuGutter: zA
}, Xo = {
  borderRadius: XA,
  colors: WA,
  spacing: ZA
}, $A = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: qs(),
  captureMenuScroll: !qs(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: CA(),
  formatGroupLabel: VA,
  getOptionLabel: mp,
  getOptionValue: bp,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: BA,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !WI(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function dc(e, t, n, o) {
  var r = yp(e, t, n), a = Cp(e, t, n), i = xp(e, t), s = Mr(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: r,
    isSelected: a,
    label: i,
    value: s,
    index: o
  };
}
function br(e, t) {
  return e.options.map(function(n, o) {
    if ("options" in n) {
      var r = n.options.map(function(i, s) {
        return dc(e, i, t, s);
      }).filter(function(i) {
        return pc(e, i);
      });
      return r.length > 0 ? {
        type: "group",
        data: n,
        options: r,
        index: o
      } : void 0;
    }
    var a = dc(e, n, t, o);
    return pc(e, a) ? a : void 0;
  }).filter(zI);
}
function hp(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Yt(n.options.map(function(o) {
      return o.data;
    }))) : t.push(n.data), t;
  }, []);
}
function fc(e, t) {
  return e.reduce(function(n, o) {
    return o.type === "group" ? n.push.apply(n, Yt(o.options.map(function(r) {
      return {
        data: r.data,
        id: "".concat(t, "-").concat(o.index, "-").concat(r.index)
      };
    }))) : n.push({
      data: o.data,
      id: "".concat(t, "-").concat(o.index)
    }), n;
  }, []);
}
function YA(e, t) {
  return hp(br(e, t));
}
function pc(e, t) {
  var n = e.inputValue, o = n === void 0 ? "" : n, r = t.data, a = t.isSelected, i = t.label, s = t.value;
  return (!wp(e) || !a) && Ip(e, {
    label: i,
    value: s,
    data: r
  }, o);
}
function JA(e, t) {
  var n = e.focusedValue, o = e.selectValue, r = o.indexOf(n);
  if (r > -1) {
    var a = t.indexOf(n);
    if (a > -1)
      return n;
    if (r < t.length)
      return t[r];
  }
  return null;
}
function UA(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var Ho = function(t, n) {
  var o, r = (o = t.find(function(a) {
    return a.data === n;
  })) === null || o === void 0 ? void 0 : o.id;
  return r || null;
}, xp = function(t, n) {
  return t.getOptionLabel(n);
}, Mr = function(t, n) {
  return t.getOptionValue(n);
};
function yp(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Cp(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var o = Mr(e, t);
  return n.some(function(r) {
    return Mr(e, r) === o;
  });
}
function Ip(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var wp = function(t) {
  var n = t.hideSelectedOptions, o = t.isMulti;
  return n === void 0 ? o : n;
}, QA = 1, Ai = /* @__PURE__ */ function(e) {
  P0(n, e);
  var t = D0(n);
  function n(o) {
    var r;
    if (S0(this, n), r = t.call(this, o), r.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, r.blockOptionHover = !1, r.isComposing = !1, r.commonProps = void 0, r.initialTouchX = 0, r.initialTouchY = 0, r.openAfterFocus = !1, r.scrollToFocusedOptionOnUpdate = !1, r.userIsDragging = void 0, r.isAppleDevice = jA(), r.controlRef = null, r.getControlRef = function(c) {
      r.controlRef = c;
    }, r.focusedOptionRef = null, r.getFocusedOptionRef = function(c) {
      r.focusedOptionRef = c;
    }, r.menuListRef = null, r.getMenuListRef = function(c) {
      r.menuListRef = c;
    }, r.inputRef = null, r.getInputRef = function(c) {
      r.inputRef = c;
    }, r.focus = r.focusInput, r.blur = r.blurInput, r.onChange = function(c, l) {
      var u = r.props, f = u.onChange, g = u.name;
      l.name = g, r.ariaOnChange(c, l), f(c, l);
    }, r.setValue = function(c, l, u) {
      var f = r.props, g = f.closeMenuOnSelect, b = f.isMulti, C = f.inputValue;
      r.onInputChange("", {
        action: "set-value",
        prevInputValue: C
      }), g && (r.setState({
        inputIsHiddenAfterUpdate: !b
      }), r.onMenuClose()), r.setState({
        clearFocusValueOnUpdate: !0
      }), r.onChange(c, {
        action: l,
        option: u
      });
    }, r.selectOption = function(c) {
      var l = r.props, u = l.blurInputOnSelect, f = l.isMulti, g = l.name, b = r.state.selectValue, C = f && r.isOptionSelected(c, b), m = r.isOptionDisabled(c, b);
      if (C) {
        var v = r.getOptionValue(c);
        r.setValue(b.filter(function(h) {
          return r.getOptionValue(h) !== v;
        }), "deselect-option", c);
      } else if (!m)
        f ? r.setValue([].concat(Yt(b), [c]), "select-option", c) : r.setValue(c, "select-option");
      else {
        r.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: g
        });
        return;
      }
      u && r.blurInput();
    }, r.removeValue = function(c) {
      var l = r.props.isMulti, u = r.state.selectValue, f = r.getOptionValue(c), g = u.filter(function(C) {
        return r.getOptionValue(C) !== f;
      }), b = bn(l, g, g[0] || null);
      r.onChange(b, {
        action: "remove-value",
        removedValue: c
      }), r.focusInput();
    }, r.clearValue = function() {
      var c = r.state.selectValue;
      r.onChange(bn(r.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, r.popValue = function() {
      var c = r.props.isMulti, l = r.state.selectValue, u = l[l.length - 1], f = l.slice(0, l.length - 1), g = bn(c, f, f[0] || null);
      u && r.onChange(g, {
        action: "pop-value",
        removedValue: u
      });
    }, r.getFocusedOptionId = function(c) {
      return Ho(r.state.focusableOptionsWithIds, c);
    }, r.getFocusableOptionsWithIds = function() {
      return fc(br(r.props, r.state.selectValue), r.getElementId("option"));
    }, r.getValue = function() {
      return r.state.selectValue;
    }, r.cx = function() {
      for (var c = arguments.length, l = new Array(c), u = 0; u < c; u++)
        l[u] = arguments[u];
      return kI.apply(void 0, [r.props.classNamePrefix].concat(l));
    }, r.getOptionLabel = function(c) {
      return xp(r.props, c);
    }, r.getOptionValue = function(c) {
      return Mr(r.props, c);
    }, r.getStyles = function(c, l) {
      var u = r.props.unstyled, f = LA[c](l, u);
      f.boxSizing = "border-box";
      var g = r.props.styles[c];
      return g ? g(f, l) : f;
    }, r.getClassNames = function(c, l) {
      var u, f;
      return (u = (f = r.props.classNames)[c]) === null || u === void 0 ? void 0 : u.call(f, l);
    }, r.getElementId = function(c) {
      return "".concat(r.state.instancePrefix, "-").concat(c);
    }, r.getComponents = function() {
      return cA(r.props);
    }, r.buildCategorizedOptions = function() {
      return br(r.props, r.state.selectValue);
    }, r.getCategorizedOptions = function() {
      return r.props.menuIsOpen ? r.buildCategorizedOptions() : [];
    }, r.buildFocusableOptions = function() {
      return hp(r.buildCategorizedOptions());
    }, r.getFocusableOptions = function() {
      return r.props.menuIsOpen ? r.buildFocusableOptions() : [];
    }, r.ariaOnChange = function(c, l) {
      r.setState({
        ariaSelection: H({
          value: c
        }, l)
      });
    }, r.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), r.focusInput());
    }, r.onMenuMouseMove = function(c) {
      r.blockOptionHover = !1;
    }, r.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var l = r.props.openMenuOnClick;
        r.state.isFocused ? r.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && r.onMenuClose() : l && r.openMenu("first") : (l && (r.openAfterFocus = !0), r.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, r.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !r.props.isDisabled) {
        var l = r.props, u = l.isMulti, f = l.menuIsOpen;
        r.focusInput(), f ? (r.setState({
          inputIsHiddenAfterUpdate: !u
        }), r.onMenuClose()) : r.openMenu("first"), c.preventDefault();
      }
    }, r.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (r.clearValue(), c.preventDefault(), r.openAfterFocus = !1, c.type === "touchend" ? r.focusInput() : setTimeout(function() {
        return r.focusInput();
      }));
    }, r.onScroll = function(c) {
      typeof r.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && ao(c.target) && r.props.onMenuClose() : typeof r.props.closeMenuOnScroll == "function" && r.props.closeMenuOnScroll(c) && r.props.onMenuClose();
    }, r.onCompositionStart = function() {
      r.isComposing = !0;
    }, r.onCompositionEnd = function() {
      r.isComposing = !1;
    }, r.onTouchStart = function(c) {
      var l = c.touches, u = l && l.item(0);
      u && (r.initialTouchX = u.clientX, r.initialTouchY = u.clientY, r.userIsDragging = !1);
    }, r.onTouchMove = function(c) {
      var l = c.touches, u = l && l.item(0);
      if (u) {
        var f = Math.abs(u.clientX - r.initialTouchX), g = Math.abs(u.clientY - r.initialTouchY), b = 5;
        r.userIsDragging = f > b || g > b;
      }
    }, r.onTouchEnd = function(c) {
      r.userIsDragging || (r.controlRef && !r.controlRef.contains(c.target) && r.menuListRef && !r.menuListRef.contains(c.target) && r.blurInput(), r.initialTouchX = 0, r.initialTouchY = 0);
    }, r.onControlTouchEnd = function(c) {
      r.userIsDragging || r.onControlMouseDown(c);
    }, r.onClearIndicatorTouchEnd = function(c) {
      r.userIsDragging || r.onClearIndicatorMouseDown(c);
    }, r.onDropdownIndicatorTouchEnd = function(c) {
      r.userIsDragging || r.onDropdownIndicatorMouseDown(c);
    }, r.handleInputChange = function(c) {
      var l = r.props.inputValue, u = c.currentTarget.value;
      r.setState({
        inputIsHiddenAfterUpdate: !1
      }), r.onInputChange(u, {
        action: "input-change",
        prevInputValue: l
      }), r.props.menuIsOpen || r.onMenuOpen();
    }, r.onInputFocus = function(c) {
      r.props.onFocus && r.props.onFocus(c), r.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (r.openAfterFocus || r.props.openMenuOnFocus) && r.openMenu("first"), r.openAfterFocus = !1;
    }, r.onInputBlur = function(c) {
      var l = r.props.inputValue;
      if (r.menuListRef && r.menuListRef.contains(document.activeElement)) {
        r.inputRef.focus();
        return;
      }
      r.props.onBlur && r.props.onBlur(c), r.onInputChange("", {
        action: "input-blur",
        prevInputValue: l
      }), r.onMenuClose(), r.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, r.onOptionHover = function(c) {
      if (!(r.blockOptionHover || r.state.focusedOption === c)) {
        var l = r.getFocusableOptions(), u = l.indexOf(c);
        r.setState({
          focusedOption: c,
          focusedOptionId: u > -1 ? r.getFocusedOptionId(c) : null
        });
      }
    }, r.shouldHideSelectedOptions = function() {
      return wp(r.props);
    }, r.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), r.focus();
    }, r.onKeyDown = function(c) {
      var l = r.props, u = l.isMulti, f = l.backspaceRemovesValue, g = l.escapeClearsValue, b = l.inputValue, C = l.isClearable, m = l.isDisabled, v = l.menuIsOpen, h = l.onKeyDown, I = l.tabSelectsValue, x = l.openMenuOnFocus, y = r.state, w = y.focusedOption, R = y.focusedValue, E = y.selectValue;
      if (!m && !(typeof h == "function" && (h(c), c.defaultPrevented))) {
        switch (r.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!u || b) return;
            r.focusValue("previous");
            break;
          case "ArrowRight":
            if (!u || b) return;
            r.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (b) return;
            if (R)
              r.removeValue(R);
            else {
              if (!f) return;
              u ? r.popValue() : C && r.clearValue();
            }
            break;
          case "Tab":
            if (r.isComposing || c.shiftKey || !v || !I || !w || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            x && r.isOptionSelected(w, E))
              return;
            r.selectOption(w);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (v) {
              if (!w || r.isComposing) return;
              r.selectOption(w);
              break;
            }
            return;
          case "Escape":
            v ? (r.setState({
              inputIsHiddenAfterUpdate: !1
            }), r.onInputChange("", {
              action: "menu-close",
              prevInputValue: b
            }), r.onMenuClose()) : C && g && r.clearValue();
            break;
          case " ":
            if (b)
              return;
            if (!v) {
              r.openMenu("first");
              break;
            }
            if (!w) return;
            r.selectOption(w);
            break;
          case "ArrowUp":
            v ? r.focusOption("up") : r.openMenu("last");
            break;
          case "ArrowDown":
            v ? r.focusOption("down") : r.openMenu("first");
            break;
          case "PageUp":
            if (!v) return;
            r.focusOption("pageup");
            break;
          case "PageDown":
            if (!v) return;
            r.focusOption("pagedown");
            break;
          case "Home":
            if (!v) return;
            r.focusOption("first");
            break;
          case "End":
            if (!v) return;
            r.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, r.state.instancePrefix = "react-select-" + (r.props.instanceId || ++QA), r.state.selectValue = Tr(o.value), o.menuIsOpen && r.state.selectValue.length) {
      var a = r.getFocusableOptionsWithIds(), i = r.buildFocusableOptions(), s = i.indexOf(r.state.selectValue[0]);
      r.state.focusableOptionsWithIds = a, r.state.focusedOption = i[s], r.state.focusedOptionId = Ho(a, i[s]);
    }
    return r;
  }
  return N0(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Ks(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var a = this.props, i = a.isDisabled, s = a.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !i && r.isDisabled || // ensure focus is on the Input when the menu opens
      c && s && !r.menuIsOpen) && this.focusInput(), c && i && !r.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !i && r.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Ks(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(r, a) {
      this.props.onInputChange(r, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(r) {
      var a = this, i = this.state, s = i.selectValue, c = i.isFocused, l = this.buildFocusableOptions(), u = r === "first" ? 0 : l.length - 1;
      if (!this.props.isMulti) {
        var f = l.indexOf(s[0]);
        f > -1 && (u = f);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: l[u],
        focusedOptionId: this.getFocusedOptionId(l[u])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(r) {
      var a = this.state, i = a.selectValue, s = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = i.indexOf(s);
        s || (c = -1);
        var l = i.length - 1, u = -1;
        if (i.length) {
          switch (r) {
            case "previous":
              c === 0 ? u = 0 : c === -1 ? u = l : u = c - 1;
              break;
            case "next":
              c > -1 && c < l && (u = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: u !== -1,
            focusedValue: i[u]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, i = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var c = 0, l = s.indexOf(i);
        i || (l = -1), r === "up" ? c = l > 0 ? l - 1 : s.length - 1 : r === "down" ? c = (l + 1) % s.length : r === "pageup" ? (c = l - a, c < 0 && (c = 0)) : r === "pagedown" ? (c = l + a, c > s.length - 1 && (c = s.length - 1)) : r === "last" && (c = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Xo) : H(H({}, Xo), this.props.theme) : Xo;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var r = this.clearValue, a = this.cx, i = this.getStyles, s = this.getClassNames, c = this.getValue, l = this.selectOption, u = this.setValue, f = this.props, g = f.isMulti, b = f.isRtl, C = f.options, m = this.hasValue();
      return {
        clearValue: r,
        cx: a,
        getStyles: i,
        getClassNames: s,
        getValue: c,
        hasValue: m,
        isMulti: g,
        isRtl: b,
        options: C,
        selectOption: l,
        selectProps: f,
        setValue: u,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var r = this.state.selectValue;
      return r.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var r = this.props, a = r.isClearable, i = r.isMulti;
      return a === void 0 ? i : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(r, a) {
      return yp(this.props, r, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(r, a) {
      return Cp(this.props, r, a);
    }
  }, {
    key: "filterOption",
    value: function(r, a) {
      return Ip(this.props, r, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(r, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(r, {
          context: a,
          inputValue: i,
          selectValue: s
        });
      } else
        return this.getOptionLabel(r);
    }
  }, {
    key: "formatGroupLabel",
    value: function(r) {
      return this.props.formatGroupLabel(r);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var r = this.props, a = r.isDisabled, i = r.isSearchable, s = r.inputId, c = r.inputValue, l = r.tabIndex, u = r.form, f = r.menuIsOpen, g = r.required, b = this.getComponents(), C = b.Input, m = this.state, v = m.inputIsHidden, h = m.ariaSelection, I = this.commonProps, x = s || this.getElementId("input"), y = H(H(H({
          "aria-autocomplete": "list",
          "aria-expanded": f,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": g,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, f && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (h == null ? void 0 : h.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ d.createElement(C, Z({}, I, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: x,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: v,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: l,
          form: u,
          type: "text",
          value: c
        }, y)) : /* @__PURE__ */ d.createElement(wA, Z({
          id: x,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: _r,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: l,
          inputMode: "none",
          form: u,
          value: ""
        }, y));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var r = this, a = this.getComponents(), i = a.MultiValue, s = a.MultiValueContainer, c = a.MultiValueLabel, l = a.MultiValueRemove, u = a.SingleValue, f = a.Placeholder, g = this.commonProps, b = this.props, C = b.controlShouldRenderValue, m = b.isDisabled, v = b.isMulti, h = b.inputValue, I = b.placeholder, x = this.state, y = x.selectValue, w = x.focusedValue, R = x.isFocused;
      if (!this.hasValue() || !C)
        return h ? null : /* @__PURE__ */ d.createElement(f, Z({}, g, {
          key: "placeholder",
          isDisabled: m,
          isFocused: R,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), I);
      if (v)
        return y.map(function(N, _) {
          var D = N === w, O = "".concat(r.getOptionLabel(N), "-").concat(r.getOptionValue(N));
          return /* @__PURE__ */ d.createElement(i, Z({}, g, {
            components: {
              Container: s,
              Label: c,
              Remove: l
            },
            isFocused: D,
            isDisabled: m,
            key: O,
            index: _,
            removeProps: {
              onClick: function() {
                return r.removeValue(N);
              },
              onTouchEnd: function() {
                return r.removeValue(N);
              },
              onMouseDown: function(L) {
                L.preventDefault();
              }
            },
            data: N
          }), r.formatOptionLabel(N, "value"));
        });
      if (h)
        return null;
      var E = y[0];
      return /* @__PURE__ */ d.createElement(u, Z({}, g, {
        data: E,
        isDisabled: m
      }), this.formatOptionLabel(E, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var r = this.getComponents(), a = r.ClearIndicator, i = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, u = this.state.isFocused;
      if (!this.isClearable() || !a || c || !this.hasValue() || l)
        return null;
      var f = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ d.createElement(a, Z({}, i, {
        innerProps: f,
        isFocused: u
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var r = this.getComponents(), a = r.LoadingIndicator, i = this.commonProps, s = this.props, c = s.isDisabled, l = s.isLoading, u = this.state.isFocused;
      if (!a || !l) return null;
      var f = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ d.createElement(a, Z({}, i, {
        innerProps: f,
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var r = this.getComponents(), a = r.DropdownIndicator, i = r.IndicatorSeparator;
      if (!a || !i) return null;
      var s = this.commonProps, c = this.props.isDisabled, l = this.state.isFocused;
      return /* @__PURE__ */ d.createElement(i, Z({}, s, {
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var r = this.getComponents(), a = r.DropdownIndicator;
      if (!a) return null;
      var i = this.commonProps, s = this.props.isDisabled, c = this.state.isFocused, l = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ d.createElement(a, Z({}, i, {
        innerProps: l,
        isDisabled: s,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var r = this, a = this.getComponents(), i = a.Group, s = a.GroupHeading, c = a.Menu, l = a.MenuList, u = a.MenuPortal, f = a.LoadingMessage, g = a.NoOptionsMessage, b = a.Option, C = this.commonProps, m = this.state.focusedOption, v = this.props, h = v.captureMenuScroll, I = v.inputValue, x = v.isLoading, y = v.loadingMessage, w = v.minMenuHeight, R = v.maxMenuHeight, E = v.menuIsOpen, N = v.menuPlacement, _ = v.menuPosition, D = v.menuPortalTarget, O = v.menuShouldBlockScroll, T = v.menuShouldScrollIntoView, L = v.noOptionsMessage, M = v.onMenuScrollToTop, B = v.onMenuScrollToBottom;
      if (!E) return null;
      var k = function(Q, ge) {
        var Ce = Q.type, ue = Q.data, fe = Q.isDisabled, me = Q.isSelected, pe = Q.label, _e = Q.value, ct = m === ue, W = fe ? void 0 : function() {
          return r.onOptionHover(ue);
        }, Ge = fe ? void 0 : function() {
          return r.selectOption(ue);
        }, Le = "".concat(r.getElementId("option"), "-").concat(ge), He = {
          id: Le,
          onClick: Ge,
          onMouseMove: W,
          onMouseOver: W,
          tabIndex: -1,
          role: "option",
          "aria-selected": r.isAppleDevice ? void 0 : me
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ d.createElement(b, Z({}, C, {
          innerProps: He,
          data: ue,
          isDisabled: fe,
          isSelected: me,
          key: Le,
          label: pe,
          type: Ce,
          value: _e,
          isFocused: ct,
          innerRef: ct ? r.getFocusedOptionRef : void 0
        }), r.formatOptionLabel(Q.data, "menu"));
      }, $;
      if (this.hasOptions())
        $ = this.getCategorizedOptions().map(function(J) {
          if (J.type === "group") {
            var Q = J.data, ge = J.options, Ce = J.index, ue = "".concat(r.getElementId("group"), "-").concat(Ce), fe = "".concat(ue, "-heading");
            return /* @__PURE__ */ d.createElement(i, Z({}, C, {
              key: ue,
              data: Q,
              options: ge,
              Heading: s,
              headingProps: {
                id: fe,
                data: J.data
              },
              label: r.formatGroupLabel(J.data)
            }), J.options.map(function(me) {
              return k(me, "".concat(Ce, "-").concat(me.index));
            }));
          } else if (J.type === "option")
            return k(J, "".concat(J.index));
        });
      else if (x) {
        var j = y({
          inputValue: I
        });
        if (j === null) return null;
        $ = /* @__PURE__ */ d.createElement(f, C, j);
      } else {
        var F = L({
          inputValue: I
        });
        if (F === null) return null;
        $ = /* @__PURE__ */ d.createElement(g, C, F);
      }
      var U = {
        minMenuHeight: w,
        maxMenuHeight: R,
        menuPlacement: N,
        menuPosition: _,
        menuShouldScrollIntoView: T
      }, re = /* @__PURE__ */ d.createElement(qI, Z({}, C, U), function(J) {
        var Q = J.ref, ge = J.placerProps, Ce = ge.placement, ue = ge.maxHeight;
        return /* @__PURE__ */ d.createElement(c, Z({}, C, U, {
          innerRef: Q,
          innerProps: {
            onMouseDown: r.onMenuMouseDown,
            onMouseMove: r.onMenuMouseMove
          },
          isLoading: x,
          placement: Ce
        }), /* @__PURE__ */ d.createElement(_A, {
          captureEnabled: h,
          onTopArrive: M,
          onBottomArrive: B,
          lockEnabled: O
        }, function(fe) {
          return /* @__PURE__ */ d.createElement(l, Z({}, C, {
            innerRef: function(pe) {
              r.getMenuListRef(pe), fe(pe);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": C.isMulti,
              id: r.getElementId("listbox")
            },
            isLoading: x,
            maxHeight: ue,
            focusedOption: m
          }), $);
        }));
      });
      return D || _ === "fixed" ? /* @__PURE__ */ d.createElement(u, Z({}, C, {
        appendTo: D,
        controlElement: this.controlRef,
        menuPlacement: N,
        menuPosition: _
      }), re) : re;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var r = this, a = this.props, i = a.delimiter, s = a.isDisabled, c = a.isMulti, l = a.name, u = a.required, f = this.state.selectValue;
      if (u && !this.hasValue() && !s)
        return /* @__PURE__ */ d.createElement(FA, {
          name: l,
          onFocus: this.onValueInputFocus
        });
      if (!(!l || s))
        if (c)
          if (i) {
            var g = f.map(function(m) {
              return r.getOptionValue(m);
            }).join(i);
            return /* @__PURE__ */ d.createElement("input", {
              name: l,
              type: "hidden",
              value: g
            });
          } else {
            var b = f.length > 0 ? f.map(function(m, v) {
              return /* @__PURE__ */ d.createElement("input", {
                key: "i-".concat(v),
                name: l,
                type: "hidden",
                value: r.getOptionValue(m)
              });
            }) : /* @__PURE__ */ d.createElement("input", {
              name: l,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ d.createElement("div", null, b);
          }
        else {
          var C = f[0] ? this.getOptionValue(f[0]) : "";
          return /* @__PURE__ */ d.createElement("input", {
            name: l,
            type: "hidden",
            value: C
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var r = this.commonProps, a = this.state, i = a.ariaSelection, s = a.focusedOption, c = a.focusedValue, l = a.isFocused, u = a.selectValue, f = this.getFocusableOptions();
      return /* @__PURE__ */ d.createElement(vA, Z({}, r, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: s,
        focusedValue: c,
        isFocused: l,
        selectValue: u,
        focusableOptions: f,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.getComponents(), a = r.Control, i = r.IndicatorsContainer, s = r.SelectContainer, c = r.ValueContainer, l = this.props, u = l.className, f = l.id, g = l.isDisabled, b = l.menuIsOpen, C = this.state.isFocused, m = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ d.createElement(s, Z({}, m, {
        className: u,
        innerProps: {
          id: f,
          onKeyDown: this.onKeyDown
        },
        isDisabled: g,
        isFocused: C
      }), this.renderLiveRegion(), /* @__PURE__ */ d.createElement(a, Z({}, m, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: g,
        isFocused: C,
        menuIsOpen: b
      }), /* @__PURE__ */ d.createElement(c, Z({}, m, {
        isDisabled: g
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ d.createElement(i, Z({}, m, {
        isDisabled: g
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, a) {
      var i = a.prevProps, s = a.clearFocusValueOnUpdate, c = a.inputIsHiddenAfterUpdate, l = a.ariaSelection, u = a.isFocused, f = a.prevWasFocused, g = a.instancePrefix, b = r.options, C = r.value, m = r.menuIsOpen, v = r.inputValue, h = r.isMulti, I = Tr(C), x = {};
      if (i && (C !== i.value || b !== i.options || m !== i.menuIsOpen || v !== i.inputValue)) {
        var y = m ? YA(r, I) : [], w = m ? fc(br(r, I), "".concat(g, "-option")) : [], R = s ? JA(a, I) : null, E = UA(a, y), N = Ho(w, E);
        x = {
          selectValue: I,
          focusedOption: E,
          focusedOptionId: N,
          focusableOptionsWithIds: w,
          focusedValue: R,
          clearFocusValueOnUpdate: !1
        };
      }
      var _ = c != null && r !== i ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, D = l, O = u && f;
      return u && !O && (D = {
        value: bn(h, I, I[0] || null),
        options: I,
        action: "initial-input-focus"
      }, O = !f), (l == null ? void 0 : l.action) === "initial-input-focus" && (D = null), H(H(H({}, x), _), {}, {
        prevProps: r,
        ariaSelection: D,
        prevWasFocused: O
      });
    }
  }]), n;
}(vc);
Ai.defaultProps = $A;
var KA = /* @__PURE__ */ Sn(function(e, t) {
  var n = Wf(e);
  return /* @__PURE__ */ d.createElement(Ai, Z({
    ref: t
  }, n));
}), qA = KA, e1 = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], gc = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 ? arguments[1] : void 0, o = arguments.length > 2 ? arguments[2] : void 0, r = String(t).toLowerCase(), a = String(o.getOptionValue(n)).toLowerCase(), i = String(o.getOptionLabel(n)).toLowerCase();
  return a === r || i === r;
}, zo = {
  formatCreateLabel: function(t) {
    return 'Create "'.concat(t, '"');
  },
  isValidNewOption: function(t, n, o, r) {
    return !(!t || n.some(function(a) {
      return gc(t, a, r);
    }) || o.some(function(a) {
      return gc(t, a, r);
    }));
  },
  getNewOptionData: function(t, n) {
    return {
      label: n,
      value: t,
      __isNew__: !0
    };
  }
};
function t1(e) {
  var t = e.allowCreateWhileLoading, n = t === void 0 ? !1 : t, o = e.createOptionPosition, r = o === void 0 ? "last" : o, a = e.formatCreateLabel, i = a === void 0 ? zo.formatCreateLabel : a, s = e.isValidNewOption, c = s === void 0 ? zo.isValidNewOption : s, l = e.getNewOptionData, u = l === void 0 ? zo.getNewOptionData : l, f = e.onCreateOption, g = e.options, b = g === void 0 ? [] : g, C = e.onChange, m = st(e, e1), v = m.getOptionValue, h = v === void 0 ? bp : v, I = m.getOptionLabel, x = I === void 0 ? mp : I, y = m.inputValue, w = m.isLoading, R = m.isMulti, E = m.value, N = m.name, _ = ut(function() {
    return c(y, Tr(E), b, {
      getOptionValue: h,
      getOptionLabel: x
    }) ? u(y, i(y)) : void 0;
  }, [i, u, x, h, y, c, b, E]), D = ut(function() {
    return (n || !w) && _ ? r === "first" ? [_].concat(Yt(b)) : [].concat(Yt(b), [_]) : b;
  }, [n, r, w, _, b]), O = Ee(function(T, L) {
    if (L.action !== "select-option")
      return C(T, L);
    var M = Array.isArray(T) ? T : [T];
    if (M[M.length - 1] === _) {
      if (f) f(y);
      else {
        var B = u(y, y), k = {
          action: "create-option",
          name: N,
          option: B
        };
        C(bn(R, [].concat(Yt(Tr(E)), [B]), B), k);
      }
      return;
    }
    C(T, L);
  }, [u, y, R, N, _, f, C, E]);
  return H(H({}, m), {}, {
    options: D,
    onChange: O
  });
}
var n1 = /* @__PURE__ */ Sn(function(e, t) {
  var n = Wf(e), o = t1(n);
  return /* @__PURE__ */ d.createElement(Ai, Z({
    ref: t
  }, o));
}), r1 = n1;
const JE = (e) => {
  const t = typeof document < "u" ? document : {}, {
    options: n,
    value: o,
    label: r,
    isMulti: a = !1,
    isLoading: i = !1,
    isCreatable: s = !1,
    placeholder: c = "Select...",
    isSearchable: l = !1,
    isClearable: u = !1,
    isDisabled: f = !1,
    className: g = "",
    labelClassName: b = "",
    selectClassName: C = ""
  } = e, m = (h) => {
    e.onChangeOptions && e.onChangeOptions(h);
  }, v = (h) => {
    e.onCreateOptions && e.onCreateOptions(h);
  };
  return /* @__PURE__ */ p.jsxs("div", { className: S(`nyn-select-block mb-3 ${g}`), children: [
    r && /* @__PURE__ */ p.jsx(Tt, { htmlFor: "select", className: S(`nyn-select-label block pb-2 text-text ${b}`), children: r }),
    !s && /* @__PURE__ */ p.jsx(
      qA,
      {
        isMulti: a,
        isLoading: i,
        isDisabled: f,
        isClearable: u,
        isSearchable: l,
        className: S(`nyn-select ${C}`),
        placeholder: c,
        classNamePrefix: "nyn-select",
        value: o,
        options: n,
        classNames: ps,
        onChange: m,
        theme: fs,
        menuPortalTarget: t.body
      }
    ),
    !!s && /* @__PURE__ */ p.jsx(
      r1,
      {
        isMulti: a,
        isLoading: i,
        isDisabled: f,
        isClearable: u,
        isSearchable: l,
        className: S(`nyn-select ${C}`),
        placeholder: c,
        classNamePrefix: "nyn-select",
        value: o,
        options: n,
        classNames: ps,
        onCreateOption: v,
        onChange: m,
        theme: fs,
        menuPortalTarget: t.body
      }
    )
  ] });
}, o1 = Wa, a1 = Xa, Ap = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    _n,
    {
      className: S(
        "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        e
      ),
      ...t,
      ref: n
    }
  )
);
Ap.displayName = _n.displayName;
const i1 = en(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), Ep = d.forwardRef(
  ({ side: e = "right", className: t, children: n, ...o }, r) => /* @__PURE__ */ p.jsxs(a1, { children: [
    /* @__PURE__ */ p.jsx(Ap, {}),
    /* @__PURE__ */ p.jsxs(Tn, { ref: r, className: S(i1({ side: e }), t), ...o, children: [
      n,
      /* @__PURE__ */ p.jsxs(Zr, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
        /* @__PURE__ */ p.jsx(Vr, { className: "h-4 w-4" }),
        /* @__PURE__ */ p.jsx("span", { className: "sr-only", children: "Close" })
      ] })
    ] })
  ] })
);
Ep.displayName = Tn.displayName;
const Rp = ({ className: e, ...t }) => /* @__PURE__ */ p.jsx("div", { className: S("flex flex-col space-y-2 text-center sm:text-left", e), ...t });
Rp.displayName = "SheetHeader";
const Sp = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Dn, { ref: n, className: S("text-lg font-semibold text-foreground", e), ...t })
);
Sp.displayName = Dn.displayName;
const s1 = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(Mn, { ref: n, className: S("text-sm text-muted-foreground", e), ...t }));
s1.displayName = Mn.displayName;
const c1 = {
  [Ht.XS]: "md:max-w-sm",
  [Ht.SM]: "md:max-w-lg",
  [Ht.MD]: "md:max-w-2xl",
  [Ht.LG]: "md:max-w-4xl"
}, UE = (e) => {
  const { isOpen: t, className: n = "", headerClassName: o = "", titleClassName: r = "", contentClassName: a = "", title: i, children: s, size: c = Ht.XS } = e;
  return /* @__PURE__ */ p.jsx(o1, { open: t, onOpenChange: e.onCloseSheet, children: /* @__PURE__ */ p.jsxs(
    Ep,
    {
      className: S(
        `nyn-sheet p-0 gap-0 border-0 border-l border-border bg-card text-white overflow-hidden w-full ${c1[c]} ${n}`
      ),
      children: [
        /* @__PURE__ */ p.jsx(Rp, { className: S(`nyn-sheet-header px-3 py-2.5 bg-primary text-white ${o}`), children: /* @__PURE__ */ p.jsx(Sp, { className: S(`nyn-sheet-title text-base font-normal ${r}`), children: i }) }),
        /* @__PURE__ */ p.jsx("div", { className: S(`nyn-sheet-content text-text h-[calc(100vh_-_44px)] overflow-y-auto ${a}`), children: s })
      ]
    }
  ) });
};
function l1({ className: e, ...t }) {
  return /* @__PURE__ */ p.jsx("div", { className: S("animate-pulse rounded-md bg-muted", e), ...t });
}
const QE = (e) => {
  const { className: t = "" } = e;
  return /* @__PURE__ */ p.jsx(l1, { className: S(`nyn-skeleton bg-border ${t}`) });
};
var io = "Switch", [u1, KE] = ye(io), [d1, f1] = u1(io), Np = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      form: u,
      ...f
    } = e, [g, b] = d.useState(null), C = ne(t, (x) => b(x)), m = d.useRef(!1), v = g ? u || !!g.closest("form") : !0, [h, I] = Oe({
      prop: r,
      defaultProp: a ?? !1,
      onChange: l,
      caller: io
    });
    return /* @__PURE__ */ p.jsxs(d1, { scope: n, checked: h, disabled: s, children: [
      /* @__PURE__ */ p.jsx(
        z.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": h,
          "aria-required": i,
          "data-state": Dp(h),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...f,
          ref: C,
          onClick: G(e.onClick, (x) => {
            I((y) => !y), v && (m.current = x.isPropagationStopped(), m.current || x.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ p.jsx(
        Tp,
        {
          control: g,
          bubbles: !m.current,
          name: o,
          value: c,
          checked: h,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Np.displayName = io;
var Pp = "SwitchThumb", _p = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = f1(Pp, n);
    return /* @__PURE__ */ p.jsx(
      z.span,
      {
        "data-state": Dp(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
_p.displayName = Pp;
var p1 = "SwitchBubbleInput", Tp = d.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const i = d.useRef(null), s = ne(i, a), c = Fa(n), l = Br(t);
    return d.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const f = window.HTMLInputElement.prototype, b = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (c !== n && b) {
        const C = new Event("click", { bubbles: o });
        b.call(u, n), u.dispatchEvent(C);
      }
    }, [c, n, o]), /* @__PURE__ */ p.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...l,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Tp.displayName = p1;
function Dp(e) {
  return e ? "checked" : "unchecked";
}
var Mp = Np, g1 = _p;
const Fp = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    Mp,
    {
      className: S(
        "peer inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        e
      ),
      ...t,
      ref: n,
      children: /* @__PURE__ */ p.jsx(
        g1,
        {
          className: S(
            "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
          )
        }
      )
    }
  )
);
Fp.displayName = Mp.displayName;
const qE = (e) => {
  const { label: t, enabled: n, disabled: o = !1, onChange: r, className: a = "", switchClassName: i = "", labelClassName: s = "" } = e;
  return /* @__PURE__ */ p.jsxs("div", { className: S(`flex items-center justify-between ${a}`), children: [
    t && /* @__PURE__ */ p.jsx(Tt, { htmlFor: "airplane-mode", className: S(`nyn-switch-label text-text leading-relaxed pr-3 ${s}`), children: t }),
    /* @__PURE__ */ p.jsx(
      Fp,
      {
        id: "airplane-mode",
        checked: n,
        disabled: o,
        onCheckedChange: r,
        className: S(
          `nyn-switch data-[state=checked]:border-primary data-[state=unchecked]:border-border data-[state=checked]:bg-primary data-[state=unchecked]:bg-border ${i}`
        )
      }
    )
  ] });
}, Op = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ p.jsx("table", { ref: n, className: S("w-full caption-bottom text-sm", e), ...t }) }));
Op.displayName = "Table";
const Gp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("thead", { ref: n, className: S("[&_tr]:border-b", e), ...t }));
Gp.displayName = "TableHeader";
const kp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("tbody", { ref: n, className: S("[&_tr:last-child]:border-0", e), ...t }));
kp.displayName = "TableBody";
const m1 = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("tfoot", { ref: n, className: S("bg-primary font-medium text-primary-foreground", e), ...t }));
m1.displayName = "TableFooter";
const va = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("tr", { ref: n, className: S("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", e), ...t }));
va.displayName = "TableRow";
const jp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "th",
  {
    ref: n,
    className: S("h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", e),
    ...t
  }
));
jp.displayName = "TableHead";
const Vp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("td", { ref: n, className: S("p-4 align-middle [&:has([role=checkbox])]:pr-0", e), ...t }));
Vp.displayName = "TableCell";
const Bp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx("caption", { ref: n, className: S("mt-4 text-sm text-muted-foreground", e), ...t }));
Bp.displayName = "TableCaption";
const eR = (e) => {
  const {
    columnDef: t,
    caption: n = "",
    data: o,
    className: r = "",
    captionClassName: a = "",
    headerClassName: i = "",
    headerRowClassName: s = "",
    headerCellClassName: c = "",
    bodyClassName: l = "",
    bodyRowClassName: u = "",
    bodyCellClassName: f = ""
  } = e;
  return /* @__PURE__ */ p.jsxs(Op, { className: S(`border border-border bg-card rounded ${r}`), children: [
    n && /* @__PURE__ */ p.jsx(Bp, { className: a, children: n }),
    /* @__PURE__ */ p.jsx(Gp, { className: S(`[&_tr]:border-0 border-border ${i}`), children: /* @__PURE__ */ p.jsx(va, { className: s, children: t.map((g, b) => /* @__PURE__ */ p.jsx(jp, { className: `px-3 py-3 h-auto border-b border-border ${c} ${g.className}`, children: g.title }, b)) }) }),
    /* @__PURE__ */ p.jsx(kp, { className: l, children: o.map((g, b) => /* @__PURE__ */ p.jsx(va, { className: S(`[&_tr]:border-0 border-border ${u}`), children: t.map((C, m) => {
      const v = C.component;
      return /* @__PURE__ */ p.jsx(Vp, { className: `px-3 py-3 border-b border-border ${f} ${C.className}`, children: C.component ? /* @__PURE__ */ p.jsx(v, { row: g, col: C, ...e }) : g[C.name] }, b + "" + m);
    }) }, b)) })
  ] });
};
var so = "Tabs", [b1, tR] = ye(so, [
  an
]), Lp = an(), [v1, Ei] = b1(so), Wp = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: c = "automatic",
      ...l
    } = e, u = Nn(s), [f, g] = Oe({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: so
    });
    return /* @__PURE__ */ p.jsx(
      v1,
      {
        scope: n,
        baseId: je(),
        value: f,
        onValueChange: g,
        orientation: i,
        dir: u,
        activationMode: c,
        children: /* @__PURE__ */ p.jsx(
          z.div,
          {
            dir: u,
            "data-orientation": i,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
Wp.displayName = so;
var Xp = "TabsList", Hp = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...r } = e, a = Ei(Xp, n), i = Lp(n);
    return /* @__PURE__ */ p.jsx(
      ri,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: o,
        children: /* @__PURE__ */ p.jsx(
          z.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...r,
            ref: t
          }
        )
      }
    );
  }
);
Hp.displayName = Xp;
var zp = "TabsTrigger", Zp = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: r = !1, ...a } = e, i = Ei(zp, n), s = Lp(n), c = Jp(i.baseId, o), l = Up(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ p.jsx(
      oi,
      {
        asChild: !0,
        ...s,
        focusable: !r,
        active: u,
        children: /* @__PURE__ */ p.jsx(
          z.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": l,
            "data-state": u ? "active" : "inactive",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            id: c,
            ...a,
            ref: t,
            onMouseDown: G(e.onMouseDown, (f) => {
              !r && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(o) : f.preventDefault();
            }),
            onKeyDown: G(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && i.onValueChange(o);
            }),
            onFocus: G(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !u && !r && f && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
Zp.displayName = zp;
var $p = "TabsContent", Yp = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: r, children: a, ...i } = e, s = Ei($p, n), c = Jp(s.baseId, o), l = Up(s.baseId, o), u = o === s.value, f = d.useRef(u);
    return d.useEffect(() => {
      const g = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(g);
    }, []), /* @__PURE__ */ p.jsx(Se, { present: r || u, children: ({ present: g }) => /* @__PURE__ */ p.jsx(
      z.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !g,
        id: l,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: g && a
      }
    ) });
  }
);
Yp.displayName = $p;
function Jp(e, t) {
  return `${e}-trigger-${t}`;
}
function Up(e, t) {
  return `${e}-content-${t}`;
}
var h1 = Wp, Qp = Hp, Kp = Zp, qp = Yp;
const x1 = h1, eg = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    Qp,
    {
      ref: n,
      className: S("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", e),
      ...t
    }
  )
);
eg.displayName = Qp.displayName;
const tg = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    Kp,
    {
      ref: n,
      className: S(
        "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
        e
      ),
      ...t
    }
  )
);
tg.displayName = Kp.displayName;
const ng = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    qp,
    {
      ref: n,
      className: S(
        "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        e
      ),
      ...t
    }
  )
);
ng.displayName = qp.displayName;
const nR = (e) => {
  const { isFull: t = !1, items: n, selected: o, children: r, className: a = "", itemClassName: i = "", activeItemClassName: s = "" } = e, c = (l) => o === l;
  return /* @__PURE__ */ p.jsxs(x1, { defaultValue: o, value: o, onValueChange: e.onChange, className: "w-full", children: [
    /* @__PURE__ */ p.jsx(
      eg,
      {
        className: S(
          `nyn-tabs bg-transparent border-0 border-b border-border  p-0 rounded-none ${t ? "grid grid-flow-col justify-stretch" : "flex flex-row justify-start"} ${a}`
        ),
        children: n.map((l) => /* @__PURE__ */ p.jsx(
          tg,
          {
            value: l,
            className: S(
              `h-full border-0 border-b-4 ${c(l) ? "text-primary border-primary " + s : "text-text border-transparent " + i}`
            ),
            children: l
          },
          l
        ))
      }
    ),
    r
  ] });
}, rR = (e) => {
  const { item: t, className: n = "" } = e;
  return /* @__PURE__ */ p.jsx(ng, { value: t, className: S(`nyn-tab-content ${n}`), children: e.children });
}, rg = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  "textarea",
  {
    className: S(
      "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ref: n,
    ...t
  }
));
rg.displayName = "Textarea";
const oR = (e) => {
  const {
    label: t = "",
    id: n = "textarea",
    placeholder: o = "",
    className: r = "",
    labelClassName: a = "",
    textareaClassName: i = "",
    value: s = "",
    onChange: c,
    ...l
  } = e;
  return /* @__PURE__ */ p.jsxs("div", { className: S(`nyn-textarea-block ${r}`), children: [
    t && /* @__PURE__ */ p.jsx(Tt, { htmlFor: n, className: S(`nyn-textarea-label block pb-2 text-text ${a}`), children: t }),
    /* @__PURE__ */ p.jsx(
      rg,
      {
        id: n,
        ...s && { value: s },
        ...o && { placeholder: o },
        ...c && { onChange: c },
        ...l,
        className: S(`nyn-textarea w-full rounded bg-card border border-border text-text px-3 py-2 ${i}`)
      }
    )
  ] });
};
var y1 = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), C1 = "VisuallyHidden", co = d.forwardRef(
  (e, t) => /* @__PURE__ */ p.jsx(
    z.span,
    {
      ...e,
      ref: t,
      style: { ...y1, ...e.style }
    }
  )
);
co.displayName = C1;
var I1 = co, Ri = "ToastProvider", [Si, w1, A1] = Or("Toast"), [og, aR] = ye("Toast", [A1]), [E1, lo] = og(Ri), ag = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: o = 5e3,
    swipeDirection: r = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, c] = d.useState(null), [l, u] = d.useState(0), f = d.useRef(!1), g = d.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Ri}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ p.jsx(Si.Provider, { scope: t, children: /* @__PURE__ */ p.jsx(
    E1,
    {
      scope: t,
      label: n,
      duration: o,
      swipeDirection: r,
      swipeThreshold: a,
      toastCount: l,
      viewport: s,
      onViewportChange: c,
      onToastAdd: d.useCallback(() => u((b) => b + 1), []),
      onToastRemove: d.useCallback(() => u((b) => b - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: g,
      children: i
    }
  ) });
};
ag.displayName = Ri;
var ig = "ToastViewport", R1 = ["F8"], ha = "toast.viewportPause", xa = "toast.viewportResume", sg = d.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: o = R1,
      label: r = "Notifications ({hotkey})",
      ...a
    } = e, i = lo(ig, n), s = w1(n), c = d.useRef(null), l = d.useRef(null), u = d.useRef(null), f = d.useRef(null), g = ne(t, f, i.onViewportChange), b = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), C = i.toastCount > 0;
    d.useEffect(() => {
      const v = (h) => {
        var x;
        o.length !== 0 && o.every((y) => h[y] || h.code === y) && ((x = f.current) == null || x.focus());
      };
      return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
    }, [o]), d.useEffect(() => {
      const v = c.current, h = f.current;
      if (C && v && h) {
        const I = () => {
          if (!i.isClosePausedRef.current) {
            const R = new CustomEvent(ha);
            h.dispatchEvent(R), i.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (i.isClosePausedRef.current) {
            const R = new CustomEvent(xa);
            h.dispatchEvent(R), i.isClosePausedRef.current = !1;
          }
        }, y = (R) => {
          !v.contains(R.relatedTarget) && x();
        }, w = () => {
          v.contains(document.activeElement) || x();
        };
        return v.addEventListener("focusin", I), v.addEventListener("focusout", y), v.addEventListener("pointermove", I), v.addEventListener("pointerleave", w), window.addEventListener("blur", I), window.addEventListener("focus", x), () => {
          v.removeEventListener("focusin", I), v.removeEventListener("focusout", y), v.removeEventListener("pointermove", I), v.removeEventListener("pointerleave", w), window.removeEventListener("blur", I), window.removeEventListener("focus", x);
        };
      }
    }, [C, i.isClosePausedRef]);
    const m = d.useCallback(
      ({ tabbingDirection: v }) => {
        const I = s().map((x) => {
          const y = x.ref.current, w = [y, ...V1(y)];
          return v === "forwards" ? w : w.reverse();
        });
        return (v === "forwards" ? I.reverse() : I).flat();
      },
      [s]
    );
    return d.useEffect(() => {
      const v = f.current;
      if (v) {
        const h = (I) => {
          var w, R, E;
          const x = I.altKey || I.ctrlKey || I.metaKey;
          if (I.key === "Tab" && !x) {
            const N = document.activeElement, _ = I.shiftKey;
            if (I.target === v && _) {
              (w = l.current) == null || w.focus();
              return;
            }
            const T = m({ tabbingDirection: _ ? "backwards" : "forwards" }), L = T.findIndex((M) => M === N);
            Zo(T.slice(L + 1)) ? I.preventDefault() : _ ? (R = l.current) == null || R.focus() : (E = u.current) == null || E.focus();
          }
        };
        return v.addEventListener("keydown", h), () => v.removeEventListener("keydown", h);
      }
    }, [s, m]), /* @__PURE__ */ p.jsxs(
      tv,
      {
        ref: c,
        role: "region",
        "aria-label": r.replace("{hotkey}", b),
        tabIndex: -1,
        style: { pointerEvents: C ? void 0 : "none" },
        children: [
          C && /* @__PURE__ */ p.jsx(
            ya,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const v = m({
                  tabbingDirection: "forwards"
                });
                Zo(v);
              }
            }
          ),
          /* @__PURE__ */ p.jsx(Si.Slot, { scope: n, children: /* @__PURE__ */ p.jsx(z.ol, { tabIndex: -1, ...a, ref: g }) }),
          C && /* @__PURE__ */ p.jsx(
            ya,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const v = m({
                  tabbingDirection: "backwards"
                });
                Zo(v);
              }
            }
          )
        ]
      }
    );
  }
);
sg.displayName = ig;
var cg = "ToastFocusProxy", ya = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: o, ...r } = e, a = lo(cg, n);
    return /* @__PURE__ */ p.jsx(
      co,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...r,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var l;
          const s = i.relatedTarget;
          !((l = a.viewport) != null && l.contains(s)) && o();
        }
      }
    );
  }
);
ya.displayName = cg;
var Wn = "Toast", S1 = "toast.swipeStart", N1 = "toast.swipeMove", P1 = "toast.swipeCancel", _1 = "toast.swipeEnd", lg = d.forwardRef(
  (e, t) => {
    const { forceMount: n, open: o, defaultOpen: r, onOpenChange: a, ...i } = e, [s, c] = Oe({
      prop: o,
      defaultProp: r ?? !0,
      onChange: a,
      caller: Wn
    });
    return /* @__PURE__ */ p.jsx(Se, { present: n || s, children: /* @__PURE__ */ p.jsx(
      M1,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => c(!1),
        onPause: Me(e.onPause),
        onResume: Me(e.onResume),
        onSwipeStart: G(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: G(e.onSwipeMove, (l) => {
          const { x: u, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: G(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: G(e.onSwipeEnd, (l) => {
          const { x: u, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), c(!1);
        })
      }
    ) });
  }
);
lg.displayName = Wn;
var [T1, D1] = og(Wn, {
  onClose() {
  }
}), M1 = d.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: o = "foreground",
      duration: r,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: c,
      onResume: l,
      onSwipeStart: u,
      onSwipeMove: f,
      onSwipeCancel: g,
      onSwipeEnd: b,
      ...C
    } = e, m = lo(Wn, n), [v, h] = d.useState(null), I = ne(t, (M) => h(M)), x = d.useRef(null), y = d.useRef(null), w = r || m.duration, R = d.useRef(0), E = d.useRef(w), N = d.useRef(0), { onToastAdd: _, onToastRemove: D } = m, O = Me(() => {
      var B;
      (v == null ? void 0 : v.contains(document.activeElement)) && ((B = m.viewport) == null || B.focus()), i();
    }), T = d.useCallback(
      (M) => {
        !M || M === 1 / 0 || (window.clearTimeout(N.current), R.current = (/* @__PURE__ */ new Date()).getTime(), N.current = window.setTimeout(O, M));
      },
      [O]
    );
    d.useEffect(() => {
      const M = m.viewport;
      if (M) {
        const B = () => {
          T(E.current), l == null || l();
        }, k = () => {
          const $ = (/* @__PURE__ */ new Date()).getTime() - R.current;
          E.current = E.current - $, window.clearTimeout(N.current), c == null || c();
        };
        return M.addEventListener(ha, k), M.addEventListener(xa, B), () => {
          M.removeEventListener(ha, k), M.removeEventListener(xa, B);
        };
      }
    }, [m.viewport, w, c, l, T]), d.useEffect(() => {
      a && !m.isClosePausedRef.current && T(w);
    }, [a, w, m.isClosePausedRef, T]), d.useEffect(() => (_(), () => D()), [_, D]);
    const L = d.useMemo(() => v ? bg(v) : null, [v]);
    return m.viewport ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      L && /* @__PURE__ */ p.jsx(
        F1,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: L
        }
      ),
      /* @__PURE__ */ p.jsx(T1, { scope: n, onClose: O, children: wa.createPortal(
        /* @__PURE__ */ p.jsx(Si.ItemSlot, { scope: n, children: /* @__PURE__ */ p.jsx(
          ev,
          {
            asChild: !0,
            onEscapeKeyDown: G(s, () => {
              m.isFocusedToastEscapeKeyDownRef.current || O(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ p.jsx(
              z.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...C,
                ref: I,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: G(e.onKeyDown, (M) => {
                  M.key === "Escape" && (s == null || s(M.nativeEvent), M.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, O()));
                }),
                onPointerDown: G(e.onPointerDown, (M) => {
                  M.button === 0 && (x.current = { x: M.clientX, y: M.clientY });
                }),
                onPointerMove: G(e.onPointerMove, (M) => {
                  if (!x.current) return;
                  const B = M.clientX - x.current.x, k = M.clientY - x.current.y, $ = !!y.current, j = ["left", "right"].includes(m.swipeDirection), F = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, U = j ? F(0, B) : 0, re = j ? 0 : F(0, k), J = M.pointerType === "touch" ? 10 : 2, Q = { x: U, y: re }, ge = { originalEvent: M, delta: Q };
                  $ ? (y.current = Q, lr(N1, f, ge, {
                    discrete: !1
                  })) : mc(Q, m.swipeDirection, J) ? (y.current = Q, lr(S1, u, ge, {
                    discrete: !1
                  }), M.target.setPointerCapture(M.pointerId)) : (Math.abs(B) > J || Math.abs(k) > J) && (x.current = null);
                }),
                onPointerUp: G(e.onPointerUp, (M) => {
                  const B = y.current, k = M.target;
                  if (k.hasPointerCapture(M.pointerId) && k.releasePointerCapture(M.pointerId), y.current = null, x.current = null, B) {
                    const $ = M.currentTarget, j = { originalEvent: M, delta: B };
                    mc(B, m.swipeDirection, m.swipeThreshold) ? lr(_1, b, j, {
                      discrete: !0
                    }) : lr(
                      P1,
                      g,
                      j,
                      {
                        discrete: !0
                      }
                    ), $.addEventListener("click", (F) => F.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), F1 = (e) => {
  const { __scopeToast: t, children: n, ...o } = e, r = lo(Wn, t), [a, i] = d.useState(!1), [s, c] = d.useState(!1);
  return k1(() => i(!0)), d.useEffect(() => {
    const l = window.setTimeout(() => c(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ p.jsx(Pn, { asChild: !0, children: /* @__PURE__ */ p.jsx(co, { ...o, children: a && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    r.label,
    " ",
    n
  ] }) }) });
}, O1 = "ToastTitle", ug = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e;
    return /* @__PURE__ */ p.jsx(z.div, { ...o, ref: t });
  }
);
ug.displayName = O1;
var G1 = "ToastDescription", dg = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e;
    return /* @__PURE__ */ p.jsx(z.div, { ...o, ref: t });
  }
);
dg.displayName = G1;
var fg = "ToastAction", pg = d.forwardRef(
  (e, t) => {
    const { altText: n, ...o } = e;
    return n.trim() ? /* @__PURE__ */ p.jsx(mg, { altText: n, asChild: !0, children: /* @__PURE__ */ p.jsx(Ni, { ...o, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${fg}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
pg.displayName = fg;
var gg = "ToastClose", Ni = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...o } = e, r = D1(gg, n);
    return /* @__PURE__ */ p.jsx(mg, { asChild: !0, children: /* @__PURE__ */ p.jsx(
      z.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: G(e.onClick, r.onClose)
      }
    ) });
  }
);
Ni.displayName = gg;
var mg = d.forwardRef((e, t) => {
  const { __scopeToast: n, altText: o, ...r } = e;
  return /* @__PURE__ */ p.jsx(
    z.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...r,
      ref: t
    }
  );
});
function bg(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((o) => {
    if (o.nodeType === o.TEXT_NODE && o.textContent && t.push(o.textContent), j1(o)) {
      const r = o.ariaHidden || o.hidden || o.style.display === "none", a = o.dataset.radixToastAnnounceExclude === "";
      if (!r)
        if (a) {
          const i = o.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...bg(o));
    }
  }), t;
}
function lr(e, t, n, { discrete: o }) {
  const r = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? Aa(r, a) : r.dispatchEvent(a);
}
var mc = (e, t, n = 0) => {
  const o = Math.abs(e.x), r = Math.abs(e.y), a = o > r;
  return t === "left" || t === "right" ? a && o > n : !a && r > n;
};
function k1(e = () => {
}) {
  const t = Me(e);
  rt(() => {
    let n = 0, o = 0;
    return n = window.requestAnimationFrame(() => o = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(o);
    };
  }, [t]);
}
function j1(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function V1(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Zo(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var B1 = ag, vg = sg, hg = lg, xg = ug, yg = dg, Cg = pg, Ig = Ni;
const L1 = B1, wg = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
  vg,
  {
    ref: n,
    className: S(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
wg.displayName = vg.displayName;
const W1 = en(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Ag = d.forwardRef(({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ p.jsx(hg, { ref: o, className: S(W1({ variant: t }), e), ...n }));
Ag.displayName = hg.displayName;
const X1 = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    Cg,
    {
      ref: n,
      className: S(
        "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
        e
      ),
      ...t
    }
  )
);
X1.displayName = Cg.displayName;
const Eg = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(
    Ig,
    {
      ref: n,
      className: S(
        "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
        e
      ),
      "toast-close": "",
      ...t,
      children: /* @__PURE__ */ p.jsx(Vr, { className: "h-4 w-4" })
    }
  )
);
Eg.displayName = Ig.displayName;
const Rg = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(xg, { ref: n, className: S("text-sm font-semibold", e), ...t })
);
Rg.displayName = xg.displayName;
const Sg = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p.jsx(yg, { ref: n, className: S("text-sm opacity-90", e), ...t }));
Sg.displayName = yg.displayName;
const H1 = 1, z1 = 1e6;
let $o = 0;
function Z1() {
  return $o = ($o + 1) % Number.MAX_VALUE, $o.toString();
}
const Yo = /* @__PURE__ */ new Map(), bc = (e) => {
  if (Yo.has(e))
    return;
  const t = setTimeout(() => {
    Yo.delete(e), vn({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, z1);
  Yo.set(e, t);
}, $1 = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, H1)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? bc(n) : e.toasts.forEach((o) => {
        bc(o.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (o) => o.id === n || n === void 0 ? {
            ...o,
            open: !1
          } : o
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, vr = [];
let hr = { toasts: [] };
function vn(e) {
  hr = $1(hr, e), vr.forEach((t) => {
    t(hr);
  });
}
function Y1({ ...e }) {
  const t = Z1(), n = (r) => vn({
    type: "UPDATE_TOAST",
    toast: { ...r, id: t }
  }), o = () => vn({ type: "DISMISS_TOAST", toastId: t });
  return vn({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (r) => {
        r || o();
      }
    }
  }), {
    id: t,
    dismiss: o,
    update: n
  };
}
function Ng() {
  const [e, t] = d.useState(hr);
  return d.useEffect(() => (vr.push(t), () => {
    const n = vr.indexOf(t);
    n > -1 && vr.splice(n, 1);
  }), [e]), {
    ...e,
    toast: Y1,
    dismiss: (n) => vn({ type: "DISMISS_TOAST", toastId: n })
  };
}
function J1() {
  const { toasts: e } = Ng();
  return /* @__PURE__ */ p.jsxs(L1, { children: [
    e.map(function({ id: t, title: n, description: o, action: r, ...a }) {
      return /* @__PURE__ */ p.jsxs(Ag, { ...a, className: "text-text bg-card border border-border shadow-lg p-3", children: [
        /* @__PURE__ */ p.jsxs("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ p.jsx(Rg, { children: n }),
          o && /* @__PURE__ */ p.jsx(Sg, { children: o })
        ] }),
        r,
        /* @__PURE__ */ p.jsx(Eg, {})
      ] }, t);
    }),
    /* @__PURE__ */ p.jsx(wg, {})
  ] });
}
var [uo, iR] = ye("Tooltip", [
  on
]), fo = on(), Pg = "TooltipProvider", U1 = 700, Ca = "tooltip.open", [Q1, Pi] = uo(Pg), _g = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = U1,
    skipDelayDuration: o = 300,
    disableHoverableContent: r = !1,
    children: a
  } = e, i = d.useRef(!0), s = d.useRef(!1), c = d.useRef(0);
  return d.useEffect(() => {
    const l = c.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ p.jsx(
    Q1,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(c.current), i.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => i.current = !0,
          o
        );
      }, [o]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: d.useCallback((l) => {
        s.current = l;
      }, []),
      disableHoverableContent: r,
      children: a
    }
  );
};
_g.displayName = Pg;
var Rn = "Tooltip", [K1, po] = uo(Rn), Tg = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, c = Pi(Rn, e.__scopeTooltip), l = fo(t), [u, f] = d.useState(null), g = je(), b = d.useRef(0), C = i ?? c.disableHoverableContent, m = s ?? c.delayDuration, v = d.useRef(!1), [h, I] = Oe({
    prop: o,
    defaultProp: r ?? !1,
    onChange: (E) => {
      E ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Ca))) : c.onClose(), a == null || a(E);
    },
    caller: Rn
  }), x = d.useMemo(() => h ? v.current ? "delayed-open" : "instant-open" : "closed", [h]), y = d.useCallback(() => {
    window.clearTimeout(b.current), b.current = 0, v.current = !1, I(!0);
  }, [I]), w = d.useCallback(() => {
    window.clearTimeout(b.current), b.current = 0, I(!1);
  }, [I]), R = d.useCallback(() => {
    window.clearTimeout(b.current), b.current = window.setTimeout(() => {
      v.current = !0, I(!0), b.current = 0;
    }, m);
  }, [m, I]);
  return d.useEffect(() => () => {
    b.current && (window.clearTimeout(b.current), b.current = 0);
  }, []), /* @__PURE__ */ p.jsx(Ur, { ...l, children: /* @__PURE__ */ p.jsx(
    K1,
    {
      scope: t,
      contentId: g,
      open: h,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: f,
      onTriggerEnter: d.useCallback(() => {
        c.isOpenDelayedRef.current ? R() : y();
      }, [c.isOpenDelayedRef, R, y]),
      onTriggerLeave: d.useCallback(() => {
        C ? w() : (window.clearTimeout(b.current), b.current = 0);
      }, [w, C]),
      onOpen: y,
      onClose: w,
      disableHoverableContent: C,
      children: n
    }
  ) });
};
Tg.displayName = Rn;
var Ia = "TooltipTrigger", Dg = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, r = po(Ia, n), a = Pi(Ia, n), i = fo(n), s = d.useRef(null), c = ne(t, s, r.onTriggerChange), l = d.useRef(!1), u = d.useRef(!1), f = d.useCallback(() => l.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ p.jsx(Qr, { asChild: !0, ...i, children: /* @__PURE__ */ p.jsx(
      z.button,
      {
        "aria-describedby": r.open ? r.contentId : void 0,
        "data-state": r.stateAttribute,
        ...o,
        ref: c,
        onPointerMove: G(e.onPointerMove, (g) => {
          g.pointerType !== "touch" && !u.current && !a.isPointerInTransitRef.current && (r.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: G(e.onPointerLeave, () => {
          r.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: G(e.onPointerDown, () => {
          r.open && r.onClose(), l.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: G(e.onFocus, () => {
          l.current || r.onOpen();
        }),
        onBlur: G(e.onBlur, r.onClose),
        onClick: G(e.onClick, r.onClose)
      }
    ) });
  }
);
Dg.displayName = Ia;
var q1 = "TooltipPortal", [sR, eE] = uo(q1, {
  forceMount: void 0
}), qt = "TooltipContent", Mg = d.forwardRef(
  (e, t) => {
    const n = eE(qt, e.__scopeTooltip), { forceMount: o = n.forceMount, side: r = "top", ...a } = e, i = po(qt, e.__scopeTooltip);
    return /* @__PURE__ */ p.jsx(Se, { present: o || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ p.jsx(Fg, { side: r, ...a, ref: t }) : /* @__PURE__ */ p.jsx(tE, { side: r, ...a, ref: t }) });
  }
), tE = d.forwardRef((e, t) => {
  const n = po(qt, e.__scopeTooltip), o = Pi(qt, e.__scopeTooltip), r = d.useRef(null), a = ne(t, r), [i, s] = d.useState(null), { trigger: c, onClose: l } = n, u = r.current, { onPointerInTransitChange: f } = o, g = d.useCallback(() => {
    s(null), f(!1);
  }, [f]), b = d.useCallback(
    (C, m) => {
      const v = C.currentTarget, h = { x: C.clientX, y: C.clientY }, I = iE(h, v.getBoundingClientRect()), x = sE(h, I), y = cE(m.getBoundingClientRect()), w = uE([...x, ...y]);
      s(w), f(!0);
    },
    [f]
  );
  return d.useEffect(() => () => g(), [g]), d.useEffect(() => {
    if (c && u) {
      const C = (v) => b(v, u), m = (v) => b(v, c);
      return c.addEventListener("pointerleave", C), u.addEventListener("pointerleave", m), () => {
        c.removeEventListener("pointerleave", C), u.removeEventListener("pointerleave", m);
      };
    }
  }, [c, u, b, g]), d.useEffect(() => {
    if (i) {
      const C = (m) => {
        const v = m.target, h = { x: m.clientX, y: m.clientY }, I = (c == null ? void 0 : c.contains(v)) || (u == null ? void 0 : u.contains(v)), x = !lE(h, i);
        I ? g() : x && (g(), l());
      };
      return document.addEventListener("pointermove", C), () => document.removeEventListener("pointermove", C);
    }
  }, [c, u, i, l, g]), /* @__PURE__ */ p.jsx(Fg, { ...e, ref: a });
}), [nE, rE] = uo(Rn, { isInside: !1 }), oE = /* @__PURE__ */ Cc("TooltipContent"), Fg = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: o,
      "aria-label": r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, c = po(qt, n), l = fo(n), { onClose: u } = c;
    return d.useEffect(() => (document.addEventListener(Ca, u), () => document.removeEventListener(Ca, u)), [u]), d.useEffect(() => {
      if (c.trigger) {
        const f = (g) => {
          const b = g.target;
          b != null && b.contains(c.trigger) && u();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, u]), /* @__PURE__ */ p.jsx(
      tn,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ p.jsxs(
          ti,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ p.jsx(oE, { children: o }),
              /* @__PURE__ */ p.jsx(nE, { scope: n, isInside: !0, children: /* @__PURE__ */ p.jsx(I1, { id: c.contentId, role: "tooltip", children: r || o }) })
            ]
          }
        )
      }
    );
  }
);
Mg.displayName = qt;
var Og = "TooltipArrow", aE = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, r = fo(n);
    return rE(
      Og,
      n
    ).isInside ? null : /* @__PURE__ */ p.jsx(ni, { ...r, ...o, ref: t });
  }
);
aE.displayName = Og;
function iE(e, t) {
  const n = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, o, r, a)) {
    case a:
      return "left";
    case r:
      return "right";
    case n:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function sE(e, t, n = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      o.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return o;
}
function cE(e) {
  const { top: t, right: n, bottom: o, left: r } = e;
  return [
    { x: r, y: t },
    { x: n, y: t },
    { x: n, y: o },
    { x: r, y: o }
  ];
}
function lE(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], c = t[i], l = s.x, u = s.y, f = c.x, g = c.y;
    u > o != g > o && n < (f - l) * (o - u) / (g - u) + l && (r = !r);
  }
  return r;
}
function uE(e) {
  const t = e.slice();
  return t.sort((n, o) => n.x < o.x ? -1 : n.x > o.x ? 1 : n.y < o.y ? -1 : n.y > o.y ? 1 : 0), dE(t);
}
function dE(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (r.y - i.y) >= (a.y - i.y) * (r.x - i.x)) t.pop();
      else break;
    }
    t.push(r);
  }
  t.pop();
  const n = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const r = e[o];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (r.y - i.y) >= (a.y - i.y) * (r.x - i.x)) n.pop();
      else break;
    }
    n.push(r);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var fE = _g, pE = Tg, gE = Dg, Gg = Mg;
const mE = fE, bE = pE, vE = gE, kg = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, o) => /* @__PURE__ */ p.jsx(
  Gg,
  {
    ref: o,
    sideOffset: t,
    className: S(
      "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
kg.displayName = Gg.displayName;
const cR = (e) => {
  const { children: t, theme: n } = e, [o, r] = sx("THEME", "");
  return hn(() => {
    const a = window.matchMedia("(prefers-color-scheme: dark)").matches, i = !n && !a ? ea.LIGHT : n || ea.DARK;
    r(i), window.document.documentElement.style.colorScheme = i, document.documentElement.setAttribute("data-theme", i);
  }, [n]), /* @__PURE__ */ p.jsxs(mE, { children: [
    /* @__PURE__ */ p.jsx("main", { children: t }),
    /* @__PURE__ */ p.jsx(J1, {})
  ] });
}, lR = () => {
  const { toast: e } = Ng();
  return (t, n = "") => {
    e(Object.assign({ description: t }, n && { title: n }));
  };
}, uR = (e) => {
  const { message: t, className: n = "", triggerClassName: o = "", children: r } = e;
  return /* @__PURE__ */ p.jsxs(bE, { children: [
    /* @__PURE__ */ p.jsx(vE, { className: o, children: r }),
    /* @__PURE__ */ p.jsx(kg, { className: S(`nyn-tooltip text-text border border-border rounded bg-card p-2 max-w-xs ${n}`), children: t })
  ] });
};
export {
  el as AccordionTypes,
  Re as AlertTypes,
  Vt as BadgeSize,
  Bt as ButtonSize,
  Lt as DialogSize,
  Wt as MenuSize,
  IE as NAccordion,
  wE as NAlert,
  AE as NBadge,
  EE as NButton,
  RE as NButtonGroup,
  SE as NCard,
  PE as NCheck,
  TE as NConfirmAlert,
  DE as NDialog,
  yu as NDivider,
  OE as NFormInput,
  ME as NInfiniteScroll,
  FE as NInput,
  GE as NLink,
  kE as NLinkify,
  jE as NLoading,
  BE as NMenu,
  WE as NMenuItem,
  LE as NMenuNested,
  HE as NPopover,
  ZE as NProgress,
  YE as NRadioGroup,
  JE as NSelect,
  UE as NSheet,
  QE as NSkeleton,
  qE as NSwitch,
  eR as NTable,
  nR as NTabs,
  rR as NTabsContent,
  oR as NTextarea,
  cR as NTheme,
  uR as NTooltip,
  Xt as PopoverSize,
  Ht as SheetSize,
  qc as Size,
  ea as THEMES,
  S as cn,
  of as menuSizeMapping,
  sx as useLocalStorage,
  lR as useToast
};
//# sourceMappingURL=index.es.js.map
